<template>
  <!-- 点検実施 -->
  <div id="AppInspectionExecute">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <div class="box" style="width: 100%;">
      <div class="columns">
        <div class="column">
          <label class="searchTitle label">点検入力</label>
        </div>
      </div>
      <!-- 操作エリア -->
      <div class="columns">
        <div class="column">
          <div style="float: right;">
            <b-button
              v-if="$route.params.isBulk"
              class="button is-primary has-text-centered"
              icon-left="select-off"
              native-type="button"
              v-on:click="cancel()"
            >取り消し</b-button>
            <b-button
              class="button is-primary has-text-centered"
              icon-left="folder-remove"
              native-type="button"
              v-on:click="expendablesOrder"
            >{{ cancelButtonName }}</b-button>
            <b-button
              class="button is-primary has-text-centered"
              icon-left="folder-upload"
              native-type="button"
              v-on:click="inputSign()"
            >{{ completeButtonName }}</b-button>
            <b-modal :active.sync="isComponentModalActive" has-modal-card full-screen>
              <sign-modal
                ref="signModal"
                v-bind:signatureFlag="signatureFlag"
                v-bind:signData="signData"
                v-bind:alternative="alternative"
                v-bind:alternativeReason="alternativeReason"
                v-bind:isBulk="$route.params.isBulk"
                v-bind:isDealer="$route.params.isDealer"
              ></sign-modal>
            </b-modal>
            <b-modal :active.sync="EvoWarningflag" has-modal-card full-screen>
              <form action="">
                <div class="modal-card" style="width: 100%;min-height: 100vh;">
                  <header class="modal-card-head">
                    <p class="modal-card-title" style="color: whitesmoke;">主設定変更確認</p>
                  </header>
                  <section class="modal-card-body">
                    <p style="font-size:60px;color: red;margin-top:13%;">器械は点検開始時と同じ設定で終了していますか?<br>（処方変更の場合を除く）</p>
                  </section>
                  <footer class="modal-card-foot">
                    <button class="button" style='width:10%; margin: 0 auto;' type="button" @click="EvoWarningflag = false,isComponentModalActive = true">OK</button>
                  </footer>
                </div>
              </form>
            </b-modal>
          </div>
        </div>
      </div>
      <!-- 点検実施タブ -->
      <div style="width: 100%;">
        <section :data="data">
          <b-tabs type="is-boxed">
            <b-tab-item
              v-for="(inspectionItem,subscript) in data"
              v-bind:key="subscript"
              style="font-size: 0.8rem !important;"
            >
              <template slot="header">
                <div style="display: inline-block;">
                  <template v-if="checkNotOther(inspectionItem)">
                    <span
                      v-if="inspectionItem.machineReplaceSerialNumber!=''"
                    >{{ inspectionItem.machineReplaceProductCode|productFilter(productMaster) }}</span>
                    <span v-else>{{ inspectionItem.productName }}</span>
                    <br />
                    <span
                      v-if="inspectionItem.machineReplaceSerialNumber!=''"
                    >({{inspectionItem.machineReplaceSerialNumber}})</span>
                    <span v-else>({{inspectionItem.serialNumber}})</span>
                  </template>
                  <template v-else>
                    <span>点検外作業</span>
                    <br />
                    <span>&nbsp;</span>
                  </template>
                </div>
              </template>
              <div style="height:10px;"></div>
              <!--機器ごとの点検内容-->
              <template v-if="checkNotOther(inspectionItem)">
                <div style="detailArea">
                  <div
                    v-if="inspectionItem.machineReplace == '有り'"
                    class="subtitle is-5"
                    style="color: red; text-align: left;"
                  >器械交換が必要な点検です。</div>
                  <div
                    v-if="inspectionItem.machineReplace == '有'"
                    class="subtitle is-5"
                    style="color: red; text-align: left;"
                  >器械交換が必要な点検です</div>
                  <div>
                    <!-- 患者情報 -->
                    <table class="table" style="table-layout:fixed">
                      <tr style="font-size: 16px;">
                        <td style="width: 30%;">患者コード</td>
                        <td>{{ inspectionItem.patientCode }}</td>
                      </tr>
                      <tr style="font-size: 16px;">
                        <td>患者名</td>
                        <td>{{ inspectionItem.patientName }}</td>
                      </tr>
                      <tr style="font-size: 16px;">
                        <td>医療機関</td>
                        <td>
                          {{ inspectionItem.hospitalName }}
                          <b-button
                            class="button is-primary has-text-centered"
                            icon-left="truck"
                            native-type="button"
                            style="float: right;;margin-right:5px;"
                            v-on:click="regulardisposablesOrder(inspectionItem.patientCode,inspectionItem.patientName,inspectionItem.regularDisposablesProduct,inspectionItem.CTERM,subscript)"
                          >消耗品発送登録</b-button>
                        </td>
                      </tr>
                      <tr style="font-size: 16px;">
                        <td>診療科</td>
                        <text-items v-bind:itemName="inspectionItem.department" ref="department"></text-items>
                      </tr>
                      <tr style="font-size: 16px;">
                        <td>担当医</td>
                        <text-items v-bind:itemName="inspectionItem.doctorName" ref="doctorName"></text-items>
                      </tr>
                      <tr style="font-size: 16px;">
                        <td>器械交換有無</td>
                        <td>{{ inspectionItem.machineReplace }}{{ machineReplaceDate(inspectionItem.LTDAT,inspectionItem.nextMaintenanceDate) }}</td>
                      </tr>
                      <tr style="font-size: 16px;">
                        <td>品目名</td>
                        <td>
                          <span
                            v-if="inspectionItem.machineReplaceSerialNumber!=''"
                          >{{ inspectionItem.machineReplaceProductCode|productFilter(productMaster) }}</span>
                          <span v-else>{{ inspectionItem.productCode|productFilter(productMaster)}}</span>
                        </td>
                      </tr>
                      <tr style="font-size: 16px;">
                        <td>シリアル</td>
                        <td>
                          <span v-if="inspectionItem.machineReplaceSerialNumber !== ''">
                            {{ inspectionItem.serialNumber }} ⇒ {{ inspectionItem.machineReplaceSerialNumber }}
                            <div>
                              <b-button
                                class="button is-primary has-text-centered"
                                icon-left="repeat-off"
                                native-type="button"
                                style="float: right;"
                                v-on:click="clearSerial(inspectionItem.serialNumber,subscript)"
                              >機器交換キャンセル</b-button>
                            </div>
                          </span>
                          <span v-else>
                            {{ inspectionItem.serialNumber }}
                            <b-button
                              class="button is-primary has-text-centered"
                              icon-left="repeat"
                              native-type="button"
                              id="machineReplaceButton"
                              style="float: right;"
                              v-on:click="serialReader(inspectionItem.serialNumber, inspectionItem.productCode,subscript)"
                            >機器交換</b-button>
                            <b-modal
                              :active.sync="isSerialReaderModalActive"
                              has-modal-card
                              full-screen
                              @close="closeModal"
                            >
                              <reader-modal
                                v-on:child-event="childFunction"
                                v-bind:oldSerialNumber="inspectionItem.serialNumber"
                                v-bind:productNumber="inspectionItem.productCode"
                                v-bind:originalData="initData"
                              ></reader-modal>
                            </b-modal>
                          </span>
                        </td>
                      </tr>
                      <tr style="font-size: 16px;">
                        <td>前回点検から医師処方値の変更があったか</td>
                        <td>{{ inspectionItem.modifiedDoctorDirection | directionFilter }}</td>
                      </tr>
                      <tr style="font-size: 16px;">
                        <td>処方値変更理由</td>
                        <td>
                          <table>
                            <thead style="border-bottom: 3px double lightgray">
                              <tr>
                                <td style="font-size: 16px;width:16%;">変更日時</td>
                                <td style="font-size: 16px;width:15%;">更新者</td>
                                <td style="font-size: 16px;width:10%;">変更種別</td>
                                <td style="font-size: 16px;width:15%;">変更項目</td>
                                <td style="font-size: 16px;width:10%;">変更前</td>
                                <td style="font-size: 16px;width:10%;">変更後</td>
                                <td style="font-size: 16px;width:24%;">変更理由
                                  <b-button
                                    class="button is-primary has-text-centered"
                                    native-type="button"
                                    style="float: right;left:14px;"
                                    icon-left="history"
                                    v-on:click="openModal(subscript)"
                                  >処方値変更履歴</b-button>
                                </td>
                            </tr>
                            </thead>
                            <tbody>
                              <tr v-if="lastPreEditHistory[subscript]">
                                <td style="font-size: 16px;">{{ lastPreEditHistory[subscript].updatedDay }}</td>
                                <td style="font-size: 16px;word-break:break-all;">{{ lastPreEditHistory[subscript].staffName }}</td>
                                <td style="font-size: 16px;word-break:break-all;">{{ lastPreEditHistory[subscript].type }}</td>
                                <td style="font-size: 16px;word-break:break-all;">{{ lastPreEditHistory[subscript].displayName }}</td>
                                <td style="font-size: 16px;word-break:break-all;">{{ lastPreEditHistory[subscript].beforeValue }}</td>
                                <td style="font-size: 16px;word-break:break-all;">{{ lastPreEditHistory[subscript].afterValue }}</td>
                                <td style="font-size: 16px;word-break:break-all;">{{ lastPreEditHistory[subscript].doctorChangeReason }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr style="font-size: 16px;">
                        <td>前回作業指示</td>
                        <td style="word-wrap:break-word;">{{ inspectionItem.lastDirection }}</td>
                      </tr>
                      <tr style="font-size: 16px;">
                        <td>予約時指示</td>
                        <td style="word-wrap:break-word;">{{ inspectionItem.appointmentMemo }}</td>
                      </tr>
                      <tr style="font-size: 16px;">
                        <td :style="$route.params.isDealer ? 'color: red;' : ''">点検実施日</td>
                        <td v-if="!$route.params.isDealer">
                          <span>{{formatDate2(inspectionDate)}}</span>
                        </td>
                        <td v-else>
                          <b-datepicker
                            name="inspectionDate"
                            placeholder="点検実施日"
                            icon="calendar-today"
                            :month-names= monthNames
                            :day-names= dayNames    
                            v-model="inspectionDate" 
                            ref="inspectionDate"             
                          >
                            <button
                              class="button is-danger"
                              @click="(inspectionDate = null)"
                            >
                              <b-icon icon="close"></b-icon>
                              <span>Clear</span>
                            </button>
                          </b-datepicker>
                        </td>
                      </tr>
                      <tr style="font-size: 16px;">
                        <td>点検期間</td>
                        <inspection-span-items
                          v-bind:inspection-span="inspectionItem.CTERM"
                          v-bind:subscript="subscript"
                          ref="inspectionSpan"
                        ></inspection-span-items>
                      </tr>
                      <tr style="font-size: 16px;">
                        <td>次回点検月</td>
                        <td><span v-if="inspectionDate">{{getNextInspection(inspectionItem,true)}}</span></td>
                      </tr>
                      <tr style="font-size: 16px;">
                        <td>点検指示内容</td>
                        <td>
                          <b-select expanded v-model="inspectionItem.inspectionOrder">
                            <option
                              v-for="inspection in inspectionOrderList"
                              :value="inspection.key"
                              :key="inspection.key"
                            >{{ inspection.value }}</option>
                          </b-select>
                        </td>
                      </tr>
                      <tr v-if="$route.params.isDealer" style="font-size: 16px;">
                        <td style="color: red;">委託担当者</td>
                        <text-items v-bind:trustStaff="trustStaff" ref="trustStaff"></text-items>
                      </tr>
                      <tr style="font-size: 16px;" v-if="inspectionItem.machineType == 8">
                        <td style="border-bottom: solid 1px;">療法（呼吸のみ）</td>
                        <td style="border-bottom: solid 1px;">
                          <b-field
                            :type="{'is-danger':errors.has('therapy')}"
                            :message="errors.first('therapy')"
                          >
                            <b-select
                              v-model="inspectionItem.therapy"
                              name="therapy"
                              data-vv-as="療法（呼吸のみ）"
                              expanded
                            >
                              <option value="NPPV">NPPV</option>
                              <option value="TPPV">TPPV</option>
                              <option value="HFT">HFT</option>
                              <option value="NPPV/HFT">NPPV/HFT</option>
                              <option value="TPPV/HFT">TPPV/HFT</option>
                            </b-select>
                          </b-field>
                        </td>
                      </tr>
                      <tr style="font-size: 16px;">
                        <td v-if="inspectionItem.machineType == 5" colspan="2">
                          <span v-if="inspectionItem.version != 0">
                            <b-checkbox
                              v-model="inspectionItem.subContentsValue"
                              v-on:input="subContentsChecked(subscript,2)"
                              native-value="2"
                            />副設定有り
                          </span>
                          <span v-else-if="inspectionItem.version == 0">
                            <b-checkbox :disabled="true" value="true" />副設定有り
                            <br />※旧バージョンの点検中断データの為、選択不可
                          </span>
                        </td>
                        <td v-else-if="inspectionItem.machineType == 4" colspan="2">
                          <span v-if="inspectionItem.version != 0">
                            <b-checkbox
                              v-model="inspectionItem.subContentsValue"
                              v-on:input="subContentsChecked(subscript,2)"
                              native-value="2"
                            />プリセット2有り
                            <br />
                            <b-checkbox
                              v-model="inspectionItem.subContentsValue"
                              v-on:input="subContentsChecked(subscript,3)"
                              native-value="3"
                            />プリセット3有り
                          </span>
                          <span v-else-if="inspectionItem.version == 0">
                            <b-checkbox :disabled="true" value="true" />プリセット2有り
                            <br />
                            <b-checkbox :disabled="true" value="true" />プリセット3有り
                            <br />※旧バージョンの点検中断データの為、選択不可
                          </span>
                        </td>
                        <td v-else-if="inspectionItem.machineType == 7" colspan="2">
                          <b-checkbox
                            v-for="setting in trilogyEvoSetting"
                            :key="setting.code"
                            :native-value="setting.stContentsType"
                            v-model="inspectionItem.subContentsValue"
                            v-on:input="subContentsChecked(subscript, setting.contentsType)"
                            :style="setting.contentsType >= 3 ? 'margin-left:15px;' : ''"
                          >
                            {{ setting.name }}{{ subSettingName(subscript, setting.contentsType) }}
                          </b-checkbox>
                        </td>
                        <td v-else-if="inspectionItem.machineType == 11" colspan="2">
                            <b-checkbox
                              v-model="inspectionItem.subContentsValue"
                              v-on:input="subContentsChecked(subscript,2)"
                              native-value="2"
                            />プリセット2有り
                            <b-checkbox
                              v-model="inspectionItem.subContentsValue"
                              v-on:input="subContentsChecked(subscript,3)"
                              native-value="3"
                            />プリセット3有り
                        </td>
                        <td v-else-if="inspectionItem.machineType == 8" colspan="2">
                          <b-checkbox
                            v-model="inspectionItem.subContentsValue"
                            v-on:input="subContentsChecked(subscript,2)"
                            native-value="2"
                          />prog2有り
                          <b-checkbox
                            style=" margin-left:15px;"
                            v-model="inspectionItem.subContentsValue"
                            v-on:input="subContentsChecked(subscript,3)"
                            native-value="3"
                          />prog3有り
                        </td>
                        <td v-else-if="inspectionItem.machineType == 12" colspan="2">
                          <b-checkbox
                            v-model="inspectionItem.subContentsValue"
                            v-on:input="subContentsChecked(subscript,2)"
                            native-value="2"
                          />プログラム1設定有り
                          <b-checkbox
                            style=" margin-left:15px;"
                            v-model="inspectionItem.subContentsValue"
                            v-on:input="subContentsChecked(subscript,3)"
                            native-value="3"
                          />プログラム2設定有り
                          <b-checkbox
                            style=" margin-left:15px;"
                            v-model="inspectionItem.subContentsValue"
                            v-on:input="subContentsChecked(subscript,4)"
                            native-value="4"
                          />プログラム3設定有り
                          <b-checkbox
                            style=" margin-left:15px;"
                            v-model="inspectionItem.subContentsValue"
                            v-on:input="subContentsChecked(subscript,5)"
                            native-value="5"
                          />プログラム4設定有り
                        </td>
                        <td v-else-if="inspectionItem.machineType == 17" colspan="2">
                          <b-checkbox
                            v-model="inspectionItem.subContentsValue"
                            v-on:input="subContentsChecked(subscript,2)"
                            native-value="2"
                          />プロファイル1設定有り
                          <b-checkbox
                            style=" margin-left:20px;"
                            v-model="inspectionItem.subContentsValue"
                            v-on:input="subContentsChecked(subscript,3)"
                            native-value="3"
                          />プロファイル2設定有り
                          <b-checkbox
                            style=" margin-left:20px;"
                            v-model="inspectionItem.subContentsValue"
                            v-on:input="subContentsChecked(subscript,4)"
                            native-value="4"
                          />プロファイル3設定有り
                          <b-checkbox
                            style=" margin-left:20px;"
                            v-model="inspectionItem.subContentsValue"
                            v-on:input="subContentsChecked(subscript,5)"
                            native-value="5"
                          />プロファイル4設定有り
                        </td>
                      </tr>
                      <template v-if="inspectionItem.machineType == 7">
                        <tr style="font-size: 18px;">
                          <td colspan="2">
                            <b-button
                              v-for="setting in trilogyEvoSetting"
                              :key="setting.code"
                              class="button is-primary has-text-centered"
                              icon-left="folder-upload"
                              native-type="button"
                              style="position: relative; margin-right: 20px;"
                              v-on:click="subContentsInspection(subscript, setting.contentsType)"
                            >
                              {{ setting.name }}{{ subSettingName(subscript, setting.contentsType) }}
                            </b-button>
                            <b-modal
                              :active.sync="isSubContentsModalActive"
                              has-modal-card
                              full-screen
                            >
                              <sub-inspection-modal
                                v-on:set-sub-data="setSubData"
                                v-on:sub-setting-name="subSettingName"
                                v-bind:inspection-item="inspectionItem"
                                v-bind:checkList="checkList"
                                v-bind:subscript="subscript"
                                v-bind:product-master="productMaster"
                                v-bind:targetContentsType="targetContentsType"
                                v-bind:mainSetting="getMainSettingTrilogyEvo(inspectionItem.mainSetting, targetContentsType)"
                              ></sub-inspection-modal>
                            </b-modal>
                          </td>
                        </tr>
                        <tr style="font-size: 16px;">
                          <td>メイン設定</td>
                          <td>
                            <b-select expanded v-model="inspectionItem.mainSetting">
                              <option
                                v-for="setting in trilogyEvoMainSetting"
                                :key="setting.code"
                                :value="setting.code"
                              >
                                {{ setting.name }}
                              </option>
                            </b-select>
                          </td>
                        </tr>
                      </template>
                      <tr v-else-if="inspectionItem.machineType == 8" style="font-size: 18px;">
                        <td colspan="2">
                          <b-button
                            class="button is-primary has-text-centered"
                            icon-left="folder-upload"
                            native-type="button"
                            style="position: relative; margin-right:20px;"
                            v-on:click="subContentsInspection(subscript, 2)"
                          >prog2</b-button>
                          <b-button
                            class="button is-primary has-text-centered"
                            icon-left="folder-upload"
                            native-type="button"
                            style="position: relative; margin-right:20px;"
                            v-on:click="subContentsInspection(subscript, 3)"
                          >prog3</b-button>

                          <b-modal
                            :active.sync="isSubContentsModalActive"
                            has-modal-card
                            full-screen
                          >
                            <sub-inspection-modal
                              v-on:set-sub-data="setSubData"
                              v-bind:inspection-item="inspectionItem"
                              v-bind:checkList="checkList"
                              v-bind:subscript="subscript"
                              v-bind:product-master="productMaster"
                              v-bind:targetContentsType="targetContentsType"
                            ></sub-inspection-modal>
                          </b-modal>
                        </td>
                      </tr>
                      <tr v-if="inspectionItem.machineType == 11" style="font-size: 18px;">
                        <td colspan="2">
                          <b-button
                            class="button is-primary has-text-centered"
                            icon-left="folder-upload"
                            native-type="button"
                            style="position: relative; margin-right:20px;"
                            v-on:click="subContentsInspection(subscript, 2)"
                          >プリセット2点検</b-button>
                          <b-button
                            class="button is-primary has-text-centered"
                            icon-left="folder-upload"
                            native-type="button"
                            style="position: relative; margin-right:20px;"
                            v-on:click="subContentsInspection(subscript, 3)"
                          >プリセット3点検</b-button>
                          <b-modal
                            :active.sync="isSubContentsModalActive"
                            has-modal-card
                            full-screen
                          >
                            <sub-inspection-modal
                              v-on:set-sub-data="setSubData"
                              v-bind:inspection-item="inspectionItem"
                              v-bind:checkList="checkList"
                              v-bind:subscript="subscript"
                              v-bind:product-master="productMaster"
                              v-bind:targetContentsType="targetContentsType"
                            ></sub-inspection-modal>
                          </b-modal>
                        </td>
                      </tr>
                      <tr v-if="inspectionItem.machineType == 12" style="font-size: 18px;">
                        <td colspan="2">
                          <b-button
                            class="button is-primary has-text-centered"
                            icon-left="folder-upload"
                            native-type="button"
                            style="position: relative; margin-right:20px;"
                            v-on:click="subContentsInspection(subscript, 2)"
                          >プログラム1項目点検</b-button>
                          <b-button
                            class="button is-primary has-text-centered"
                            icon-left="folder-upload"
                            native-type="button"
                            style="position: relative; margin-right:20px;"
                            v-on:click="subContentsInspection(subscript, 3)"
                          >プログラム2項目点検</b-button>
                          <b-button
                            class="button is-primary has-text-centered"
                            icon-left="folder-upload"
                            native-type="button"
                            style="position: relative; margin-right:20px;"
                            v-on:click="subContentsInspection(subscript, 4)"
                          >プログラム3項目点検</b-button>
                          <b-button
                            class="button is-primary has-text-centered"
                            icon-left="folder-upload"
                            native-type="button"
                            style="position: relative; margin-right:20px;"
                            v-on:click="subContentsInspection(subscript, 5)"
                          >プログラム4項目点検</b-button>
                          <b-modal
                            :active.sync="isSubContentsModalActive"
                            has-modal-card
                            full-screen
                          >
                            <sub-inspection-modal
                              v-on:set-sub-data="setSubData"
                              v-bind:inspection-item="inspectionItem"
                              v-bind:checkList="checkList"
                              v-bind:subscript="subscript"
                              v-bind:product-master="productMaster"
                              v-bind:targetContentsType="targetContentsType"
                            ></sub-inspection-modal>
                          </b-modal>
                        </td>
                      </tr>
                      <tr v-if="inspectionItem.machineType == 17" style="font-size: 18px;">
                        <td colspan="2">
                          <b-button
                            class="button is-primary has-text-centered"
                            icon-left="folder-upload"
                            native-type="button"
                            style="position: relative; margin-right:20px;"
                            v-on:click="subContentsInspection(subscript, 2)"
                          >プロファイル1項目点検</b-button>
                          <b-button
                            class="button is-primary has-text-centered"
                            icon-left="folder-upload"
                            native-type="button"
                            style="position: relative; margin-right:20px;"
                            v-on:click="subContentsInspection(subscript, 3)"
                          >プロファイル2項目点検</b-button>
                          <b-button
                            class="button is-primary has-text-centered"
                            icon-left="folder-upload"
                            native-type="button"
                            style="position: relative; margin-right:20px;"
                            v-on:click="subContentsInspection(subscript, 4)"
                          >プロファイル3項目点検</b-button>
                          <b-button
                            class="button is-primary has-text-centered"
                            icon-left="folder-upload"
                            native-type="button"
                            style="position: relative; margin-right:20px;"
                            v-on:click="subContentsInspection(subscript, 5)"
                          >プロファイル4項目点検</b-button>
                          <b-modal
                            :active.sync="isSubContentsModalActive"
                            has-modal-card
                            full-screen
                          >
                            <sub-inspection-modal
                              v-on:set-sub-data="setSubData"
                              v-bind:inspection-item="inspectionItem"
                              v-bind:checkList="checkList"
                              v-bind:subscript="subscript"
                              v-bind:product-master="productMaster"
                              v-bind:targetContentsType="targetContentsType"
                            ></sub-inspection-modal>
                          </b-modal>
                        </td>
                      </tr>
                      <b-modal
                        :active.sync="isSubContentsChangeModalActive"
                        has-modal-card
                        @close="subContentsChanged(subscript,false)"
                      >
                        <subContentsChange-Modal
                          v-bind:target-contents="targetContents"
                          v-bind:index="subscript"
                          v-bind:target-no="target"
                          v-on:subContents-change-event="subContentsChanged"
                        ></subContentsChange-Modal>
                      </b-modal>
                      <tr style="font-size: 18px;">
                        <td colspan="2">
                          <b-button
                            class="button is-primary has-text-centered"
                            icon-left="checkbox-marked"
                            native-type="button"
                            style="position: relative; margin-right:20px;"
                            v-on:click="prescriptionCopyAll()"
                          >処方値一括コピー</b-button>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
                <!-- 点検内容一覧 -->
                <div style="height: 10px"></div>
                <div v-if="inspectionItem.machineType == 7" class="columns searchTitle label" style="position: relative;">
                  <div class="column is-2" style="text-align:left; z-index 1;">{{ getMainSettingTrilogyEvo(inspectionItem.mainSetting, 1) }}</div>
                  <div class="column" style="position: absolute; z-index 1; width: 100%;">
                    <label>{{ trilogyEvoMainSetting[0].name }}点検</label>
                  </div>
                </div>
                <div class="columns header">
                  <div class="column is-1" style="text-align:left;">No.</div>
                  <div class="column is-3" style="text-align:left; margin-left:10px;">点検内容</div>
                  <div class="column is-2" style="text-align:left; margin-left:10px;">処方値</div>
                  <div class="column is-checkBoxCol" style="text-align:left; margin-left:10px;">レ</div>
                  <div class="column" style="text-align:left; margin-left:10px;">変更値</div>
                  <div class="column is-1">必須解除</div>
                </div>
                <!-- inspectionItemリストの中身を表示する -->
                <template v-for="(content, index) in inspectionItem.value">
                  <heading-comp
                    v-if="inspectionItem.machineType == 8 && (content.displayName.indexOf('リーク上限(Prog1)') != -1)"
                    v-bind:key="'alarmStartTitle'+index"
                    v-bind:color="'backgroundColor: #209cee;'"
                    v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                    v-bind:value1="'アラーム'"
                  ></heading-comp>
                  <heading-comp
                    v-if="inspectionItem.machineType == 8 && (content.displayName.indexOf('オートスタート(Prog1)') != -1)"
                    v-bind:key="'alarmEndTitle'+index"
                    v-bind:color="'backgroundColor: #209cee;'"
                    v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                  ></heading-comp>
                  <heading-comp
                    v-if="inspectionItem.machineType == 8 && (content.displayName.indexOf('運転時間') != -1 && content.displayName.indexOf('加湿器運転時間（prismaAQUAのみ)') == -1)"
                    v-bind:key="'notInstalledStartTitle'+index"
                    v-bind:color="'backgroundColor: #000894;'"
                    v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                    v-bind:value1="'点検項目（非装着点検項目）'"
                  ></heading-comp>
                  <heading-comp
                    v-if="inspectionItem.machineType == 8 && (content.displayName.indexOf('交換部品(Prog1)') != -1)"
                    v-bind:key="'notInstalledEndTitle'+index"
                    v-bind:color="'backgroundColor: #000894;'"
                    v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                  ></heading-comp>
                  <heading-comp
                    v-if="inspectionItem.machineType == 3 && (content.displayName.indexOf('気道内圧　（PIP)(表示値)') != -1)"
                    v-bind:key="'notInstalledEndTitle'+index"
                    v-bind:color="'backgroundColor: #209cee;'"
                    v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                    v-bind:value1="'モニター(表示値)'"
                  ></heading-comp>
                  <heading-comp
                    v-if="inspectionItem.machineType == 3 && (content.displayName.indexOf('PEEP/CPAP(実測値)') != -1)"
                    v-bind:key="'notInstalledEndTitle'+index"
                    v-bind:color="'backgroundColor: #209cee;'"
                    v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                    v-bind:value1="'モニター(実測値)'"
                  ></heading-comp>
                  <heading-comp
                    v-if="inspectionItem.machineType == 3 && (content.displayName.indexOf('作動音　（タービン等）') != -1)"
                    v-bind:key="'notInstalledEndTitle'+index"
                    v-bind:color="'backgroundColor: #209cee;'"
                    v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                  ></heading-comp>
                  <heading-comp
                    v-if="inspectionItem.machineType == 10 && (content.displayName.indexOf('ブロワー時間') != -1)"
                    v-bind:key="'A40ProinspectionStartTitle'+index"
                    v-bind:color="'backgroundColor: #000894;'"
                    v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                    v-bind:value1="'点検項目'"
                  ></heading-comp>
                  <heading-comp
                    v-if="inspectionItem.machineType == 10 && (content.displayName.indexOf('アラーム本体　回路外れ') != -1)"
                    v-bind:key="'A40AlarmStartTitle'+index"
                    v-bind:color="'backgroundColor: #000894;'"
                    v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                    v-bind:value1="'アラーム本体'"
                  ></heading-comp>
                  <heading-comp
                    v-if="inspectionItem.machineType == 10 && (content.displayName.indexOf('アラーム外部　気道内圧上限') != -1)"
                    v-bind:key="'A40ExternalAlarmStartTitle'+index"
                    v-bind:color="'backgroundColor: #000894;'"
                    v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                    v-bind:value1="'アラーム外部'"
                  ></heading-comp>
                  <heading-comp
                    v-if="inspectionItem.machineType == 11 && (content.displayName.indexOf('パーカッサー振動数(プリセット1)') != -1)"
                    v-bind:key="'A40ExternalAlarmStartTitle'+index"
                    v-bind:color="'backgroundColor: #000894;'"
                    v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                    v-bind:value1="'パーカッサー'"
                  ></heading-comp>
                  <heading-comp
                    v-if="inspectionItem.machineType == 11 && (content.displayName.indexOf('制御ロック') != -1)"
                    v-bind:key="'A40ExternalAlarmStartTitle'+index"
                    v-bind:color="'backgroundColor: #000894;'"
                    v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                  ></heading-comp>
                  <heading-comp
                    v-if="inspectionItem.machineType == 11 && (content.displayName.indexOf('予備回路') != -1 && content.displayOrder == 159)"
                    v-bind:key="'A40ExternalAlarmStartTitle'+index"
                    v-bind:color="'backgroundColor: #000894;'"
                    v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                    v-bind:value1="'点検検査項目'"
                  ></heading-comp>
                  <heading-comp
                    v-if="inspectionItem.machineType == 12 && (content.displayName.indexOf('呼吸回路タイプ　') != -1)"
                    v-bind:key="'LuisaMachineinspection1_'+index"
                    v-bind:color="addSubSystemStyleBackColorOpacity(null, 0.8)"
                    v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                    v-bind:value1="'器械設定共通項目'"
                  ></heading-comp>
                  <heading-comp
                    v-if="inspectionItem.machineType == 12 && (content.displayName.indexOf('呼吸回路タイプ　') != -1)"
                    v-bind:key="'LuisaMachineinspection2_'+index"
                    v-bind:color="addSubSystemStyleBackColorOpacity(null, 0.4)"
                    v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                    v-bind:value1="'換気プログラム'"
                  ></heading-comp>
                  <heading-comp
                    v-if="inspectionItem.machineType == 12 && (content.displayName.indexOf('アラーム音量') != -1)"
                    v-bind:key="'LuisaMachineinspection3_'+index"
                    v-bind:color="addSubSystemStyleBackColorOpacity(null, 0.4)"
                    v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                    v-bind:value1="'装置設定'"
                  ></heading-comp>
                  <heading-comp
                    v-if="inspectionItem.machineType == 12 && (content.displayName.indexOf('点検対象SN') != -1)"
                    v-bind:key="'LuisaMachineinspection4_'+index"
                    v-bind:color="addSubSystemStyleBackColorOpacity(null, 0.4)"
                    v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                    v-bind:value1="'内部バッテリ'"
                  ></heading-comp>
                  <heading-comp
                    v-if="inspectionItem.machineType == 12 && (content.displayName.indexOf('運転時間') != -1)"
                    v-bind:key="'LuisaMachineinspection5_'+index"
                    v-bind:color="addSubSystemStyleBackColorOpacity(null, 0.8)"
                    v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                    v-bind:value1="'点検項目(※非装着時点検項目)'"
                  ></heading-comp>
                  <heading-comp
                    v-if="inspectionItem.machineType == 12 && (content.displayName.indexOf('内部バッテリ充電量') != -1)"
                    v-bind:key="'LuisaMachineinspection6_'+index"
                    v-bind:color="addSubSystemStyleBackColorOpacity(null, 0.4)"
                    v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                    v-bind:value1="'内部バッテリ'"
                  ></heading-comp>
                                    <heading-comp
                    v-if="inspectionItem.machineType == 12 && (content.displayName.indexOf('外部バッテリ１充電量') != -1)"
                    v-bind:key="'LuisaMachineinspection7_'+index"
                    v-bind:color="addSubSystemStyleBackColorOpacity(null, 0.4)"
                    v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                    v-bind:value1="'外部バッテリ'"
                  ></heading-comp>
                  <heading-comp
                    v-if="inspectionItem.machineType == 12 && (content.displayName.indexOf('IPAP(min）') != -1)"
                    v-bind:key="'LuisaMachineinspection8_'+index"
                    v-bind:color="addSubSystemStyleBackColorOpacity(null, 0.4)"
                    v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                    v-bind:value1="'測定表示値'"
                  ></heading-comp>
                  <heading-comp
                    v-if="inspectionItem.machineType == 12 && (content.displayName.indexOf('高リーク　') != -1)"
                    v-bind:key="'LuisaMachineinspection9_'+index"
                    v-bind:color="addSubSystemStyleBackColorOpacity(null, 0.4)"
                    v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                    v-bind:value1="'アラーム'"
                  ></heading-comp>
                  <heading-comp
                    v-if="inspectionItem.machineType == 12 && (content.displayName.indexOf('呼吸回路タイプ ') != -1)"
                    v-bind:key="'LuisaMachineinspection10_'+index"
                    v-bind:color="addSubSystemStyleBackColorOpacity(null, 0.4)"
                    v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                    v-bind:value1="'付属品情報'"
                  ></heading-comp>
                  <heading-comp
                    v-if="inspectionItem.machineType == 12 && (content.displayName.indexOf('加湿器品目コード') != -1)"
                    v-bind:key="'LuisaMachineinspection11_'+index"
                    v-bind:color="addSubSystemStyleBackColorOpacity(null, 0.4)"
                    v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                    v-bind:value1="''"
                  ></heading-comp>
                  <heading-comp
                    v-if="inspectionItem.machineType == 12 && (content.displayName.indexOf('交換部品') != -1)"
                    v-bind:key="'LuisaMachineinspection12_'+index"
                    v-bind:color="addSubSystemStyleBackColorOpacity(null, 0.4)"
                    v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                    v-bind:value1="''"
                  ></heading-comp>
                  <heading-comp
                    v-if="inspectionItem.machineType == 17 && (content.displayName.indexOf('FW（起動時）') != -1)"
                    v-bind:key="'CrealWayMachineinspection1_'+index"
                    v-bind:color="addSubSystemStyleBackColorOpacity(null, 0.8)"
                    v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                    v-bind:value1="'器械設定共通項目'"
                  ></heading-comp>
                  <heading-comp
                    v-if="inspectionItem.machineType == 17 && (content.displayName.indexOf('吸気圧測定値（40hPa）') != -1)"
                    v-bind:key="'CrealWayMachineinspection14_'+index"
                    v-bind:color="addSubSystemStyleBackColorOpacity(null, 0.6)"
                    v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                    v-bind:value1="'確認項目'"
                  ></heading-comp>
                  <heading-comp
                    v-if="inspectionItem.machineType == 17 && (content.displayName.indexOf('交換部品') != -1)"
                    v-bind:key="'CrealWayMachineinspection15_'+index"
                    v-bind:color="addSubSystemStyleBackColorOpacity(null, 0.6)"
                    v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                    v-bind:value1="''"
                  ></heading-comp>
                  <!-- myAIRVO2 -->
                  <heading-comp
                    v-if="inspectionItem.machineType == 18 && (content.displayName.indexOf('患者タイプ') != -1)"
                    v-bind:key="'myAIRVO2Machineinspection1_'+index"
                    v-bind:color="addSubSystemStyleBackColorOpacity(null, 0.8)"
                    v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                    v-bind:value1="'器械設定共通項目'"
                  ></heading-comp>
                  <heading-comp
                    v-if="inspectionItem.machineType == 18 && (content.displayName == 'アラーム')"
                    v-bind:key="'myAIRVO2Machineinspection2_'+index"
                    v-bind:color="addSubSystemStyleBackColorOpacity(null, 0.6)"
                    v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                    v-bind:value1="'確認項目'"
                  ></heading-comp>
                  <heading-comp
                    v-if="inspectionItem.machineType == 18 && (content.displayName.indexOf('交換部品') != -1)"
                    v-bind:key="'myAIRVO2Machineinspection3_'+index"
                    v-bind:color="addSubSystemStyleBackColorOpacity(null, 0.6)"
                    v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                    v-bind:value1="''"
                  ></heading-comp>
                  <!-- 特定の項目の場合色変更 -->
                  <heading-comp
                    v-if="inspectionItem.machineType == 5 &&
                    inspectionItem.version != 0 &&
                    (content.displayName.indexOf('換気モード(副)') != -1)"
                    v-bind:key="'prefix-'+index"
                    v-bind:color="'backgroundColor: #000894;'"
                    v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                    v-bind:value1="'副設定項目'"
                  ></heading-comp>
                  <heading-comp
                    v-if="inspectionItem.machineType == 5&&
                    inspectionItem.version != 0 &&
                    (content.displayName.indexOf('バックライト') != -1)"
                    v-bind:key="'prefix-'+index"
                    v-bind:color="'backgroundColor: #000894;'"
                    v-bind:text-style="'font-size:15px; font-weight: bold;'"
                  ></heading-comp>
                  <heading-comp
                    v-if="inspectionItem.machineType == 5 &&
                    inspectionItem.version != 0 &&
                    (content.displayName.indexOf('気道内圧（PIP）(主)') != -1 ||
                      content.displayName.indexOf('気道内圧（PIP）(副)') != -1)"
                    v-bind:key="'prefix-'+index"
                    v-bind:color="'backgroundColor: #0e5dd3;'"
                    v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                    v-bind:value1="'モニタ表示値 / モニタ実測値'"
                  ></heading-comp>
                  <heading-comp
                    v-if="inspectionItem.machineType == 5 &&
                    inspectionItem.version != 0 &&
                    (content.displayName.indexOf('作業音（ブロワ)(主)') != -1 ||
                    content.displayName.indexOf('作業音（ブロワ）(副)') != -1)"
                    v-bind:key="'prefix-'+index"
                    v-bind:color="'backgroundColor: #0e5dd3;'"
                    v-bind:text-style="'font-size:15px; font-weight: bold;'"
                  ></heading-comp>
                  <heading-comp
                    v-if="inspectionItem.machineType == 5 &&
                    inspectionItem.version != 0 &&
                    (content.displayName.indexOf('アラーム 吸気圧上限(主)') != -1 ||
                    content.displayName.indexOf('アラーム 吸気圧上限(副)') != -1 ||
                    content.displayName.indexOf('吸気圧上限（主）') != -1 ||
                    content.displayName.indexOf('吸気圧上限（副）') != -1)"
                    v-bind:key="'prefix-'+index"
                    v-bind:color="'backgroundColor: #209cee;'"
                    v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                    v-bind:value1="'アラーム'"
                  ></heading-comp>
                  <heading-comp
                    v-if="inspectionItem.machineType == 5 &&
                    inspectionItem.version != 0 &&
                    (content.displayName.indexOf('アラームログ／イベントログ') != -1 ||
                    content.displayName.indexOf('呼吸回路タイプ(副)') != -1)"
                    v-bind:key="'prefix-'+index"
                    v-bind:color="'backgroundColor: #209cee;'"
                    v-bind:text-style="'font-size:15px; font-weight: bold;'"
                  ></heading-comp>

                  <!-- 見出し表示共通化 -->
                  <span 
                    v-if="header(inspectionItem, content)"
                    v-bind:key="'prefix-' + index"
                  >
                    <heading-comp
                      v-for="(header, index) in header(inspectionItem, content)"
                      v-bind:key="'prefix-' + index"
                      :color="'backgroundColor: ' + header.backgroundColor"
                      v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                      :value1="header.headerName"
                      style="margin-bottom: 0.75rem"
                    ></heading-comp>
                  </span>

                  <!-- テキスト項目 -->
                  <char-comp
                    v-if="content.type=== 'char' &&
                    (inspectionItem.version == 0 ||
                    (inspectionItem.version != 0 &&
                    (inspectionItem.machineType != 7 ||
                    (inspectionItem.machineType == 7 &&
                    content.contentsType == 1))&&
                    (inspectionItem.machineType != 8 ||
                    (inspectionItem.machineType == 8 &&
                    content.contentsType == 1))&&
                    (inspectionItem.machineType != 11 ||
                    (inspectionItem.machineType == 11 &&
                    content.contentsType == 1))&&
                    (inspectionItem.machineType != 12 ||
                    (inspectionItem.machineType == 12 &&
                    content.contentsType == 1))&&
                    (inspectionItem.machineType != 17 ||
                    (inspectionItem.machineType == 17 &&
                    content.contentsType == 1))
                    ))"
                    ref="itemvaluecompo"
                    v-bind:key="index"
                    v-bind:displayName="content.displayName"
                    v-bind:displayOrder="content.displayOrder"
                    v-bind:prescription="content.prescription"
                    v-bind:subscript="subscript"
                    v-bind:index="index"
                    v-bind:unit="content.unit"
                    v-bind:value="content.value"
                    v-bind:serial-list="inspectionItem.bombeSerialList"
                    v-bind:contentsType="content.contentsType"
                    v-bind:machine-type="inspectionItem.machineType"
                    v-bind:fieldName="getInputFieldName(subscript,index+1)"
                    v-bind:varsion="inspectionItem.version"
                    v-bind:serial="getSerial(inspectionItem)"
                    v-bind:isDisabled="`${checkDisable(inspectionItem.subContentsValue,content.contentsType,subscript,content.displayName,inspectionItem.version) ? true:false}`"
                    v-bind:isValidateRequired="`${checkRequired(inspectionItem.productCode,inspectionItem.machineType,content.type,content.sap,content.required,content.prescription,inspectionItem.subContentsValue,content.contentsType,content.displayOrder,getInputFieldName(subscript,index+1),content.displayName,subscript,content.requiredcheck) ? 'required':''}|validationCheck:${subscript},${index},${content.displayName},'${encodeURI(content.validationRule)}'|${(inspectionItem.machineType==8&&content.displayName.indexOf('（品目コード）(Prog1)')!=-1) ? 'checkProduct' : ''}`"
                    v-bind:requiredcheck="content.requiredcheck"
                    v-bind:note="content.note"
                    v-on:child-event="checkValueHot"
                    v-on:child-event-setValue="setValue"
                    v-on:child-event-limitCheck="limitCheck"
                  ></char-comp>
                  <!-- セレクトボックス -->
                  <sel-comp
                    v-if="content.type=== 'sel' &&
                    (inspectionItem.version == 0 ||
                    (inspectionItem.version != 0 &&
                    (inspectionItem.machineType != 7 ||
                    (inspectionItem.machineType == 7 &&
                    content.contentsType == 1))&&
                    (inspectionItem.machineType != 8 ||
                    (inspectionItem.machineType == 8 &&
                    content.contentsType == 1))&&
                    (inspectionItem.machineType != 11 ||
                    (inspectionItem.machineType == 11 &&
                    content.contentsType == 1))&&
                    (inspectionItem.machineType != 12 ||
                    (inspectionItem.machineType == 12 &&
                    content.contentsType == 1))&&
                    (inspectionItem.machineType != 17 ||
                    (inspectionItem.machineType == 17 &&
                    content.contentsType == 1))
                    ))"
                    ref="itemvaluecompo"
                    v-bind:key="index"
                    v-bind:displayName="content.displayName"
                    v-bind:displayValue="getDisplayValue(inspectionItem.machineType,mode[subscript],content.displayValue,content.displayName)"
                    v-bind:prescription="content.prescription"
                    v-bind:subscript="subscript"
                    v-bind:index="index"
                    v-bind:unit="content.unit"
                    v-bind:value="content.value"
                    v-bind:contentsType="content.contentsType"
                    v-bind:machine-type="inspectionItem.machineType"
                    v-bind:fieldName="getSelectFieldName(subscript,index+1)"
                    v-bind:isDisabled="`${checkDisable(inspectionItem.subContentsValue,content.contentsType,subscript,content.displayName,inspectionItem.version) ? true:false}`"
                    v-bind:isValidateRequired="`${checkRequired(inspectionItem.productCode,inspectionItem.machineType,content.type,content.sap,content.required,content.prescription,inspectionItem.subContentsValue,content.contentsType,content.displayOrder,getSelectFieldName(subscript,index+1),content.displayName,subscript,false) ? 'required':''}`"
                    v-bind:requiredcheck="content.requiredcheck"
                    v-on:child-event="setValue"
                  ></sel-comp>
                  <!-- ラジオボタン -->
                  <radio-comp
                    v-if="content.type=== 'radio' &&
                    (inspectionItem.version == 0 ||
                    (inspectionItem.version != 0 &&
                    (inspectionItem.machineType != 7 ||
                    (inspectionItem.machineType == 7 &&
                    content.contentsType == 1))&&
                    (inspectionItem.machineType != 8 ||
                    (inspectionItem.machineType == 8 &&
                    content.contentsType == 1))&&
                    (inspectionItem.machineType != 11 ||
                    (inspectionItem.machineType == 11 &&
                    content.contentsType == 1))&&
                    (inspectionItem.machineType != 12 ||
                    (inspectionItem.machineType == 12 &&
                    content.contentsType == 1))&&
                    (inspectionItem.machineType != 17 ||
                    (inspectionItem.machineType == 17 &&
                    content.contentsType == 1))
                    ))"
                    ref="itemvaluecompo"
                    v-bind:key="index"
                    v-bind:displayName="content.displayName"
                    v-bind:displayValue="content.displayValue"
                    v-bind:prescription="content.prescription"
                    v-bind:subscript="subscript"
                    v-bind:index="index"
                    v-bind:value="content.value ? content.value : content.displayValue[0].key"
                    v-bind:machine-type="inspectionItem.machineType"
                    v-bind:contentsType="content.contentsType"
                    v-bind:fieldName="getRadioFieldName(subscript,index+1)"
                    v-bind:isDisabled="`${checkDisable(inspectionItem.subContentsValue,content.contentsType,subscript,content.displayName,inspectionItem.version) ? true:false}`"
                    v-bind:isValidateRequired="`${checkRequired(inspectionItem.productCode,inspectionItem.machineType,content.type,content.sap,content.required,content.prescription,inspectionItem.subContentsValue,content.contentsType,content.displayOrder,getRadioFieldName(subscript,index+1),content.displayName,subscript,false) ? `requiredCheck:${content.value}`:''}`"
                    v-on:child-event="setValue"
                  ></radio-comp>
                </template>
                <!-- inspectionItemrリストの中身を表示する ここまで。 -->
                <!-- カメラ読み込み -->
                <b-modal :active.sync="serialInputModalActive.flg" has-modal-card>
                  <serialInput-modal
                    v-bind:index="serialInputModalActive.index"
                    v-bind:serial-list="serialInputModalActive.list"
                    v-bind:serial-type="serialInputModalActive.serialType"
                    v-bind:d-name="serialInputModalActive.dName"
                    v-bind:d-number="serialInputModalActive.dNumber"
                    v-bind:machineType="serialInputModalActive.machineType"
                    v-on:serial-input-event="serialChanged"
                    v-on:single-item-serial-reader="singleItemSerialReader"
                    full-screen
                  ></serialInput-modal>
                </b-modal>
                <b-modal
                  :active.sync="isSerialPuroductReaderModalActive"
                  has-modal-card
                  full-screen
                >
                  <serialProductReader-modal
                    v-bind:list="serialPuroductList"
                    v-bind:serial-type="serialInputModalActive.serialType"
                    v-bind:index="serialInputModalActive.index"
                    v-bind:d-name="serialInputModalActive.dName"
                    v-bind:d-number="serialInputModalActive.dNumber"
                    v-bind:machineType="serialInputModalActive.machineType"
                    v-on:serial-input-event="serialChanged"
                  ></serialProductReader-modal>
                </b-modal>
                <!-- 次回作業指示 -->
                <nextDirection-comp
                  v-bind:next-direction="inspectionItem.nextDirection"
                  v-bind:index="inspectionItem.value.length"
                  ref="nextDirection"
                ></nextDirection-comp>
              </template>
              <!--その他作業内容-->
              <template v-else>
                <otherWork-comp v-bind:other-work="inspectionItem.otherWork" ref="otherWork"></otherWork-comp>
              </template>
            </b-tab-item>
          </b-tabs>
        </section>
      </div>
      <b-modal :active.sync="isRegularDisposablesOrderModalActive" full-screen>
        <!--<regular-disposables-modal
          v-on:set-regular-disposables-data="setDisposablesData"
          v-bind:disposablesByDevice="inspectionItem.regularDisposablesProduct"
          v-bind:interval="inspectionItem.CTERM"
          v-bind:index="subscript"
        ></regular-disposables-modal>-->
        <regular-disposables-modal
          v-on:set-regular-disposables-data="setDisposablesData"
          v-bind:disposablesByDevice="teikishoumouData.disposablesByDevice"
          v-bind:interval="teikishoumouData.interval"
          v-bind:index="teikishoumouData.index"
          v-bind:patientCode="targetPatientCode"
          v-bind:patientName="targetPatientName"
        ></regular-disposables-modal>
      </b-modal>
      <b-modal :active.sync="prescriptionHistoryModalActive" has-modal-card full-screen>
        <prescription-history-modal v-bind:targetData="targetHistoryList"></prescription-history-modal> 
      </b-modal>
    </div>
    <!-- 下部余白 -->
    <div style="height: 10px;" />
  </div>
</template>

<script>
import Quagga from "quagga";
import disposablesOderTemplate from "./AppDisposablesOrder";
import AppInspectionExecuteSubTemplate from "./AppInspectionExecuteSub";
import regulardisposablesOderTemplate from "./AppRegularDisposablesOrder";
import { log } from "util";
import { constants } from "zlib";
import * as datetime from "../utils/datetime";
import * as Inspection from "../utils/inspection"

var canvas;
var ctx;
var moveflg = 0;
var Xpoint = 0;
var Ypoint = 0;
var signFlg = false;
// 初期値（サイズ、色、アルファ値）の決定
var defSize = 5;
var defColor = "#555";
var cnt = 0;

// ネイティブアプリとやりとりするためのPromise
window.nativePromises = {};
function generateUUID() {
  var d = new Date().getTime();
  var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
    c
  ) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
}
window.resolvePromise = function(promiseId, data, error) {
  if (error) {
    window.nativePromises[promiseId].reject(data);
  } else {
    window.nativePromises[promiseId].resolve(data);
  }
  // remove referenfe to stored promise
  delete window.nativePromises[promiseId];
};

const HeadingCompTemplate = {
  props: ["index", "color", "value1", "value2", "value3", "textStyle"],
  template: `
  <div class="columns row" :style="color">
      <div class="column is-1" style="text-align:left; margin-left:10px;"/>
      <div class="column is-3" style="text-align:left; margin-left:10px;">
        <span :style="textStyle">{{value1}}</span>
      </div>
      <div class="column is-2" style="text-align:left; margin-left:10px;">
        <span :style="textStyle">{{value2}}</span>
      </div>
      <div class="column is-checkBoxCol" style="text-align:left; margin-left:10px;"/>
      <div class="column" style="text-align:left; margin-left:10px;">
        <span :style="textStyle">{{value3}}</span>
      </div>
  </div>
  `,
  data: function() {
    return {};
  },
  created: function() {},
  methods: {}
};

const CharCompTemplate = {
  props: [
    "displayName",
    "displayOrder",
    "prescription",
    "subscript",
    "index",
    "unit",
    "value",
    "fieldName",
    "isValidateRequired",
    "isDisabled",
    "contentsType",
    "machineType",
    "serialList",
    "varsion",
    "serial",
    "requiredcheck",
    "note"
  ],
  template: `
  <div class="columns row" v-bind:style="addStyleBackColor()">
    <!--No.-->
    <div class="column is-1" style="text-align:left; margin-left:10px;">{{index+1}}</div>
    <!--点検内容-->
    <div class="column is-3" style="text-align:left; word-break:normal;">
      <span v-if="displayName" v-bind:style="addStyleTextColor(isValidateRequired)">
        {{displayName}}
        <br />
      </span>
      <span style="color:red;" v-if="displayName.indexOf('点検値変更理由') != -1" >
      ※ 改行は入力禁止
      </span>
      <span style="color:red;" v-if="displayName.indexOf('特記事項') != -1" >
      ※ 改行は入力禁止
      </span>
      <span v-if="note">
        {{note}}
      </span>
      <span v-if="machineType == 6 && displayName.indexOf('酸素濃度') != -1" >
         <span v-if="contentsType == 3&& displayName.indexOf('ゴーミニ') != -1" >
         ※ シンプリーゴーミニ：87％ 以上
         </span>
         <span v-else-if="contentsType == 4 && displayName.indexOf('ゴー') != -1" >
         ※ シンプリーゴー：90％ 以上
         </span>
         <span v-else>
        　※ コンフォライフ3SP / O2グリーンいぶき5SP：88～95％<br>
             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ライトテック-3X / ライトテック-5X：全設定流量 88％ 以上<br>
             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;オキシジェンステーション5L：87％ 以上<br>
             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dr.酸素7L：87％ 以上（0.5～7.2[L/分]）
          </span>
        </span>
      <span v-if="machineType == 4">
        <span v-if="displayName.indexOf('治療前呼吸') != -1" >
         ※ OFF、1-10（１きざみ）
        </span>
        <span v-if="displayName.indexOf('治療前圧力') != -1" >
         ※ 0hPa(cmH2O)-70（１きざみ）
        </span>
        <span v-if="displayName.indexOf('治療前吸気時間') != -1" >
         ※ 0.0秒ー5.0秒（0.1きざみ）
        </span>
        <span v-if="displayName.indexOf('治療前一時停止') != -1" >
         ※ 0.0秒ー5.0秒（0.1きざみ）
        </span>
        <span v-if="displayName.indexOf('咳回数') != -1" >
         ※ 1-15（１きざみ）
        </span>
        <span v-if="displayName.indexOf('サイクル数') != -1" >
         ※ 1-10（１きざみ）
        </span>
      </span>
      <span v-if="machineType == 8">
        <span v-if="displayName == 'Ti timed(Prog1)'" >
          ※ 自動または0.2～4.0
        </span>
        <span v-if="displayName == 'ロック時間(Prog1)'" >
          ※ OFFまたは0.6～5.0
        </span>
        <span v-if="displayName == '（目標）換気量(Prog1)'" >
          ※ 100～9999
        </span>
        <span v-if="displayName == 'softSTART Tmax(min)(Prog1)'" >
          ※ OFFまたは5～45
        </span>
        <span v-if="displayName == 'softSTOP(Prog1)'" >
          ※ OFFまたは5～45
        </span>
        <span v-if="displayName == 'リーク上限(Prog1)'" >
          ※ OFFまたは0.0～1000.0
        </span>
        <span v-if="displayName == '圧力上限(Prog1)'" >
          ※ OFFまたは0.0～50.0
        </span>
        <span v-if="displayName == '無呼吸(Prog1)'" >
          ※ OFFまたは10～60(5刻み)
        </span>
        <span v-if="displayName == '１回換気量　下限(Prog1)'" >
          ※ OFFまたは0～2000
        </span>
        <span v-if="displayName == '１回換気量　上限(Prog1)'" >
          ※ OFFまたは0～2000
        </span>
        <span v-if="displayName == 'Vti　下限(Prog1)'" >
          ※ OFFまたは0～2000
        </span>
        <span v-if="displayName == 'Vti　上限(Prog1)'" >
          ※ OFFまたは0～2000
        </span>
        <span v-if="displayName == '呼吸回数　下限(Prog1)'" >
          ※ OFFまたは0.0～100.0
        </span>
        <span v-if="displayName == '呼吸回数　上限(Prog1)'" >
          ※ OFFまたは0.0～100.0
        </span>
        <span v-if="displayName == 'MV　下限(Prog1)'" >
          ※ OFFまたは0.0～100.0
        </span>
        <span v-if="displayName == 'MV　上限(Prog1)'" >
          ※ OFFまたは0.0～100.0
        </span>
        <span v-if="displayName == 'SpO2　下限(Prog1)'" >
          ※ OFFまたは0.0～100.0
        </span>
        <span v-if="displayName == 'SpO2　上限(Prog1)'" >
          ※ OFFまたは0.0～100.0
        </span>
        <span v-if="displayName == '脈拍数　下限(Prog1)'" >
          ※ OFFまたは0～999
        </span>
        <span v-if="displayName == '脈拍数　上限(Prog1)'" >
          ※ OFFまたは0～999
        </span>
        <span v-if="displayName == 'IPAP(min)/CPAP(Prog1)'" >
          ※ 0.0～50.0(0.2刻み)
        </span>
        <span v-if="displayName == 'EPAP(Prog1)'" >
          ※ 0.0～50.0(0.2刻み)
        </span>
        <span v-if="displayName == 'EPAPmin（autoST）(Prog1)'" >
          ※ 0.0～50.0(0.2刻み)
        </span>
        <span v-if="displayName == 'EPAPmax（autoST）(Prog1)'" >
          ※ 0.0～50.0(0.2刻み)
        </span>
        <span v-if="displayName == '△pinsp．min(autoST)(Prog1)'" >
          ※ 0.0～50.0(0.2刻み)
        </span>
        <span v-if="displayName == '呼吸回数(Prog1)'" >
          ※ 0.0～60.0(0.5刻み)
        </span>
        <span v-if="displayName == '吸気時間(Prog1)'" >
          ※ 0.5～4.0
        </span>
        <span v-if="displayName == 'Ti min(Prog1)'" >
          ※ 0.2～4.0
        </span>
        <span v-if="displayName == 'Ti max(Prog1)'" >
          ※ 0.2～4.0
        </span>
        <span v-if="displayName == 'トリガ手動設定項目 吸気(Prog1)'" >
          ※ 1～8
        </span>
        <span v-if="displayName == 'トリガ手動設定項目 呼気(％)(Prog1)'" >
          ※ 5～95
        </span>
        <span v-if="displayName == '△P(Prog1)'" >
          ※ 0.2～40.0
        </span>
        <span v-if="displayName == 'deltaP LIAM(Prog1)'" >
          ※ 0.2～36.0
        </span>
        <span v-if="displayName == 'Ti LIAM(Prog1)'" >
          ※ 1.5～6.0
        </span>
        <span v-if="displayName == 'Te LIAM(Prog1)'" >
          ※ 0.5～9.0
        </span>
        <span v-if="displayName == '継続時間(Prog1)'" >
          ※ OFFまたは1～999
        </span>
        <span v-if="displayName == '回数(Prog1)'" >
          ※ 1～10
        </span>
        <span v-if="displayName == 'HFT流量(Prog1)'" >
          ※ 5.0～60.0
        </span>
        <span v-if="displayName == '低フロー酸素(Prog1)'" >
          ※ 0.00～60.00
        </span>
        <span v-if="displayName == '加湿器1（品目コード）(Prog1)'" >
          ※ R1152359 / R1079739 / R1143625
        </span>
      </span>
      <span v-if="machineType == 9">
        <span v-if="displayName == '酸素流量'" >
          ※ 0～60(0.01刻み)
        </span>
        <span v-if="displayName == '酸素流量　FiO2（％）目標値'" >
          ※ 21～100
        </span>
        <span v-if="displayName == '酸素濃度上限アラーム'" >
          ※ OFFまたは0～100(0.1刻み)
        </span>
        <span v-if="displayName == '酸素濃度下限アラーム'" >
          ※ OFFまたは0～100(0.1刻み)
        </span>
        <span v-if="displayName == 'フロー'" >
          ※ ２～60(0.1刻み)
        </span>
        <span v-if="displayName == 'Soft ver.'" >
          ※ 0～10桁の文字列
        </span>
        <span v-if="displayName == '家庭電源'" >
          ※ 小数点第一位まで指定する数値のみ
        </span>
        <span v-if="displayName == '酸素濃縮器（流量）'" >
          ※ 0～99
        </span>
        <span v-if="displayName == '酸素濃縮器：機種名'" >
          ※ 0～35桁の文字列
        </span>
        <span v-if="displayName == '予備回路'" >
          ※ 0～99
        </span>
      </span>
      <span v-if="machineType == 10">
        <span v-if="displayName == 'Spo2低下アラーム'" >
          ※ OFFまたは50~95の整数
        </span>
      </span>
      <span v-if="machineType == 11">
        <span v-if="displayName == 'パーカッサー振動数(プリセット1)'" >
          ※10～780の10単位刻み
        </span>
        <span v-if="displayName == 'パーカッサー動作時間(分)(プリセット1)'" >
          ※0～5の整数
        </span>
        <span v-if="displayName == 'パーカッサー動作時間(秒)(プリセット1)'" >
          ※0～59の整数
        </span>
      </span>
    </div>
    <!--特記事項-->
    <div class="column" v-if="isAdditionalMemoField(displayName) && isDisabled!='true'" style="text-align:left; margin-left:10px;">
      <b-field
        label
        labelPosition="on-border"
      >
        <b-input
          :name="fieldName"
          type="textarea"
          expanded
          v-model="dataValue"
          size="is-small"
          data-vv-as="点検値"
          :readonly="isDisabled=='true'"
          v-validate="isValidateRequired"
          style="width:100%;"
        ></b-input>
      </b-field>
    </div>
    <!--処方値-->
    <div class="column is-2" v-if="!isAdditionalMemoField(displayName)" style="text-align:left; margin-left:10px; white-space: pre-wrap;"
      >{{ getPrescriptionValue(prescription) }}
    </div>
    <!--変更チェック-->
    <div class="column is-checkBoxCol" v-if="!isAdditionalMemoField(displayName)" style="text-align:left; margin-left:10px;">
        <b-checkbox
          true-value="true"
          false-value="false"
          :disabled="isDisabled=='true'"
          :id="idName"
          @click.native="copy()"
        ></b-checkbox>
    </div>
    <!--特記事項以外の入力項目-->
    <div class="column"  v-if="!isAdditionalMemoField(displayName) && isDisabled!='true'" style="text-align:left; margin-left:10px;">
      <b-field
        label
        labelPosition="on-border"
      > 
        <div
          v-if="serialInputType() == 2 || serialInputType() == 3">
          <b-input         
            :name="fieldName"
            expanded
            v-model="dataValue"
            size="is-small"
            data-vv-as="点検値"
            :input="inputValue(dataValue)"
            :readonly="isDisabled=='true'"
            v-validate="isValidateRequired"
          ></b-input>
        </div>
        <!-- 点検値変更理由-->
        <b-input
          v-else-if="isReasonMemoField(displayName) "
          type="textarea"
          :name="fieldName"
          expanded
          v-model="dataValue"
          size="is-small"
          data-vv-as="点検値"
          :input="inputValue(dataValue,machineType, false)"
          :readonly="isDisabled=='true'"
          v-validate="isValidateRequired"
        ></b-input>
        <span
          style="text-align:left;"
          v-else-if="machineType==8 && (displayName == '加湿器1（品目テキスト）(Prog1)' || displayName == '加湿器2（品目テキスト）(Prog1)')"
        >{{dataValue}}</span>
        <b-input
          v-else
          :name="fieldName"
          :id="fieldName"
          expanded
          v-model="dataValue"
          size="is-small"
          data-vv-as="点検値"
          :input="inputValue(dataValue,machineType, false)"
          @blur="machineType==8?inputItemName():''"
          :readonly="isDisabled=='true'"
          v-validate="isValidateRequired"
        ></b-input>
        <b-select
          v-if="(machineType == 5 || machineType == 6) && varsion != 0 && displayName=='酸素濃度(主)' || displayName=='酸素濃度(副)'"
          expanded
          size="is-small"
          v-model="unit"
          :input="inputUnit(unit)"
        >
          <option
            v-for="unitItem in unitList"
            :value="unitItem.key"
            :key="unitItem.key"
          >{{ unitItem.value }}</option>
        </b-select>
        <b-select
          v-if="machineType == 3 && varsion != 0 && displayName=='アラーム音量'"
          expanded
          size="is-small"
          v-model="unit"
          :input="inputUnit(unit)"
        >
          <option
            v-for="unitItem in unitList2"
            :value="unitItem.key"
            :key="unitItem.key"
          >{{ unitItem.value }}</option>
        </b-select>
        <span
        v-if="unit"
        style="margin-left:10px;"
        >{{unit}}</span>
      </b-field>
      <b-field>
        <span v-if="errors.has(fieldName)" style="color:red;">{{errors.first(fieldName)}}</span>
      </b-field>
      <b-field>
        <span v-if="checkFlg" style="color:red;">下限が上限値を超えています。</span>
      </b-field>
      <b-button
       v-if="serialInputType() == 1"       
       class="button is-primary has-text-centered"
       native-type="button"
       id="Button"
       v-on:click="serialInput()"
       >シリアルNO入力</b-button>
      <b-button
       v-else-if="serialInputType() == 2"     
       class="button is-primary has-text-centered"
       native-type="button"
       id="Button"       
       v-on:click="serialInput()"
       icon-left="camera"
       >シリアルNO読み取り</b-button>
      <span
    v-if="machineType == 12 && displayName=='加湿器（品目コード＋品目テキスト)'"
    >
    {{ this.$parent.$parent.$parent.humidifierItemName }}
    </span>
    </div>
    <!-- シンプリーゴー、ゴーミニシリアルNO -->
    <div class="column"  v-if="displayName=='シンプリーゴーミニシリアルNO' || displayName=='シンプリーゴーシリアルNO'" style="text-align:left; margin-left:10px;">
      <b-field label labelPosition="on-border"> 
      {{serial}}
        <!--<b-input
          :name="fieldName"
          expanded
          v-model="serial"
          size="is-small"
          data-vv-as="点検値"
          :readonly="isDisabled=='true'"
        ></b-input>-->
      </b-field>
    </div>
    <!--必須項目解除チェックボックス-->
    <div class="column is-1" v-show="!isAdditionalMemoOrReasonMemo(displayName)&& isDisabled!='true'" style="text-align:left; margin-left:10px;">
      <b-field
        label
        labelPosition="on-border"
      > 
        <span class="requiredText">必須解除</span>
        <b-checkbox
          true-value="true"
          false-value="false"
          :disabled="isDisabled=='true'"
          :id="idName2"
          v-model="checker"
          @click.native="doNotRequired(checker)"
          class="requiredCheckBox"
        ></b-checkbox>
      </b-field>
    </div>
  </div>
  `,
  data: function() {
    var dataValue = this.value
    var dataValue1, dataValue2;
    var unitList = [
      { key: "％", value: "％" },
      { key: "ℓ/ｍ", value: "ℓ/ｍ" }
    ];
    var unitList2 = [
      { key: "dBA", value: "dBA" },
      { key: "　", value: "　" }
    ];
    return {
      dataValue,
      idName: this.fieldName + "_check",
      checkFlg: false,
      unitList,
      unitList2,
      idName2: this.fieldName + "_check2",
      checker: this.requiredcheck,
      dataValue1,
      dataValue2
    };
  },
  created: function() {
    this.$validator.extend("validationCheck", {
      getMessage: field => `入力内容に誤りがあります。再度入力してください。`,
      validate: (value, indexArray) => {
        var ret = false;
        var subscript = indexArray[0];
        var index = indexArray[1];
        var name = indexArray[2];
        // 正規表現にカンマが含まれるとパラメタ数が変化するのでここで結合する
        var validationRule = "";

        if (value.indexOf("'") != -1) {
          // シングルコーテーションはサーバ側でSQLエラーとなる為、ここではじく
          return false;
        }

        for (var i = 3; i < indexArray.length; i++) {
          validationRule += decodeURI(indexArray[i]);
          if (i != indexArray.length - 1) {
            validationRule += ",";
          }
        }
        validationRule = validationRule.replace(/'/g, "");
        // 入力値チェック
        var regex = RegExp(validationRule);
        if (name.indexOf("治療前呼吸") != -1) {
          // 半角変換
          value = value.replace(/[！-～]/g, function(input) {
            return String.fromCharCode(input.charCodeAt(0) - 65248);
          });
          // 大文字変換
          value = value.toUpperCase();
        }
        if (regex.test(value)) {
          ret = true;
        }
        return ret;
      }
    });
  },
  methods: {
    addStyleBackColor: function() {
      if (this.isDisabled == "true") {
        return {
          "background-color": "#E1E1E1"
        };
      }
    },
    addStyleTextColor: function(isValidateRequired) {
      // 必須項目
      if (isValidateRequired.indexOf("required") != -1) {
        return {
          color: "red"
        };
      }
    },
    activityType: function() {
      //カメラ機能が使用できるかの判定
      if (
        navigator.platform == "iPad" || // -iOS12
        (navigator.platform == "MacIntel" && // iPadOS
          navigator.userAgent.indexOf("Safari") != -1 &&
          navigator.userAgent.indexOf("Chrome") == -1 &&
          navigator.standalone !== undefined) ||
        navigator.userAgent == "AppGuardian"
      ) {
        return true;
      } else {
        return false;
      }
    },
    serialInputType() {
      //シリアルNo読み取り画面(ret=2) or シリアルナンバー入力画面(ret=1)に遷移するボタンを出力する項目か判定
      var ret;
      if (this.displayName == "携帯用酸素ボンベ（本数）") {
        ret = 1;
      } else if (
        this.$parent.$parent.$parent.serialDisplayNameList.indexOf(
          this.displayName
        ) != -1
      ) {
        ret = 2;
      }
      return ret;
    },
    doNotRequired(checker) {
      if (checker == false || checker == "false") {
        this.$parent.$parent.$parent.checkList.push(this.fieldName);
      } else {
        var items = this.$parent.$parent.$parent.checkList;
        var target = this.fieldName;
        var result = items.filter(function(item) {
          return item != target;
        });
        this.$parent.$parent.$parent.checkList = result;
      }
    },
    inputUnit(val) {
      this.$parent.$parent.$parent.data[this.subscript].value[
        this.index
      ].unit = val;
    },
    inputItemName() {
      if (
        this.displayName == "加湿器1（品目コード）(Prog1)" ||
        this.displayName == "加湿器2（品目コード）(Prog1)"
      ) {
        this.$emit(
          "child-event-setValue",
          this.dataValue,
          this.subscript,
          this.index,
          true,
          this.displayName
        );
      }
    },
    inputValue: async function(val, machineType, checkFlg) {
      if (this.isDisabled == "true") {
        // エラーリセット
        this.errors.remove(this.fieldName);
      }
      if (machineType == 6) {
        if (
          this.displayName == "安静時" ||
          this.displayName == "安静時（上限）" ||
          this.displayName == "労作時・後" ||
          this.displayName == "労作時・後（上限）" ||
          this.displayName == "睡眠時" ||
          this.displayName == "睡眠時（上限）" ||
          this.displayName == "人工呼吸器併用時" ||
          this.displayName == "人工呼吸器併用時（上限）"
        ) {
          var number = 0;
          switch (this.displayName) {
            case "安静時":
            case "安静時（上限）":
              number = 1;
              break;
            case "労作時・後":
            case "労作時・後（上限）":
              number = 2;
              break;
            case "睡眠時":
            case "睡眠時（上限）":
              number = 3;
              break;
            case "人工呼吸器併用時":
            case "人工呼吸器併用時（上限）":
              number = 4;
              break;
            default:
              break;
          }
          await this.$emit("child-event", val, this.subscript, this.index, number, checkFlg);
        }
        // prisma 上限下限チェック
      } else if (machineType == 8) {
        if (
          this.displayName == "１回換気量　下限(Prog1)" ||
          this.displayName == "１回換気量　上限(Prog1)" ||
          this.displayName == "Vti　下限(Prog1)" ||
          this.displayName == "Vti　上限(Prog1)" ||
          this.displayName == "呼吸回数　下限(Prog1)" ||
          this.displayName == "呼吸回数　上限(Prog1)" ||
          this.displayName == "MV　下限(Prog1)" ||
          this.displayName == "MV　上限(Prog1)" ||
          this.displayName == "SpO2　下限(Prog1)" ||
          this.displayName == "SpO2　上限(Prog1)" ||
          this.displayName == "脈拍数　下限(Prog1)" ||
          this.displayName == "脈拍数　上限(Prog1)"
        ) {
          var number = 0;
          switch (this.displayName) {
            case "１回換気量　下限(Prog1)":
            case "１回換気量　上限(Prog1)":
              number = 1;
              break;
            case "Vti　下限(Prog1)":
            case "Vti　上限(Prog1)":
              number = 2;
              break;
            case "呼吸回数　下限(Prog1)":
            case "呼吸回数　上限(Prog1)":
              number = 3;
              break;
            case "MV　下限(Prog1)":
            case "MV　上限(Prog1)":
              number = 4;
              break;
            case "SpO2　下限(Prog1)":
            case "SpO2　上限(Prog1)":
              number = 5;
              break;
            case "脈拍数　下限(Prog1)":
            case "脈拍数　上限(Prog1)":
              number = 6;
              break;
            default:
              break;
          }
          await this.$emit(
            "child-event-limitCheck",
            val,
            this.subscript,
            this.index,
            number,
            machineType,
            checkFlg
          );
        }
      }
    },
    isAdditionalMemoField(displayName) {
      return displayName.indexOf("特記事項") >= 0;
    },
    isReasonMemoField(displayName) {
      return displayName.indexOf("点検値変更理由") >= 0;
    },
    isAdditionalMemoOrReasonMemo(displayName) {
      return (
        this.isAdditionalMemoField(displayName) ||
        this.isReasonMemoField(displayName)
      );
    },
    getPrescriptionValue(val) {
      if (val == "-" || val == "null") {
        return "";
      } else {
        return val;
      }
    },
    copy() {
      if (this.displayName.indexOf("点検値変更理由") != -1) {
        // エラーリセット
        this.errors.remove(this.fieldName);
        this.dataValue = "変更なし";
        return;
      }
      if (
        this.prescription != "-" &&
        this.prescription != "" &&
        this.prescription != null &&
        this.prescription != "null"
      ) {
        // エラーリセット
        this.errors.remove(this.fieldName);

        switch (this.machineType) {
          case this.$parent.$parent.$parent.MACHINE_TYPE_ASV:
            if (
              this.displayName == "加湿器品目コード" ||
              this.displayName == "マスク品目コード" ||
              this.displayName == "通信モジュール品目コード"
            ) {
              let index = this.prescription.search(/\n/);
              this.dataValue = this.prescription.substring(0, index);
            } else {
              this.dataValue = this.prescription;
            }
            break;
          default:
            this.dataValue = this.prescription;
            break;
        }
      }
    },
    letsValidate: async function() {
      var result;
      if (this.machineType == 7 && this.isDisabled == "true") {
        result = true;
      } else {
        result = await this.$validator.validateAll();
      }
      this.$parent.$parent.$parent.totalResult =
        this.$parent.$parent.$parent.totalResult && result && !this.checkFlg;

      return result;
    },
    serialInput: function(event) {
      //単体、複数のシリアル項目切り分け(serialTypeが1の場合、複数)
      var serialType = 0;
      var newList = [];
      if (this.displayName == "携帯用酸素ボンベ（本数）") {
        serialType = 1;
        this.$parent.$parent.$parent.serialInputModalActive.list = this.serialList;
      } else {
        newList.push({ value: this.dataValue });
        this.$parent.$parent.$parent.serialInputModalActive.list = newList;
      }

      this.$parent.$parent.$parent.serialInputModalActive.index = this.subscript;
      this.$parent.$parent.$parent.serialInputModalActive.serialType = serialType;
      this.$parent.$parent.$parent.serialInputModalActive.dName = this.displayName;
      this.$parent.$parent.$parent.serialInputModalActive.dNumber = this.displayOrder;
      this.$parent.$parent.$parent.serialInputModalActive.machineType = this.machineType;
      this.$parent.$parent.$parent.serialInputModalActive.flg = true;
    },
    getItemName: async function(){
        let excuteApi = this.getItemListPOST;
        let successCallBack = this.getItemListPOSTSuccess;
        let errorCallBack = this.getItemListPOSTError;
        // WebAPI Call
        await this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getItemListPOST: function(client,i){
      return client.apis.apiMaster.getProductListPOST({
        body: {
          productCode: this.value
        }
      });
    },
    getItemListPOSTSuccess: function(result){
      if(result.obj.length == 1){
        this.$parent.$parent.$parent.humidifierItemName = "品目名:" + result.obj[0].productName;
      }
    },
    getItemListPOSTError: function(result){
      //何もしない
    }
  },
  mounted: async function() {
    if(this.displayName == '加湿器（品目コード＋品目テキスト)'){
      await this.getItemName()
    }
  },
  components: {}
};
const serialInputModal = {
  props: ["serialList", "index", "serialType", "dName", "dNumber"],
  components: {},
  methods: {
    activityType: function() {
      //カメラ機能が使用できるかの判定
      if (
        navigator.platform == "iPad" || // -iOS12
        (navigator.platform == "MacIntel" && // iPadOS
          navigator.userAgent.indexOf("Safari") != -1 &&
          navigator.userAgent.indexOf("Chrome") == -1 &&
          navigator.standalone !== undefined) ||
        navigator.userAgent == "AppGuardian"
      ) {
        return true;
      } else {
        return false;
      }
    },
    serialReader: function(col, serialList) {
      //カメラ呼び出し関数
      if (
        navigator.platform == "iPad" || // -iOS12
        (navigator.platform == "MacIntel" && // iPadOS
          navigator.userAgent.indexOf("Safari") != -1 &&
          navigator.userAgent.indexOf("Chrome") == -1 &&
          navigator.standalone !== undefined) ||
        navigator.userAgent == "AppGuardian"
      ) {
        // iPad
        // さらにWebKit判定を仕込む(UserAgentがAppGuardian)
        if (navigator.userAgent.endsWith("AppGuardian")) {
          // WkWebViewのためiPadアプリ
          // WkWebViewでのカメラアクセスを開始
          // コールバック関数を準備する
          // バーコード読み取り
          this.serialReaderByNative().then(
            function(returnValue) {
              var array = returnValue.split("/");
              // 本来はここでchildFunctionを呼び出すべきだが、Promiseのコールバックで
              // thisは使えないので直接ロジックを実行する
              //品目コードとシリアルのマージ
              var productSerial =
                "品目コード:" + array[0] + " " + "S/N:" + array[1];
              serialList[col].value = productSerial;
              if (this.serialType == 0) {
                // 単項目のシリアル読取りの場合
                this.setSerial();
              }
              return;
            }.bind(this)
          );
          if (this.serialType == 0) {
            // 単項目のシリアル読取りの場合
            this.$parent.close();
          }
          return;
        } else {
          // alert("使用可能な環境ではありません。PCブラウザまたはiPadアプリを使用してください。")
          // return;
        }
      } else {
        this.$parent.$parent.$parent.$parent.isSerialPuroductReaderModalActive = true;
        this.$parent.$parent.$parent.$parent.serialPuroductList = this.serialCollection;
        this.$parent.$parent.$parent.$parent.serialPuroductListIndex = col;
      }
    },
    serialReaderByNative: function() {
      var promise = new Promise(function(resolve, reject) {
        // we generate a unique id to reference the promise later
        // from native function
        var promiseId = generateUUID();
        // save reference to promise in the global variable
        nativePromises[promiseId] = { resolve, reject };

        try {
          // call native function
          window.webkit.messageHandlers.callbackHandler.postMessage({
            promiseId: promiseId
          });
        } catch (exception) {
          alert("カメラアクセスでエラーが発生しました");
        }
      });
      return promise;
    },
    addSerial: function() {
      this.serialCollection.push({ value: "" });
    },
    setSerial: function() {
      // 空白の削除
      this.serialCollection = this.serialCollection.filter(
        val => val.value != ""
      );

      var duplication = this.serialCollection.filter(
        (x, y, z) =>
          z.slice(0, z.length).filter(w => w.value == x.value).length >= 2
      );
      if (duplication.length > 0) {
        duplication = duplication.filter(function(v1, i1, a1) {
          return (
            a1.findIndex(function(v2) {
              return v1.value === v2.value;
            }) === i1
          );
        });
        var errMsg = "下記シリアルナンバーの重複が存在します。<br>";
        for (var i in duplication) {
          errMsg = errMsg + duplication[i].value + "<br>";
        }
        this.showErrorMessage(errMsg);
      } else {
        //選択された点検種別を親画面に返却
        this.$emit(
          "serial-input-event",
          this.index,
          this.serialCollection,
          this.dName,
          this.dNumber
        );
        this.$parent.close();
      }
    }
  },
  data() {
    if (this.serialList.length < 1) {
      this.serialList.push({ value: "" });
    }
    var serialCollection = JSON.parse(JSON.stringify(this.serialList));

    //読取を押下して遷移するモーダルに値を渡す
    this.$parent.$parent.$parent.$parent.serialPuroductList = serialCollection;
    //読取を押下して遷移するモーダルから受け取った値を反映する
    return {
      serialCollection: this.$parent.$parent.$parent.$parent.serialPuroductList
    };
  },
  mounted: function() {
    if (this.serialType == 0) {
      if (
        navigator.platform == "iPad" || // -iOS12
        (navigator.platform == "MacIntel" && // iPadOS
          navigator.userAgent.indexOf("Safari") != -1 &&
          navigator.userAgent.indexOf("Chrome") == -1 &&
          navigator.standalone !== undefined) ||
        navigator.userAgent == "AppGuardian"
      ) {
        this.$emit(
          "single-item-serial-reader",
          this.index,
          this.serialCollection,
          this.dName,
          this.dNumber
        );
        this.$parent.close();
      } else {
        document.getElementById("serialReaderButton").click();
        this.$parent.close();
      }
    }
  },
  template: `<form action="">
              <div class="modal-card" style="width:800px;" >
                <header class="modal-card-head" >
                  <p v-if="serialType == 1" class="modal-card-title" style="color:whitesmoke;" >シリアルナンバー入力</p>
                  <p v-else class="modal-card-title" style="color:whitesmoke;" >シリアルナンバー読み取り</p>
                </header>
                <section class="modal-card-body" style="width:100%;">
                    <tr v-for="(item, col) in serialCollection" v-bind:key="col">
                      <th :rowspan="serialCollection.length" v-if="col==0">
                        <b-button
                          v-if ="serialType==1"
                          style="vertical-align:top; margin-right:10px;"
                          class="button is-primary has-text-centered"
                          icon-left="plus"
                          native-type="button"
                          v-on:click="addSerial()"
                        ></b-button>
                      </th>
                      <td style="width:100%;">
                        <div class="columns">
                          <div class="column" style="width:640px;">
                            <b-input                             
                             expanded
                             style="width:100%; margin-top:20px;"
                             :readonly="serialType!=1"
                             v-model="item.value"
                             data-vv-as="シリアルNo"
                             ></b-input>
                          </div>
                          <div class="column is-one-fifth">                          
                           <b-button                                                   
                              class="button is-primary has-text-centered"
                              style="margin-top:20px;"　　
                              icon-left="camera"
                              native-type="button"
                              id="serialReaderButton"
                              v-on:click="serialReader(col,serialCollection)"
                            >読取</b-button>
                           <b-button
                            v-if="col > 0"
                            style="float:right; margin-left:5px; margin-top:20px;"　
                            class="button is-primary has-text-centered"
                            icon-left="minus"
                            native-type="button"
                            v-on:click="serialCollection.splice(col, 1)"
                            ></b-button>
                          </div>
                        </div>
                      </td>
                    </tr>
                </section>
                <footer class="modal-card-foot">
                  <button class="button" type="button" @click="setSerial">決定</button>
                  <button class="button" type="button" @click="$parent.close()">閉じる</button>
                </footer>
              </div>
            </form>`
};

const SelCompTemplate = {
  props: [
    "displayName",
    "displayValue",
    "prescription",
    "subscript",
    "index",
    "unit",
    "value",
    "fieldName",
    "isValidateRequired",
    "isDisabled",
    "contentsType",
    "machineType",
    "requiredcheck",
    "note"
  ],
  template: `
  <div class="columns row" v-bind:style="addStyleColor()">
    <!--No.-->
    <div class="column is-1" style="text-align:left; margin-left:10px;">{{index+1}}</div>
    <!--点検内容-->
    <div class="column is-3" style="text-align:left;">
      <span v-if="displayName" v-bind:style="addStyleTextColor(isValidateRequired)">
        {{displayName}}
        <br />
      </span>
      <span v-if="machineType == 11">
        <span v-if="displayName.indexOf('圧力表示') != -1" >
        ※ パーカッサー選択時はBarを選択
        </span>
      </span>
    </div>
    <!--処方値-->
    <div class="column is-2" style="text-align:left; margin-left:10px;"
    >{{ getSelectValue(displayValue,prescription) }}</div>
    <!--変更チェック-->
    <div class="column is-checkBoxCol" style="text-align:left; margin-left:10px;">
      <b-checkbox
        true-value="true"
        false-value="false"
        :disabled="isDisabled=='true'"
        :id="idName"
        @click.native="copy()"
      ></b-checkbox>
    </div>    
    <!--点検値-->
    <div class="column" v-if="isDisabled!='true'" style="text-align:left; margin-left:10px;">
      <b-field
        label
        labelPosition="on-border"
      > 
        <b-select
          expanded
          size="is-small"
          v-model="dataValue"
          :name="fieldName"
          :input="inputValue(dataValue)"
          data-vv-as="点検値"
          :disabled="isDisabled=='true'"
          class="inspectionSelect"
        >
          <option
            v-for="tmpValue in displayValue"
            :value="tmpValue.key"
            :key="tmpValue.key"
            :name="fieldName"
            :disabled="isDisable(tmpValue.value)"
            v-bind:style="addStyleBackColor(tmpValue.value)"
          >{{ tmpValue.value }}</option>
        </b-select>
        <span style="margin-left:10px;" v-if="unit">{{unit}}</span>
      </b-field>
      <b-field>
        <span v-if="isError" style="color:red;">点検値は必須項目です</span>
      </b-field>
    </div>
    <div class="column" v-else style="text-align:left; margin-left:10px;">{{ getSelectValue(displayValue,dataValue) }}</div>
    <!--必須項目-->
    <div class="column is-1" v-show="isDisabled!='true'" style="text-align:left; margin-left:10px;">
      <b-field
        label
        labelPosition="on-border"
      >
        <span class="requiredText">必須解除</span>
        <b-checkbox
          true-value="true"
          false-value="false"
          :disabled="isDisabled=='true'"
          :id="idName2"
          v-model="checker"
          @click.native="doNotRequired(checker,isValidateRequired)"
          class="requiredCheckBox"
        ></b-checkbox>
      </b-field>
    </div>
  </div>
  `,
  data: function() {
    var dataValue = this.value
    var disableItem = [
      {
        machineType: 8,
        displayName: "回路径",
        value: ["12㎜", "15H㎜"]
      }
    ];
    return {
      dataValue,
      idName: this.fieldName + "_check",
      idName2: this.fieldName + "_check2",
      checker: this.requiredcheck,
      isError: false,
      isSrcRequired: this.isValidateRequired.indexOf("required") != -1,
      disableItem
    };
  },
  methods: {
    addStyleColor: function () {
      if (this.isDisabled == "true") {
        return {
          "background-color": "#E1E1E1",
        };
      }
    },
    addStyleBackColor: function(value) {
      if (this.isDisable(value)) {
        return {
          "background-color": "#E1E1E1"
        };
      }
    },
    isDisable: function(value) {
      var targetItem = this.disableItem.find(
        val =>
          val.machineType == this.machineType &&
          val.displayName == this.displayName &&
          val.value.includes(value)
      );
      if (targetItem) {
        return true;
      }
      return false;
    },
    addStyleTextColor: function(isValidateRequired) {
      // 必須項目
      if (isValidateRequired.indexOf("required") != -1) {
        return {
          color: "red"
        };
      }
    },
    doNotRequired(checker, isValidateRequired) {
      if (checker == false || checker == "false") {
        this.isError = false;
        this.$parent.$parent.$parent.checkList.push(this.fieldName);
      } else {
        if (this.isSrcRequired && !this.dataValue) {
          this.isError = true;
        }
        var items = this.$parent.$parent.$parent.checkList;
        var target = this.fieldName;
        var result = items.filter(function(item) {
          return item != target;
        });
        this.$parent.$parent.$parent.checkList = result;
      }
    },
    inputValue(val) {
      if (val) {
        this.isError = false;
      }
      if (
        this.displayName == "シンプリーゴーモード" ||
        this.displayName.indexOf("本体SpO2") != -1 ||
        this.displayName.indexOf("本体EtCO2") != -1 ||
        this.displayName.indexOf("動作モード") != -1
      ) {
        this.$emit(
          "child-event",
          val,
          this.subscript,
          this.index,
          true,
          this.displayName
        );
        // val 1:連続, 2:同調, 3:スリープ
      }
    },
    getSelectValue(displayValue, prescription) {
      if (!prescription) {
        return "";
      }

      var value = "";
      for (var i in displayValue) {
        if (displayValue[i].key === prescription) {
          value = displayValue[i].value;
        }
      }
      return value;
    },
    getPrescriptionValue(val) {
      if (val == "-" || val == "null") {
        return "";
      } else {
        return val;
      }
    },
    copy() {
      if (
        this.prescription != "-" &&
        this.prescription != "" &&
        this.prescription != null &&
        this.prescription != "null"
      ) {
        // エラーリセット
        this.errors.remove(this.fieldName);
        this.dataValue = this.prescription;
      }
    },
    letsValidate: async function() {
      if(this.isDisabled == "true"){
        this.isError = false;
      }else 
      if (this.isValidateRequired.indexOf("required") != -1) {
        if (!this.dataValue) {
          this.isError = true;
        }
      }
      const result = !this.isError;
      this.$parent.$parent.$parent.totalResult =
        this.$parent.$parent.$parent.totalResult && result;
      return result;
    }
  }
};

const RadioCompTemplate = {
  props: [
    "displayName",
    "displayValue",
    "subscript",
    "index",
    "value",
    "fieldName",
    "isValidateRequired",
    "isDisabled",
    "contentsType",
    "machineType"
  ],
  template: `
    <div class="columns row" v-bind:style="addStyleBackColor()">
      <!--No.-->
      <div class="column is-1" style="text-align:left; margin-left:10px;">{{index+1}}</div>
      <!--点検内容-->
      <div class="column is-3" style="text-align:left;">
        <span v-if="displayName" v-bind:style="addStyleTextColor(isValidateRequired)">
          {{displayName}}
        </span>
      </div>
      <!--処方値-->
      <div class="column is-2" style="text-align:left; margin-left:10px;" />
      <!--変更チェック-->
      <div class="column is-checkBoxCol" style="text-align:left; margin-left:10px;" />
      <!--点検値-->
      <div class="column" v-if="isDisabled!='true'" style="text-align: left; margin-left:10px;">
        <b-field
          label
          labelPosition="on-border"
        >
          <b-radio
            v-for="tmpValue in displayValue"
            v-model="tmpValue.key"
            :value="tmpValue.value"
            :key="tmpValue.key"
            :name="fieldName"
            :native-value="dataValue"
            @click.native="inputRadioValue(tmpValue.key)"
            data-vv-as="点検値"
            :disabled="isDisabled=='true'"
            style="text-align:left; margin-Right:10px;"
          >{{tmpValue.value}}</b-radio>
        </b-field>
        <b-field>
          <span v-if="isError" style="color:red;">点検値は必須項目です</span>
        </b-field>
      </div>
    </div>
  `,
  data: function() {
    return {
      dataValue: this.value,
      isError: false
    };
  },
  created: function() { 
    this.$validator.extend("requiredCheck", {
      getMessage: field => `点検値は必須項目です`,
      validate: (value, valueList) => {
        var ret = true;
        // 入力値チェック
        if (valueList[0] != null) {
          valueList[0] = valueList[0] + "".replace(" ", "").replace("　", "");
        }
        if (valueList[0] == null || valueList[0] == "") {
          ret = false;
        }
        return ret;
      }
    });
  },
  methods: {
    addStyleBackColor: function() {
      if (this.isDisabled == "true") {
        return {
          "background-color": "#E1E1E1"
        };
      }
    },
    addStyleTextColor: function(isValidateRequired) {
      // 必須項目
      if (isValidateRequired.indexOf("required") != -1) {
        return {
          color: "red"
        };
      }
    },
    inputRadioValue(result) {
      // エラーリセット
      this.isError = false;
      this.dataValue = result;
      this.$emit("child-event", result, this.subscript, this.index, false);
    },
    letsValidate: async function() {
      if(this.isDisabled == "true"){
        this.isError = false;
      }else 
      if (this.isValidateRequired.indexOf("required") != -1) {
        if (!this.dataValue) {
          this.isError = true;
        }
      }
      const result = !this.isError;
      this.$parent.$parent.$parent.totalResult =
        this.$parent.$parent.$parent.totalResult && result;
      return result;
    }
  }
};

const SignTemplate = {
  props: ["signatureFlag", "signData", "alternative", "alternativeReason", "isBulk", "isDealer"],
  data() {
    return {
      alternativeWritingReason: this.$props.alternativeReason,
      checkConsent: this.$props.alternative,
      flag: this.$props.signatureFlag
    };
  },
  methods: {
    close: function(event) {
      // 署名モーダル閉じる
      this.$parent.close();
    },
    signUp: function(event) {
      this.$validator.validateAll().then(async validatorResult => {
        if (validatorResult) {
          // 署名をイメージに変換
          var signData = document.getElementById("signCanvas").toDataURL();
          signData = signData.replace("data:image/png;base64,", "");
          // サインチェック
          if (this.flag || ctx.strokeStyle == "#555555") {
            // 代理サインフラグ
            var signFlg = this.checkConsent;
            // 代理サイン理由
            var signReason = this.alternativeWritingReason;
            if (
              this.flag ||
              (!signFlg && signReason == "") ||
              (signFlg && signReason != "")
            ) {
              await this.$parent.$parent
                .inspectionComplete(signData, signFlg, signReason, this.flag)
                .then();
            } else {
              // エラーメッセージ表示
              this.showErrorMessage("代筆サインまたは、代筆理由が未入力です。");
            }
          } else {
            // エラーメッセージ表示
            this.showErrorMessage("署名が未入力です。");
          }
        }
      });
    },
    clearCanvas: function(event) {
      if (this.flag) {
        this.flag = false;
        // PC対応
        canvas.addEventListener("mousedown", this.startPoint, false);
        canvas.addEventListener("mousemove", this.movePoint, false);
        canvas.addEventListener("mouseup", this.endPoint, false);
        // スマホ対応
        canvas.addEventListener("touchstart", this.startPoint, false);
        canvas.addEventListener("touchmove", this.movePoint, false);
        canvas.addEventListener("touchend", this.endPoint, false);
      }
      ctx.clearRect(
        0,
        0,
        ctx.canvas.clientWidth + 10,
        ctx.canvas.clientHeight + 10
      );
      ctx.strokeStyle = "#000000";
      // フォーカスを外す
      var active_element = document.activeElement;
      if (active_element) {
        active_element.blur();
      }
    },
    startPoint: function(e) {
      e.preventDefault();
      ctx.beginPath();
      if (!e.offsetX) {
        Xpoint = e.touches[0].pageX - e.touches[0].target.offsetLeft;
      } else {
        Xpoint = e.offsetX;
      }
      if (!e.offsetY) {
        Ypoint = e.touches[0].pageY - e.touches[0].target.offsetTop;
      } else {
        Ypoint = e.offsetY;
      }
      ctx.moveTo(Xpoint, Ypoint);
    },
    movePoint: function(e) {
      if (e.buttons === 1 || e.witch === 1 || e.type === "touchmove") {
        if (!e.offsetX) {
          Xpoint = e.touches[0].pageX - e.touches[0].target.offsetLeft;
        } else {
          Xpoint = e.offsetX;
        }
        if (!e.offsetY) {
          Ypoint = e.touches[0].pageY - e.touches[0].target.offsetTop;
        } else {
          Ypoint = e.offsetY;
        }
        moveflg = 1;
        ctx.lineTo(Xpoint, Ypoint);
        ctx.lineCap = "round";
        ctx.lineWidth = defSize * 2;
        ctx.strokeStyle = defColor;
        ctx.stroke();
      }
    },
    endPoint: function(e) {
      if (moveflg === 0) {
        ctx.lineTo(Xpoint - 1, Ypoint - 1);
        ctx.lineCap = "round";
        ctx.lineWidth = defSize * 2;
        ctx.strokeStyle = defColor;
        ctx.stroke();
      }
      moveflg = 0;
    },
    inputReason() {
      if (!this.checkConsent) {
        this.alternativeWritingReason =
          "本人、ご家族の許可を得て代理サインしております。";
      } else {
        this.alternativeWritingReason = "";
      }
    }
  },
  mounted: async function() {
    // 一括点検の場合は署名スキップ
    if (this.isBulk) {
      await this.$parent.$parent.inspectionComplete(null, null, null, true);
      this.$parent.close();
    }

    canvas = document.getElementById("signCanvas");
    canvas.width = divCanvas.clientWidth;
    canvas.height = divCanvas.clientHeight;
    ctx = canvas.getContext("2d");
    if (this.flag) {
      // サイン画像表示
      var img = new Image();
      img.src =
        "data:image/png;base64," +
        Buffer.from(this.$props.signData).toString("base64");
      img.onload = function() {
        ctx.canvas.width = divCanvas.clientWidth;
        ctx.canvas.height = divCanvas.clientHeight;
        ctx.drawImage(img, 0, 0);
      };
    } else {
      // PC対応
      canvas.addEventListener("mousedown", this.startPoint, false);
      canvas.addEventListener("mousemove", this.movePoint, false);
      canvas.addEventListener("mouseup", this.endPoint, false);
      // スマホ対応
      canvas.addEventListener("touchstart", this.startPoint, false);
      canvas.addEventListener("touchmove", this.movePoint, false);
      canvas.addEventListener("touchend", this.endPoint, false);
    }
    // サイン画像表示
    // document.getElementById("signImg").src =
    //   "data:image/png;base64," +
    //   Buffer.from(this.$props.signData).toString("base64");
  },
  template: `
        <form action="">
            <div class="modal-card" style="width: 100%;">
                <header class="modal-card-head">
                    <p class="modal-card-title" style="color: whitesmoke; text-align: left">署名</p>
                </header>
                <section class="modal-card-body" style="width: 100%;">
                  <div align="center" id="divCanvas" class="columns" style="width: 98%;height: 500px;">
                    <canvas
                      class="is-full"
                      id="signCanvas"
                      style="border:5px solid #ccc;width: 100%;">
                    </canvas>
                  </div>
                  <div class="columns" style="text-align: left;">
                    <div class="column is-full">
                      <b-checkbox
                      v-model="checkConsent"
                      :disabled="flag"
                      @click.native="inputReason()"
                      style="font-size: 16px; font-weight: bold">代理サイン</b-checkbox>
                    </div>
                  </div>
                  <div class="columns">
                    <div class="column">
                      <span style="font-size: 16px; font-weight: bold;">代理サイン理由</span>
                      <b-field
                        :type="{'is-danger':errors.has('alternativeWritingReason')}"
                        :message="errors.first('alternativeWritingReason')"
                      >
                        <b-input
                          v-model="alternativeWritingReason"
                          name="alternativeWritingReason"
                          :readonly="flag"
                          data-vv-as="代筆理由"
                          v-validate="'max:50'"
                          maxlength="50" />
                      </b-field>
                    </div>
                  </div>
                </section>
                <footer class="modal-card-foot">
                    <b-button class="button" type="button" @click="signUp()">登録する</b-button>
                    <b-button class="button" type="button" @click="clearCanvas()">クリア</b-button>
                    <span style="color: white" v-if="flag">※既に署名済みの為、編集できません。再入力する場合は「クリアボタン」押下して下さい。</span>
                </footer>
            </div>
        </form>
      `
};

const RegularDisposablesTemplate = {
  components: {
    regularDisposablesOder: regulardisposablesOderTemplate
  },
  props: [
    "disposablesByDevice",
    "interval",
    "index",
    "patientCode",
    "patientName"
  ],
  data() {
    if (
      this.disposablesByDevice[0].confirmedDelivery &&
      this.disposablesByDevice[0].confirmedDelivery.length > 0
    ) {
      this.disposablesByDevice[0].statusFlag = this.disposablesByDevice[0].confirmedDelivery.includes(
        this.formatMonth2(this.getNextDate(new Date(), this.interval, false))
      );
    }
    return {
      dispo: JSON.parse(JSON.stringify(this.disposablesByDevice))
    };
  },
  methods: {
    getNextDate: function(preDate, interval, charFlag) {
      // 前回供給日⇒次回供給予定日の自動計算
      var year = parseInt(interval / 12);
      var month = parseInt(interval % 12);
      var next1InspectionDate;
      //対象月(前回供給日+期間)の月初日
      var targetFirstDay = new Date(
        Number(preDate.getFullYear() + year),
        Number(preDate.getMonth() + month),
        1
      );
      var targetLastDay = this.parseDate(this.getMonthLastDay(targetFirstDay));
      if (targetLastDay.getDate() >= preDate.getDate()) {
        // 対象月(次回供給日+期間)の月末日が次回供給予定の日以上
        // そのまま設定
        next1InspectionDate = new Date(
          Number(preDate.getFullYear()) + year,
          Number(preDate.getMonth()) + month,
          preDate.getDate()
        );
      } else {
        // 対象月(次回供給日+期間)の月末日が次回供給予定の日より小さい
        // 対象月の月末日を設定
        next1InspectionDate = targetLastDay;
      }
      if (charFlag) {
        return this.formatDate2(next1InspectionDate);
      }
      return next1InspectionDate;
    },
    save: function(event) {
      var childView = this.$refs.regularDisposablesView;
      if (childView.checkDisposablesOrder()) {
        childView.$validator.validateAll().then(validatorResult => {
          var isErrorFlg = childView.checkItems();
          if (validatorResult && !isErrorFlg) {
            var returnItems = childView.getItems();
            this.$emit(
              "set-regular-disposables-data",
              returnItems,
              this.$props.index
            );
            this.$parent.close();
          } else {
            scrollTo(0, 0);
          }
        });
      } else {
        // エラーメッセージ表示
        this.showErrorMessage(
          "発送期間が1カ月の消耗品は発送できません。<br>" +
            "発送のチェックを外してください。"
        );
        scrollTo(0, 0);
      }
    }
  },
  template: `
      <div>
        <regularDisposablesOder ref="regularDisposablesView"
        v-bind:disposablesByDevice="dispo"
         v-bind:isSourceInspection="true"
         v-bind:interval="interval"
         v-bind:patientCode="patientCode"
         v-bind:patientName="patientName"
        />
        <div style="height: 10px;" />
        <span style="color: red" v-if="!this.disposablesByDevice[0].regularDisposableFlag && this.disposablesByDevice[0].statusFlag == 1">
        発送月が同じ消耗品が確定済です、発送のチェックを行う場合は「消耗品発送 管理」から実施してください。
        </span>
        <div class="columns" style="height: 10px;">
          <div class="column is-full" style="text-align:center;">
            <b-button
              v-on:click=$parent.close()
              class="button"
              type="is-primary"
              icon-left="keyboard-backspace"
              native-type="button"
              >戻る</b-button>
            <b-button
              v-on:click=save
              class="button"
              type="is-primary"
              native-type="button"
              >登録</b-button>
          </div>
        </div>
      </div>
      `
};

const InspectionExecuteSubTemplate = {
  components: {
    subInspection: AppInspectionExecuteSubTemplate
  },
  props: [
    "inspectionItem",
    "subscript",
    "productMaster",
    "targetContentsType",
    "checkList",
    "mainSetting",
  ],
  computed: {
    title: function() {
      let title;
      let no = this.targetContentsType - 1;
      switch (this.inspectionItem.machineType) {
        case inspectionUtil.MACHINE_TYPE.TRILOGY_EVO.code:
          title = "【設定" + this.targetContentsType + "】点検";
          break;
        case inspectionUtil.MACHINE_TYPE.PRISMA.code:
          title = "prog" + this.targetContentsType;
          break;
        case inspectionUtil.MACHINE_TYPE.COUGH_ASSIST2.code:
          title = "プリセット" + this.targetContentsType + "点検";
          break;
        case inspectionUtil.MACHINE_TYPE.LUISA.code:
          title = "プログラム" + no + "項目点検";
          break;
        case inspectionUtil.MACHINE_TYPE.CW2.code:
          title = "プロファイル" + no + "項目点検";
          break;
        default:
          title = "副項目点検";
          break;
      }
      return title;
    }
  },
  methods: {
    save: async function(event) {
      var childView = this.$refs.subInspectionView;
      // var result = await childView.checkValid();
      var returnCheckList = childView.getCheckList();
      var returnItems = childView.getItems();
      this.$emit("set-sub-data", returnItems, this.subscript, returnCheckList);
      this.$parent.close();
    },

    close: function(){
      this.$emit("sub-setting-name", this.subscript, this.targetContentsType);
      this.$parent.close();
    }
  },

  template: `
    <form style="width: 98%;height:98%;margin-left: 1%;margin-top: 1%;">
      <div class="modal-card" style="width: 100%;">
        <header class="modal-card-head">
          <div style="width: 100%; display: flex; position: relative;">
            <p class="modal-card-title" style="color: whitesmoke; z-index 1;">{{ mainSetting ? mainSetting : "　" }}</p>
            <p class="modal-card-title" style="color: whitesmoke; position: absolute; z-index 1; width: 100%; text-align: center;">{{ title }}</p>
          </div>
        </header>
        <section class="modal-card-body" style="width: 100%;height:100%;">
          <div style="height: 10px;" />
          <subInspection ref="subInspectionView"
            v-bind:inspection-item="inspectionItem"
            v-bind:subscript="subscript"
            v-bind:product-master="productMaster"
            v-bind:targetContentsType="targetContentsType"
            v-bind:checkList="checkList"
          />
          <div style="height: 10px;" />
        </section>
        <footer style="text-align:center;">
          <div class="column is-full" style="text-align:center;">
            <b-button
              v-on:click=close()
              class="button"
              type="is-primary"
              native-type="button"
            >主画面に戻る</b-button>
            ※入力値はそのまま保持されます
          </div>
        </footer>
      </div>
    </form>
  `
};

const serialScannerTemplate = {
  props: ["oldSerialNumber", "productNumber", "originalData"],
  data() {
    return {
      newProductCode: "",
      newSerialNumber: ""
    };
  },
  methods: {
    cancel() {
      Quagga.stop();
      this.$parent.close();
    },
    checkChangedMachine(targetCode, targetSerial) {
      var isOk = true;
      var data = this.$props.originalData;
      for (var i = 0; i < data.length; i++) {
        if (
          targetCode == data[i].productCode &&
          targetSerial == data[i].serialNumber
        ) {
          isOk = false;
        }
      }
      return isOk;
    },
    childFunction(newProductCode, newSerialNumber) {
      if (newProductCode && newSerialNumber) {
        newProductCode = this.spaceDelete(newProductCode);
        newSerialNumber = this.spaceDelete(newSerialNumber);

        if (this.checkChangedMachine(newProductCode, newSerialNumber)) {
          this.$emit(
            "child-event",
            this.$props.oldSerialNumber,
            this.$props.productNumber,
            newSerialNumber,
            newProductCode
          );
          this.$parent.close();
        } else {
          this.showErrorMessage(
            "点検機器と同じ「品目コード」+「シリアル番号」は入力できません。"
          );
        }
      } else if (
        document.querySelector("#serial-number").defaultValue &&
        document.querySelector("#product-code").defaultValue
      ) {
        if (this.checkChangedMachine(newProductCode, newSerialNumber)) {
          this.$emit(
            "child-event",
            this.$props.oldSerialNumber,
            this.$props.productNumber,
            document.querySelector("#serial-number").defaultValue,
            document.querySelector("#product-code").defaultValue
          );
          this.$parent.close();
        } else {
          this.showErrorMessage(
            "点検機器と同じ「品目コード」+「シリアル番号」は入力できません。"
          );
        }
      } else {
        this.showErrorMessage("未入力の項目があります。");
      }
    },

    startScanner: function() {
      Quagga.init(
        {
          numOfWorkers: navigator.hardwareConcurrency,
          frequency: 10,
          inputStream: {
            name: "Live",
            type: "LiveStream",
            target: document.querySelector("#scanner-container"),
            constraints: {
              width: { min: 800 },
              height: { min: 600 },
              facingMode: "environment",
              aspectRatio: { min: 1, max: 2 }
            }
          },
          locator: {
            patchSize: "x-large",
            halfSample: true
          },
          decoder: {
            readers: [
              {
                format: "code_128_reader",
                config: {}
              }
            ]
          },
          locate: true
        },
        err => {
          if (!err) {
            Quagga.start();
          }
        }
      );

      Quagga.onDetected(success => {
        const resultCode = success.codeResult.code;
        var pattern = new RegExp("[0-9A-Z]+/[0-9A-Z]");
        var value = resultCode.match(pattern);
        if (value) {
          let list = resultCode.split("/");
          if (
            window.confirm(
              "品目コード：" +
                list[0] +
                "\nシリアルナンバー：" +
                list[1] +
                "\nこちらの内容でよろしいですか？"
            )
          ) {
            document.querySelector("#product-code").defaultValue = list[0];
            document.querySelector("#serial-number").defaultValue = list[1];
            Quagga.stop();
          } else {
            Quagga.stop();
            Quagga.init(
              {
                numOfWorkers: navigator.hardwareConcurrency,
                frequency: 10,
                inputStream: {
                  name: "Live",
                  type: "LiveStream",
                  target: document.querySelector("#scanner-container"),
                  constraints: {
                    width: { min: 800 },
                    height: { min: 600 },
                    facingMode: "environment",
                    aspectRatio: { min: 1, max: 2 }
                  }
                },
                locator: {
                  patchSize: "x-large",
                  halfSample: true
                },
                decoder: {
                  readers: [
                    {
                      format: "code_128_reader",
                      config: {}
                    }
                  ]
                },
                locate: true
              },
              err => {
                if (!err) {
                  Quagga.start();
                }
              }
            );
          }
        }
      });
    }
  },
  mounted: function() {
    if (
      navigator.platform == "iPad" || // -iOS12
      (navigator.platform == "MacIntel" && // iPadOS
        navigator.userAgent.indexOf("Safari") != -1 &&
        navigator.userAgent.indexOf("Chrome") == -1 &&
        navigator.standalone !== undefined) ||
      navigator.userAgent == "AppGuardian"
    ) {
      // iPad
      // さらにWebKit判定を仕込む(UserAgentがAppGuardian)
      if (navigator.userAgent.endsWith("AppGuardian")) {
        return;
      } else {
        //alert('使用可能な環境ではありません。PCブラウザまたはiPadアプリを使用してください。')
        // return;
      }
    } else {
      // MacOS
    }
    if (cnt < 1) {
      this.startScanner();
      cnt = cnt + 1;
    }
  },
  beforeDestroy: function() {
    if (cnt >= 1) {
      cnt = cnt - 1;
    }
    Quagga.stop();
  },
  component: {},
  template: `
    <form action="">
      <div class="modal-card" style="width: 1280px; height: 800px;">
        <header class="modal-card-head">
            <p class="modal-card-title" style="color: whitesmoke; text-align: left">交換機器</p>
        </header>
        <section class="modal-card-body">
          <div class="columns">
            <div class="column is-one-seconds">
              <b-field label="品目コード" horizontal>
                <b-input
                id="product-code"
                placeholder="交換する機器の品目コードを入力してください。"
                v-model="newProductCode"></b-input>
              </b-field>
            </div>
            <div class="column is-one-seconds">
              <b-field label="シリアルNo." horizontal>
                <b-input
                id="serial-number"
                placeholder="交換する機器のシリアルナンバーを入力してください。"
                v-model="newSerialNumber"></b-input>
              </b-field>
            </div>
          </div>
          <div
          id="scanner-container"
          style="width: 1240px; height: 550px;"/>
        </section>
        <footer class="modal-card-foot">
          <b-button class="button" type="button" v-on:click="cancel()">戻る</b-button>
          <b-button class="button" type="button" v-on:click="childFunction(newProductCode,newSerialNumber)">決定</b-button>
        </footer>
      </div>
    </form>
    `
};

const serialProductScannerTemplate = {
  props: ["list", "serialType", "index", "dName", "dNumber", "machineType"],
  data() {
    return {
      productCode: "",
      serialCode: ""
    };
  },
  methods: {
    cancel() {
      this.$parent.close();
    },
    async childFunction() {
      if (this.productCode || this.serialCode) {
            this.$parent.$parent.$parent.$parent.serialPuroductList[
            this.$parent.$parent.$parent.$parent.serialPuroductListIndex
            ].value =
            "品目コード:" +
            this.spaceDelete(this.productCode) +
            " " +
            "S/N:" +
            this.spaceDelete(this.serialCode);
      } else {
        this.$parent.$parent.$parent.$parent.serialPuroductList[
          this.$parent.$parent.$parent.$parent.serialPuroductListIndex
        ].value = "";
      }
      if (this.serialType == 0) {
        //選択された点検種別を親画面に返却
        this.$emit(
          "serial-input-event",
          this.index,
          this.$parent.$parent.$parent.$parent.serialPuroductList,
          this.dName,
          this.dNumber,
          this.machineType,
          this.productCode,
          this.serialCode
        );
      }
      await this.getItemName();
      this.$parent.close();
    },
      getItemName: async function(){
      let excuteApi = this.getItemListPOST;
      let successCallBack = this.getItemListPOSTSuccess;
      let errorCallBack = this.getItemListPOSTError;
      // WebAPI Call
      await this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getItemListPOST: function(client){
      return client.apis.apiMaster.getProductListPOST({
        body: {
          productCode: this.productCode
        }
      });
    },
    getItemListPOSTSuccess: function(result){
      if(result.obj.length == 1){
        //複数項目の対応
        this.$parent.$parent.$parent.$parent.humidifierItemName = '品目名:' + result.obj[0].productName;
      }
      else{
        this.$parent.$parent.$parent.$parent.humidifierItemName = '品目名:';
      }
    },
    getItemListPOSTError: function(result){
      this.$parent.$parent.$parent.$parent.humidifierItemName = '品目名:';
    },

  },
  component: {},
  template: `
    <form action="">
      <div class="modal-card" style="width: 1280px; height: 800px;">
        <header class="modal-card-head">
            <p class="modal-card-title" style="color: whitesmoke; text-align: left">交換機器</p>
        </header>
        <section class="modal-card-body">
          <div class="columns">
            <div class="column is-one-seconds">
              <b-field label="品目コード" horizontal>
                <b-input                
                placeholder="品目コードを入力してください。"
                v-model="productCode"></b-input>
              </b-field>
            </div>
            <div class="column is-one-seconds">
              <b-field label="シリアルNo." horizontal>
                <b-input                
                placeholder="シリアルナンバーを入力してください。"
                v-model="serialCode"></b-input>
              </b-field>
            </div>
          </div>
          <div style="width: 1240px; height: 550px;"/>
        </section>
        <footer class="modal-card-foot">
          <b-button class="button" type="button" v-on:click="cancel()">戻る</b-button>
          <b-button class="button" type="button" v-on:click="childFunction()">決定</b-button>
        </footer>
      </div>
    </form>
    `
};

const subContentsChangeModal = {
  props: ["targetContents", "index", "targetNo"],
  components: {},
  methods: {
    on: function() {
      //親画面にtrueを返却
      this.$emit("subContents-change-event", this.$props.index, true);
      this.$parent.close();
    },
    notOn: function() {
      //親画面にfalseを返却
      this.$emit("subContents-change-event", this.$props.index, false);
      this.$parent.close();
    }
  },
  data() {
    return {};
  },
  template: `<form action="">
              <div class="modal-card" style="width:800px;" >
                <header class="modal-card-head" >
                  <p class="modal-card-title" style="color:whitesmoke;" >副項目確認</p>
                </header>
                <section class="modal-card-body" >
                  <template>
                    <div id="AppSelectKind" style="height:350px;" >
                      <div style="min-height:350px; width:100%; text-align:left; margin-left: 50px;">
                        <span
                         v-for="(target,index) in targetContents"
                         v-bind:key="index"
                         style="font-size:15px;"
                        >
                          {{ target }}
                          <br />
                        </span>
                      </div>
                    </div>
                  </template>
                </section>
                <footer class="modal-card-foot">
                  <button class="button" type="button" @click="on()">OK</button>
                  <button class="button" type="button" @click="notOn()">キャンセル</button>
                </footer>
              </div>
            </form>`
};

const nextDirectionCompTemplate = {
  props: ["nextDirection", "index"],
  data() {
    var nextDirectionValue = this.nextDirection;
    return {
      nextDirectionValue
    };
  },
  template: `
    <div class="columns row">
      <div class="column is-1" style="text-align:left; margin-left:10px;">{{index + 1}}</div>
      <div class="column is-3" style="text-align:left;">次回作業指示</div>
      <template>
      <div class="column" style="text-align:left; margin-left:10px;">
        <b-field
          label
          labelPosition="on-border"
        >
          <b-input
            expanded
            type="textarea"
            name="nextDirection"
            v-model="nextDirectionValue"
            size="is-small"
            data-vv-as="次回作業指示"
            v-validate="'max:256'"
            maxlength="256"
          ></b-input>
        </b-field>
      </div>
      </template>
    </div>
  `
};

const otherWorkCompTemplate = {
  props: ["otherWork"],
  data() {
    var otherWorkValue = this.otherWork;
    return {
      otherWorkValue
    };
  },
  template: `
    <div style="detailArea">
      <div>
        <table class="table" style="width: 100%;">
          <tr style="font-size: 16px;">
            <td style="width: 170px;">点検外作業内容</td>
            <td>
              <b-field
                :type="{'is-danger': errors.has('otherWork')}"
                :message="errors.first('otherWork')"
              >
                <b-input
                  type="textarea"
                  placeholder="点検外の作業が発生してた場合に記入してください。"
                  v-model="otherWorkValue"
                  :name="otherWork"
                  data-vv-as="点検外作業内容"
                  v-validate="'max:512'"
                  maxlength="512"
                ></b-input>
             </b-field>
            </td>
          </tr>
        </table>
      </div>
    </div>
  `
};
const TextItemsTemplate = {
  props: ["itemName"],
  data() {
    var itemNameValue = this.itemName;
    return {
      itemNameValue
    };
  },
  template: `
    <td>
      <b-field
        label
        labelPosition="on-border"
      >
        <b-input
          name="department"
          expanded
          v-model="itemNameValue"
        ></b-input>
      </b-field>
    </td>
  `
};

const InspectionSpanItemsTemplate = {
  props: ["inspectionSpan", "subscript"],
  methods: {
    inputValue() {
      this.$parent.$parent.$parent.data[
        this.subscript
      ].CTERM = this.inspectionSpanValue;

      const shoumouList = this.$parent.$parent.$parent.data[this.subscript].regularDisposablesProduct[0].shoumouList;
      for (const shoumou of shoumouList) {
        if (shoumou.deliveryKindFlag == 1 &&
            !shoumou.oldDeliveryMonth &&
            this.inspectionStatus == inspectionUtil.INSPECTION_STATUS_MAP.underInspection.code &&
            !shoumou.addFlg) {
          shoumou.oldDeliveryMonth = shoumou.nextDate;
        }
      }
    }
  },
  data() {
    var inspectionSpanValue = this.inspectionSpan;
    var subscriptValue = this.subscript;
    var name = "CTERM" + subscriptValue;
    return {
      inspectionSpanValue,
      subscriptValue,
      name
    };
  },
  template: `
    <td>
      <b-field
        label
        labelPosition="on-border"
        :type="{'is-danger':errors.has(name)}"
        :message="errors.first(name)"
      >
        <b-input
          :name="name"
          expanded
          v-model="inspectionSpanValue"
          type="number"
          :input="inputValue()"
          data-vv-as="点検期間"
          v-validate="'required|max:3|minValue_1'"
        ></b-input>
      </b-field>
    </td>
  `
};

const dayjs = require('dayjs');

import prescriptionHistoryModal from "./AppPrescriptionHistoryModal";
import { truncate } from 'fs';

import * as inspectionUtil from "../utils/inspection"

export default {
  name: "AppInspectionExecute",
  computed: {
    cancelButtonName: function () {
      const name = this.$route.params.isDealer ? "点検登録中断" : "点検中断"
      return name;
    },

    completeButtonName: function () {
      const name = this.$route.params.isDealer ? "点検登録完了" : "点検完了"
      return name;
    },
  },

  methods: {
    getSerial: function(inspectionItem) {
      var serial = inspectionItem.serialNumber;
      if (inspectionItem.machineReplaceSerialNumber) {
        serial = inspectionItem.machineReplaceSerialNumber;
      }
      return serial;
    },
    getNextInspection: function(item, isChangeFlg) {
      // リースアップ ＋ 機械交換時
      if (item.inspectionOrder != 3) {
        var displayDate = this.getNextInspectionDate(
          this.inspectionDate,
          Number(item.CTERM),
          item.LTDAT,
          item.nextMaintenanceDate,
          false
        );
        if (displayDate) {
          displayDate = this.formatDate2(displayDate.date);
          return isChangeFlg ? displayDate.slice(0, 7) : displayDate;
        } else {
          return "";
        }
      } else if (item.machineReplaceProductCode != "") {
        var displayDate = this.formatDate2(
          this.getNextInspectionDate(
            this.inspectionDate,
            Number(item.CTERM),
            item.LTDAT,
            item.nextMaintenanceDate,
            true
          ).date
        );
        return isChangeFlg ? displayDate.slice(0, 7) : displayDate;
      }
    },
    setValue: function(result, subscript, index, flg, displayName) {
      if (this.data[subscript].value[index].value != result) {
        this.$set(this.data[subscript].value[index], "value", result);
        if (flg && this.data[subscript].machineType == 5) {
          var advancedModeList = {
            "動作モード(プリセット1)": [11, 12, 13, 14, 15, 16, 17, 18],
            "動作モード(プリセット2)": [11, 12, 13, 14, 15, 16, 17, 18],
            "動作モード(プリセット3)": [11, 12, 13, 14, 15, 16, 17, 18]
          };
          var targetItemList = advancedModeList[displayName];
          if (result != "3") {
            for (var i in targetItemList) {
              var num = index + targetItemList[i];
              var targetItem = this.$refs.itemvaluecompo.filter(
                value => value.displayOrder == num
              );
              this.$set(this.data[subscript].value[num], "value", "");
              this.$set(targetItem[0], "dataValue", "");
            }
          }
          this.checkDisable(
            this.data[subscript].subContentsValue,
            this.data[subscript].value[index + 1].contentsType,
            subscript,
            this.data[subscript].value[index + 1].displayName,
            this.data[subscript].version
          );
        } else if (flg && this.data[subscript].machineType == 6) {
          // this.$delete(this.mode, subscript);
          this.$set(this.mode, subscript, result);
          var rr = this.getDisplayValue(
            this.data[subscript].machineType,
            this.mode[subscript],
            this.data[subscript].value[8].displayValue,
            this.data[subscript].value[8].displayName
          );
          this.$set(this.data[subscript].value[8], "value", "");
          // this.data[subscript].value[8].value = "";
        }
      }

      if (
        flg &&
        this.data[subscript].machineType == 8 &&
        this.prismaAnotherInputItems[displayName]
      ) {
        var productElement = this.productMaster.find(
          v => v.productCode == result
        );
        this.prismaAnotherInputItems[displayName];
        var targetItem = this.$refs.itemvaluecompo.filter(
          value =>
            value.displayName == this.prismaAnotherInputItems[displayName]
        );
        if (!targetItem) return;
        var dataValue = productElement ? productElement.productName : "";
        this.$set(targetItem[0], "dataValue", dataValue);
      }
    },
    checkValueHot: async function(result, subscript, index, checkNumber, flg) {
      if (this.data[subscript].version > 0) {
        if (this.data[subscript].value[index].value != result || flg) {
          this.$set(this.data[subscript].value[index], "value", result);
          var checkFlg = false;
          var collection = {
            1: ["安静時", "安静時（上限）"],
            2: ["労作時・後", "労作時・後（上限）"],
            3: ["睡眠時", "睡眠時（上限）"],
            4: ["人工呼吸器併用時", "人工呼吸器併用時（上限）"]
          };
          var min = this.data[subscript].value.filter(
            val => val.displayName == collection[checkNumber][0]
          );
          var max = this.data[subscript].value.filter(
            val => val.displayName == collection[checkNumber][1]
          );
          if (
            min.length > 0 &&
            min[0].value &&
            max.length > 0 &&
            max[0].value
          ) {
            if (Number(min[0].value) > Number(max[0].value)) {
              checkFlg = true;
            }
          }
          // エラーセット
          const childitems = this.$refs.itemvaluecompo;
          var cnt = 0;
          for (let i = 0; i < childitems.length; i++) {
            if (cnt == 2) {
              break;
            }
            let tmpitem = childitems[i];
            let fname = tmpitem.fieldName;
            if (fname.split("_")[1] == subscript) {
              if (collection[checkNumber].indexOf(tmpitem.displayName) != -1) {
                tmpitem.checkFlg = checkFlg;
                cnt += 1;
              }
            }
          }
        }
      }
    },
    // prisma 上限下限入力値チェック limitCheck
    limitCheck: async function(result, subscript, index, checkNumber, machineType, flg) {
      if (this.data[subscript].version > 0) {
        if (this.data[subscript].value[index].value != result || flg) {
          this.$set(this.data[subscript].value[index], "value", result);
          var checkFlg = false;
          var collection = {};
          if (machineType == 8) {
            collection = {
              1: ["１回換気量　下限(Prog1)", "１回換気量　上限(Prog1)"],
              2: ["Vti　下限(Prog1)", "Vti　上限(Prog1)"],
              3: ["呼吸回数　下限(Prog1)", "呼吸回数　上限(Prog1)"],
              4: ["MV　下限(Prog1)", "MV　上限(Prog1)"],
              5: ["SpO2　下限(Prog1)", "SpO2　上限(Prog1)"],
              6: ["脈拍数　下限(Prog1)", "脈拍数　上限(Prog1)"]
            };
          }
          var min = this.data[subscript].value.filter(
            val => val.displayName == collection[checkNumber][0]
          );
          var max = this.data[subscript].value.filter(
            val => val.displayName == collection[checkNumber][1]
          );
          if (
            min.length > 0 &&
            min[0].value &&
            max.length > 0 &&
            max[0].value
          ) {
            if (Number(min[0].value) > Number(max[0].value)) {
              checkFlg = true;
            }
          }
          // エラーセット
          const childitems = this.$refs.itemvaluecompo;
          var cnt = 0;
          for (let i = 0; i < childitems.length; i++) {
            if (cnt == 2) {
              break;
            }
            let tmpitem = childitems[i];
            let fname = tmpitem.fieldName;
            if (fname.split("_")[1] == subscript) {
              if (collection[checkNumber].indexOf(tmpitem.displayName) != -1) {
                tmpitem.checkFlg = checkFlg;
                cnt += 1;
              }
            }
          }
        }
      }
    },
    getDisplayValue(machineType, mode, displayValue, name) {
      var val = JSON.parse(JSON.stringify(displayValue));
      if (machineType == 6) {
        if (name == "シンプリーゴー設定値" && mode != "") {
          switch (mode + "") {
            case "1":
              val = val.filter(n => parseFloat(n.value) <= 2);
              break;
            case "2":
            case "3":
              val.some(function(v, i) {
                if (parseFloat(v.value) == 0.5) val.splice(i, 1); //要素を削除
              });
              break;
          }
        }
      }
      return val;
    },
    checkDisable: function(
      subContentsValue,
      contentsType,
      index,
      displayName,
      version
    ) {
      switch (this.data[index].machineType) {
        case 4:
          if (
            version != 0 &&
            (!contentsType ||
              contentsType == 1 ||
              !subContentsValue ||
              (subContentsValue &&
                subContentsValue.indexOf(contentsType + "") != -1))
          ) {
            var advancedList = Object.keys(this.cuffAssistAdvancedItems);
            var targetName = displayName;
            var no = -1;
            var no = targetName.indexOf("(");
            if (no != -1) {
              // 「(」以前でトリミング
              targetName = targetName.substring(0, no);
            }
            if (advancedList.indexOf(targetName) != -1) {
              // アドバンス自動選択時のみ活性項目の場合
              var self = this.data[index].value.filter(
                value => value.displayName == displayName
              );

              // 対象項目から「動作モード」までのoffsetを取得
              var item = this.cuffAssistAdvancedItems[targetName];
              if (item) {
                var target = this.data[index].value.filter(
                  value => value.displayOrder == self[0].displayOrder - item
                );
                if (target[0].value != "3") {
                  return true;
                }
              }
            }
            return false;
          }
          return true;
          break;
        case 6:
          if (this.inspectionItemSerial.indexOf(displayName) == -1) {
            return false;
          }
          return true;
          break;
        case 7:
          if (
            !contentsType ||
            contentsType == 1 ||
            !subContentsValue ||
            (subContentsValue &&
              subContentsValue.indexOf(contentsType + "") != -1)
          ) {
            var self = this.data[index].value.filter(
              value => value.displayName == displayName
            );
            switch (displayName) {
              default:
                return false;
                break;
            }
            if (target[0].value == "0") {
              return true;
            }
            return false;
          }
          return true;
          break;
        case 11:
          if (
            version != 0 &&
            (!contentsType ||
              contentsType == 1 ||
              !subContentsValue ||
              (subContentsValue &&
                subContentsValue.indexOf(contentsType + "") != -1))
          ) {
            var cuffAssist2List = Object.keys(this.cuffAssist2Items);
            var cuffAssist2NotPercussorList = Object.keys(this.cuffAssist2NotPercussorItems);
            var targetName = displayName;
            var no = -1;
            var no = targetName.lastIndexOf("(");
            if (no != -1) {
              // 「(」以前でトリミング
              targetName = targetName.substring(0, no);
            }
            if (cuffAssist2List.indexOf(targetName) != -1) {
              // パーカッサー選択時のみ非活性項目の場合
              var self = this.data[index].value.filter(
                value => value.displayName == displayName
              );

              // 対象項目から「動作モード」までのoffsetを取得
              var item = this.cuffAssist2Items[targetName];
              if (item) {
                var target = this.data[index].value.filter(
                  value => value.displayOrder == self[0].displayOrder - item
                );
                if (target[0].value == "3") {
                  return true;
                }
              }
            }
            if (cuffAssist2NotPercussorList.indexOf(targetName) != -1) {
              // 自動、手動選択時のみ非活性項目の場合
              var self = this.data[index].value.filter(
                value => value.displayName == displayName
              );

              // 対象項目から「動作モード」までのoffsetを取得
              var item = this.cuffAssist2NotPercussorItems[targetName];
              if (item) {
                var target = this.data[index].value.filter(
                  value => value.displayOrder == self[0].displayOrder - item
                );
                if (target[0].value == "1" || target[0].value == "2") {
                  return true;
                }
              }
            }
          }
          return false;
          break;
        default:
          if (
            version != 0 &&
            (!contentsType ||
              contentsType == 1 ||
              !subContentsValue ||
              (subContentsValue &&
                subContentsValue.indexOf(contentsType + "") != -1))
          ) {
            return false;
          }
          return true;
          break;
      }
    },
    checkRequired: function(
      productCode,
      machineType,
      type,
      sapFlg,
      requireFlg,
      prescription,
      subContentsValue,
      contentsType,
      diaplayOrder,
      fieldName,
      displayName,
      index,
      requiredcheck
    ) {
      var ret = true;
      var checkFlag = false;
      switch (machineType) {
        case 4:
        case 5:
          // トリロジー,カフアシスト
          if (
            !contentsType || // 点検項目種別がない
            contentsType == 1 || // 共通項目
            (subContentsValue && // 副設定項目に含まれている
              subContentsValue.indexOf(contentsType + "") != -1)
          ) {
            checkFlag = true;
          }
          break;
        case 6:
          // HOT
          var hot =
            Object.keys(this.portableTypeCode).indexOf(productCode) == -1
              ? 1
              : this.portableTypeCode[productCode];
          if (
            !contentsType || // 点検項目種別がない
            hot == 1 || // HOT(設置型)
            this.hotTypeRange[0] == 3 || // HOT(ｼﾝﾌﾟﾘｰｺﾞｰのみ)
            (this.hotIndividual.indexOf(contentsType) != -1 &&
              this.portableCommonOrder.indexOf(diaplayOrder) == -1) || //HOTの個別点検項目
            (hot == 2 && this.hotTypeRange[0] != 1) || // 自身が「ｼﾝﾌﾟﾘｰｺﾞｰﾐﾆ」で、同点検内に「設置型」が存在しない
            (hot == 2 && contentsType == 6) || // 自身が「ｼﾝﾌﾟﾘｰｺﾞｰﾐﾆ」で、点検項目が「ｺﾞｰﾐﾆ/ｺﾞｰ」の共通項目
            (hot == 3 &&
              contentsType == 6 &&
              this.hotTypeRange.indexOf(2) == -1) || // 自身が「ｼﾝﾌﾟﾘｰｺﾞｰ」で同点検内に「ｺﾞｰﾐﾆ」が存在しないかつ、点検項目が「ｺﾞｰﾐﾆ/ｺﾞｰ」の共通項目
            (hot == 3 && contentsType == 5 && this.hotTypeRange[0] != 1) // 自身が「ｼﾝﾌﾟﾘｰｺﾞｰ」で同点検内に「設置型」が存在しないかつ、点検項目が「設置型/ｺﾞｰ」の共通項目
          ) {
            checkFlag = true;
          }
          break;
        case 7:
          checkFlag = true;
          break;
        default:
          // HOT,トリロジー,カフアシスト以外は無条件にチェックする
          checkFlag = true;
          break;
      }
      if (checkFlag) {
        if (sapFlg) {
          // SAP項目の場合
          if (type == "char" && prescription != null) {
            prescription = prescription.replace(/\./g, "").replace(/0/g, "");
          }
          if (
            prescription == "" ||
            prescription == null ||
            prescription == "null" ||
            this.checkList.indexOf(fieldName) != -1
          ) {
            // 処方値が「0」「空白」でない場合、必須
            if (!requireFlg) {
              // 必須項目フラグがTRUEの場合、必須
              ret = false;
            }
          }
        } else {
          // SAP項目以外の場合
          if (!requireFlg) {
            // 必須項目フラグがTRUEの場合、必須
            ret = false;
          }
        }
      } else {
        ret = false;
      }

      // 未入力チェックボックスが押されている項目の必須項目を外す
      var result = this.checkList.filter(function(item) {
        return item == fieldName;
      });
      if (result == fieldName) {
        ret = false;
      }

      return ret;
    },
    closeModal: function() {
      this.oldSerialNumber = "";
      this.productNumber = "";
    },
    getSelectValue(displayValue, prescription) {
      if (!prescription) {
        return "";
      }

      var value = "";
      for (var i in displayValue) {
        if (displayValue[i].key === prescription) {
          value = displayValue[i].value;
        }
      }
      return value;
    },
    setDisposablesData(items, index) {
      this.$set(this.data[index], "regularDisposablesProduct", items);
      this.teikishoumouData = {
        disposablesByDevice: "",
        interval: null,
        index: null
      };
    },
    setSubData(returnItems, subscript, checks) {
      this.checkList = checks;
      var targetData = this.data[subscript].value.filter(
        val => val.contentsType != 1
      );
      var setItem = returnItems.value.filter(val => val.contentsType != 1);
      for (var i in targetData) {
        if (setItem[i].value) {
          targetData[i].value = setItem[i].value;
        }
      }
    },
    setDelivery(returnItems) {
      // 発送指示
      var deliveryHistory = [];
      if (returnItems.length != 0) {
        // 発送できる消耗品情報が存在するときのみ処理
        for (var i = 0; i < returnItems.length; i++) {
          var productName = this.getProductName(
            returnItems[i].productCode,
            this.productMaster
          );
          var today = new Date();
          today = this.formatDate(today);
          var history = {
            date: today,
            productCode: returnItems[i].productCode,
            count: parseInt(returnItems[i].count),
            deliveryDate: returnItems[i].deliveryDate,
            productName: productName,
            staffCode: this.staffCode,
            staffName: this.staffName,
            officeCode: this.officeCode,
            officeName: this.officeName,
            patientCode: this.patientCode,
            patientName: this.patientName
          };
          deliveryHistory.push(history);
        }
        for (var index in this.data) {
          var code;
          if (this.data[index].machineReplaceProductCode) {
            code = this.data[index].machineReplaceProductCode;
          } else {
            code = this.data[index].productCode;
          }
          if (code == returnItems[0].code) {
            this.data[index].deliveryHistory = deliveryHistory;
            break;
          }
        }
      }
    },
    inputRadioValue(subscript, index, result, fieldName) {
      this.data[subscript].value[index].value = result;
      // エラーリセット
      this.errors.remove(fieldName);
    },
    sortedItemsByDisplayOrder(value) {
      // displayOrderでソート
      return value.sort((a, b) => {
        return a.displayOrder < b.displayOrder
          ? -1
          : a.displayOrder > b.displayOrder
          ? 1
          : 0;
      });
    },
    checkNotOther(data) {
      var flg = true;
      if (Object.keys(data).indexOf("otherWork") !== -1) {
        // 点検外作業
        flg = false;
      }
      return flg;
    },
    copy(val, subscript, index, fieldName) {
      if (!document.getElementById(val).control.checked) {
        if (
          this.data[subscript].value[index].prescription != "-" &&
          this.data[subscript].value[index].prescription != "" &&
          this.data[subscript].value[index].prescription != null &&
          this.data[subscript].value[index].prescription != "null"
        ) {
          // エラーリセット
          this.errors.remove(fieldName);
          this.data[subscript].value[index].value = this.data[subscript].value[
            index
          ].prescription;
        }
      }
    },
    regist: function() {
      // 定期消耗品のチェック
      if (this.checkDisposablesOrder()) {
        var excuteApi = this.saveTempInspectionPOST;
        var successCallBack = this.saveTempInspectionPOSTSuccess;
        var errorCallBack = this.saveTempInspectionPOSTError;
        // WebAPI Call
        return this.apiCall(excuteApi, successCallBack, errorCallBack);
      } else {
        // エラーメッセージ表示
        this.showErrorMessage(
          "発送期間が1カ月の消耗品は発送できません。<br>" +
            "消耗品発送登録ボタンから消耗品発送登録画面に遷移して、<br>" +
            "発送のチェックを外して登録してください。"
        );
        return;
      }
    },
    check() {
      // 子要素の点検入力データをdataに更新する（性能改善で子コンポーネント化したことによりバインディングが切れるため）
      const childitems = this.$refs.itemvaluecompo;
      for (let i = 0; i < childitems.length; i++) {
        let tmpitem = childitems[i];
        tmpitem.letsValidate();
      }
      this.$validator.validateAll();
    },
    subContentsInspection(index, type) {
      // OK/NGのデフォルト設定（OK）
      for (const col of this.data[index].value) {
        if (col.contentsType == type && col.type == "radio" && !col.value) {
          col.value = "0";
        }
      }

      this.targetContentsType = type;
      this.isSubContentsModalActive = true;
    },
    async subContentsChecked(index, target) {
      this.targetContents = [];
      this.target = target + "";
      if (this.data[index].subContentsValue.indexOf(this.target) == -1) {
        this.targetContents.push(
          "■下記の項目には処方値があります。必須項目を外しても問題ないですか？"
        );
        // チェックOFFの場合
        // 副項目の処方値チェック処理
        for (let i = 0; i < this.data[index].value.length; i++) {
          var ret = false;
          if (this.data[index].value[i].contentsType == target) {
            if (this.data[index].value[i].sap) {
              // SAP項目の場合
              ret = true;
              var prescription = this.data[index].value[i].prescription;
              if (
                this.data[index].value[i].type == "char" &&
                prescription != null
              ) {
                prescription = this.data[index].value[i].prescription
                  .replace(/\./g, "")
                  .replace(/0/g, "");
              }
              if (
                prescription == "" ||
                prescription == null ||
                prescription == "null"
              ) {
                // 処方値が「0」「空白」でない場合、メッセージ表示
                ret = false;
              }
            }
            if (ret) {
              this.targetContents.push(
                "No." +
                  this.data[index].value[i].displayOrder +
                  " 項目名：" +
                  this.data[index].value[i].displayName
              );
            }
          }
        }
        if (this.targetContents.length != 1) {
          this.isSubContentsChangeModalActive = true;
        } else {
          await this.subContentsChanged(index, true);
        }
      } else {
        // チェックONの場合
        await this.subContentsChanged(index, true);
      }
    },
    subContentsChanged: function(index, bool) {
      let list = this.data[index].subContentsValue;
      for (let m in this.data[index].subContentsValue) {
        this.$set(list, m, this.data[index].subContentsValue[m]);
      }
      if (!bool) {
        // キャンセル選択時、リストにtargetを含む
        this.$set(list, list.length, this.target);
      } else {
        let target = Number(this.target);
        const childitems = this.$refs.itemvaluecompo;
        for (let i = 0; i < childitems.length; i++) {
          let tmpitem = childitems[i];
          let dname = tmpitem.displayName;
          let fname = tmpitem.fieldName;
          let index1 = parseInt(fname.split("_")[1]);
          if (index == index1 && tmpitem.contentsType == target) {
            tmpitem.dataValue = "";
            if (
              fname.indexOf("radio") == -1 &&
              dname.indexOf("特記事項") == -1
            ) {
              document.getElementById(fname + "_check").control.checked = false;
              //副項目の未入力チェックボックスのチェックを外す
              document.getElementById(
                fname + "_check2"
              ).control.checked = false;
              this.checkList = this.checkList.filter(function(item) {
                return item != fname;
              });
              tmpitem.checker = false;
            }
          }
        }
      }
      this.data[index].subContentsValue = [];
      // リスト中身入れ替え(バインド用)
      for (let n in list) {
        this.$delete(this.data[index].subContentsValue, n);
        this.$set(this.data[index].subContentsValue, n, list[n]);
      }
      // バリデーションエラーリセット処理
      const childitems = this.$refs.itemvaluecompo;
      for (let i = 0; i < childitems.length; i++) {
        let tmpitem = childitems[i];
        let fname = tmpitem.fieldName;
        tmpitem.letsValidate().then(validatorResult => {
          tmpitem.errors.remove(fname);
        });
      }
      this.target = null;
    },
    inputSign: function() {
      // Loading:START
      this.appVue.loadingStart();
      setTimeout(this.inputSignRunMethod, 100);
    },

    cancel: async function() {
      const comfirmCancel = await this.showComfirmMessage("取り消しを行うと、元に戻すことはできません。\n取り消しを行いますか？");
      if (!comfirmCancel) {
        return;
      }

      this.apiCall(this.setAppointmentStatus, this.setAppointmentStatusSuccess, this.showErrorMessage);
      return;
    },

    setAppointmentStatus: async function(client) {
      const res = await client.apis.apiAppointment.setAppointmentStatusPOST({
        body: {
          appointmentCode: this.appointmentCode,
          status: inspectionUtil.INSPECTION_STATUS_MAP.cancel.code,
        }
      });
      return res;
    },

    setAppointmentStatusSuccess: function(result) {
      this.showSuccess(result);
      this.doReturn();
      return;
    },

    inputSignRunMethod: async function() {
      try {
        await this.inputSignValidate();
        // Loading:END
        this.appVue.loadingEnd();
      } catch (err) {
        // Loading:END
        this.appVue.loadingEnd();
        console.log(err);
        // エラーメッセージ表示
        scrollTo(0, 0);
        // エラーメッセージ表示
        this.showErrorMessage("システムエラーが発生しました。");
      }
    },
    getTabTitle: function(inspectionItem) {
      let tabTitle = "";
      if (inspectionItem.machineReplaceSerialNumber) {
        const productElement = this.productMaster.find(v => v.productCode == inspectionItem.machineReplaceProductCode);
        tabTitle += (productElement ? productElement.productName : "");
        tabTitle += "(" + inspectionItem.machineReplaceSerialNumber + ")";
      } else {
        tabTitle += inspectionItem.productName;
        tabTitle += "(" + inspectionItem.serialNumber + ")";
      }

      return tabTitle;
    },
    getContentsTypeTitle: function(inspectionItem, contentsType) {
      let contentsTypeTitle = "";

      switch (inspectionItem.machineType) {
        case inspectionUtil.MACHINE_TYPE.TRILOGY_EVO.code:
          contentsTypeTitle = "設定" + contentsType;
          break;
        case inspectionUtil.MACHINE_TYPE.PRISMA.code:
          contentsTypeTitle = "Prog" + contentsType;
          break;
        case inspectionUtil.MACHINE_TYPE.COUGH_ASSIST2.code:
          contentsTypeTitle = "プリセット" + contentsType;
          break;
        case inspectionUtil.MACHINE_TYPE.LUISA.code:
          contentsTypeTitle = contentsType == 1 ? "共通項目" : "プログラム" + (contentsType - 1);
          break;
        case inspectionUtil.MACHINE_TYPE.CW2.code:
          contentsTypeTitle = contentsType == 1 ? "共通項目" : "プロファイル" + (contentsType - 1);
          break;
      }

      return contentsTypeTitle;
    },
    inputSignValidate: async function() {
      // 子要素の点検入力データをdataに更新する（性能改善で子コンポーネント化したことによりバインディングが切れるため）
      let result = true;
      this.totalResult = true;
      const childitems = this.$refs.itemvaluecompo;
      for (let i = 0; i < childitems.length; i++) {
        let tmpitem = childitems[i];
        var tmpItemValidate = await tmpitem.letsValidate();
        result = result && tmpItemValidate;
        let fname = tmpitem.fieldName;

        // if (!childitems[i].fields[fname].validated) {
        //   result = false;
        // }

        let nval = tmpitem.value;
        let index1 = parseInt(fname.split("_")[1]);
        let index2 = parseInt(fname.split("_")[2]) - 1; // index2は1始まりのため-1する
        var value = tmpitem.dataValue;
        if(fname.indexOf("input") != -1){
          await tmpitem.inputValue(value, tmpitem.machineType, true);
        }

        if(fname.indexOf("sel") != -1){
          var target = tmpitem.displayValue.find(val => val.key==value)
          value = target ? value : "";
        }

        if (tmpitem.isDisabled == "true") {
          // 非活性項目の場合
          value = "";
        }
        this.data[index1].value[index2].isDisabled = tmpitem.isDisabled;

        if (
          tmpitem.machineType == 4 &&
          tmpitem.displayName.indexOf("治療前呼吸") != -1
        ) {
          // 半角変換
          value = value.replace(/[！-～]/g, function(input) {
            return String.fromCharCode(input.charCodeAt(0) - 65248);
          });
          // 大文字変換
          value = value.toUpperCase();
        }
        //プリズマの場合
        if (
          tmpitem.machineType == 8 &&
          this.prismaAnotherInputItems[tmpitem.displayName]
        ) {
          var productElement = this.productMaster.find(
            v => v.productCode == value
          );
          var targetItem = this.$refs.itemvaluecompo.filter(
            tValue =>
              tValue.displayName ==
              this.prismaAnotherInputItems[tmpitem.displayName]
          );
          this.data[index1].value[index2].value = value;
          index2++;
          i++;
          var dataVal = productElement ? productElement.productName : "";
          this.data[index1].value[index2].value = dataVal;
        } else {
          this.data[index1].value[index2].value = value;
        }
      }

      // 点検期間
      const spanItems = this.$refs.inspectionSpan;
      for (let j = 0; j < spanItems.length; j++) {
        var value = spanItems[j].inspectionSpanValue;
        // 点検期間がnull or 桁数が3より大きい時 or 空の場合 or 期間が1より小さいとき or 期間が負の場合はエラーメッセージを表示
        if (
          value == null ||
          value.length > 3 ||
          value == "" ||
          Number(value) < 1 ||
          Math.sign(value) == -1
        ) {
          spanItems[j].$validator.errors.add({
            field: "CTERM" + j,
            msg:
              "点検期間は必須項目です。</br>1以上、3桁以内で入力してください。"
          });
          this.showErrorMessage(
            "点検期間は必須項目です。</br>1以上、3桁以内で入力してください。"
          );
          return;
        }
      }

      // 点検実施日、委託担当者（ディーラー点検時のみ）
      if (this.$route.params.isDealer) {
        const inspectionDate = this.$refs.inspectionDate;
        for (let j = 0; j < inspectionDate.length; j++) {
          const value = inspectionDate[j].dateSelected;
          if (!value) {
            inspectionDate[j].$validator.errors.add({
              field: "inspectionDate" + j,
              msg:
                "点検実施日は必須項目です。"
            });
            this.showErrorMessage(
              "点検実施日は必須項目です。"
            );
            return;
          }
        }
        const trustStaff = this.$refs.trustStaff;
        for (let j = 0; j < trustStaff.length; j++) {
          const value = trustStaff[j].itemNameValue;
          if (!value) {
            trustStaff[j].$validator.errors.add({
              field: "trustStaff" + j,
              msg:
                "委託担当者は必須項目です。"
            });
            this.showErrorMessage(
              "委託担当者は必須項目です。"
            );
            return;
          }
        }
      }

      for (const inspectionItem of this.data) {
        if (inspectionItem.productCode) {
          let subContentsName;
          switch (inspectionItem.machineType) {
            case 12:
              subContentsName = "プログラム";
              break;
            case 17:
              subContentsName = "プロファイル";
              break;
          }
          const subContentsValue = inspectionItem.subContentsValue.find((elem) => !!elem);
          if (subContentsName && !subContentsValue) {
            this.showErrorMessage(
              inspectionItem.productName + "は、1つ以上の" + subContentsName + "の設定が必要です。"
            )
            return;
          }
        }
      }

      // 点検完了
      // var isCheckAll = false;
      // 必須チェック(副項目)
      var isErrorRequired = false;
      // 入力値チェック(副項目)
      var isErrorValid = false;
      // チェック結果エラーメッセージ(副項目)
      // var ErrorMsg = "";
      var isDisposableError = false;
      var now = new Date();
      const errorTabs = [];
      multiple_loop: for (var index = 0; index < this.data.length; index++) {
        if (Object.keys(this.data[index]).indexOf("otherWork") == -1) {
          const title = this.getTabTitle(this.data[index]);
          const errorTab = {
            title: title,
            contentsTypeTitles: [],
          };
          errorTabs.push(errorTab);

          for (
            var subIndex = 0;
            subIndex < this.data[index].value.length;
            subIndex++
          ) {
            // 副項目の入力チェック用フラグ
            var ret = true;
            // 全ての変更値(value)に値が入っていることを確認
            // if (this.data[index].value[subIndex].value !== "") {
            //   isCheckAll = false;
            // }

            // 下記の場合、副項目の点検値をチェック
            // 器械種別：トリロジーEvo、プリズマ、カフⅡ
            
            // 副項目設定ありが1つ以上
            // sap=TRUE OR required=TRUE
            if (
              (this.data[index].machineType == 7 ||
                this.data[index].machineType == 8 || 
                this.data[index].machineType == 11 ||
                this.data[index].machineType == 12 ||
                this.data[index].machineType == 17) &&
              this.data[index].subContentsValue.length > 0 &&
              this.data[index].subContentsValue.indexOf(
                String(this.data[index].value[subIndex].contentsType)
              ) != -1
            ) {
              switch (true) {
                default:
                  if (this.data[index].value[subIndex].sap) {
                    var pre = this.data[index].value[subIndex].prescription;
                    // SAP項目の場合
                    if (this.data[index].value[subIndex].type == "char") {
                      if (this.data[index].value[subIndex].value) {
                        // バリデーションチェック
                        var regex = RegExp(
                          this.data[index].value[subIndex].validationRule
                        );
                        if (
                          !regex.test(this.data[index].value[subIndex].value)
                        ) {
                          // エラー時
                          isErrorValid = true;
                          const contentsTypeTitle = this.getContentsTypeTitle(this.data[index], this.data[index].value[subIndex].contentsType);
                          if (!errorTab.contentsTypeTitles.includes(contentsTypeTitle)) errorTab.contentsTypeTitles.push(contentsTypeTitle);
                          continue;
                        }
                      }
                      if (
                        this.data[index].value[subIndex].prescription != null
                      ) {
                        pre = pre.replace(/\./g, "").replace(/0/g, "");
                      }
                    }
                    if (pre == "" || pre == null || pre == "null") {
                      // 処方値が「0」「空白」でない場合、必須
                      ret = false;
                    }
                  } else if (!this.data[index].value[subIndex].required) {
                    // SAP項目以外かつ、必須フラグ=FALSEの場合
                    ret = false;
                  }
                  break;
              }

              // 必須項目
              if (ret) {
                switch (this.data[index].value[subIndex].type) {
                  case "char":
                    // checkListチェック
                    var targetName = this.getInputFieldName(
                      index,
                      subIndex + 1
                    );
                    var check = this.checkList.filter(function(item) {
                      return item == targetName;
                    });
                    if (check.length == 0) {
                      if (
                        this.data[index].value[subIndex].value == "" ||
                        this.data[index].value[subIndex].value == null
                      ) {
                        isErrorRequired = true;
                        const contentsTypeTitle = this.getContentsTypeTitle(this.data[index], this.data[index].value[subIndex].contentsType);
                        if (!errorTab.contentsTypeTitles.includes(contentsTypeTitle)) errorTab.contentsTypeTitles.push(contentsTypeTitle);
                        continue;
                      }
                    }
                    break;
                  case "sel":
                    // checkListチェック
                    var targetName = this.getSelectFieldName(
                      index,
                      subIndex + 1
                    );
                    var check = this.checkList.filter(function(item) {
                      return item == targetName;
                    });
                    if (check.length == 0) {
                      if (
                        this.data[index].value[subIndex].value == "" ||
                        this.data[index].value[subIndex].value == null
                      ) {
                        isErrorRequired = true;
                        const contentsTypeTitle = this.getContentsTypeTitle(this.data[index], this.data[index].value[subIndex].contentsType);
                        if (!errorTab.contentsTypeTitles.includes(contentsTypeTitle)) errorTab.contentsTypeTitles.push(contentsTypeTitle);
                        continue;
                      }
                    }
                    break;
                  case "radio":
                    // 必須チェック
                    if (
                      this.data[index].value[subIndex].value == "" ||
                      this.data[index].value[subIndex].value == null
                    ) {
                      isErrorRequired = true;
                      const contentsTypeTitle = this.getContentsTypeTitle(this.data[index], this.data[index].value[subIndex].contentsType);
                      if (!errorTab.contentsTypeTitles.includes(contentsTypeTitle)) errorTab.contentsTypeTitles.push(contentsTypeTitle);
                      continue;
                    }
                    break;
                }

                if (
                  this.data[index].value[subIndex].type == "char" &&
                  this.data[index].value[subIndex].value
                ) {
                  // バリデーションチェック
                  var regex = RegExp(
                    this.data[index].value[subIndex].validationRule
                  );
                  if (!regex.test(this.data[index].value[subIndex].value)) {
                    // エラー時
                    isErrorValid = true;
                    const contentsTypeTitle = this.getContentsTypeTitle(this.data[index], this.data[index].value[subIndex].contentsType);
                    if (!errorTab.contentsTypeTitles.includes(contentsTypeTitle)) errorTab.contentsTypeTitles.push(contentsTypeTitle);
                    continue;
                  }
                }
              }
              this.data[index].value[subIndex].isDisabled = "false";
            } else if (
              (this.data[index].machineType == 7 ||
                this.data[index].machineType == 8) &&
              this.data[index].value[subIndex].contentsType != 1 &&
              (this.data[index].subContentsValue.length == 0 ||
                (this.data[index].subContentsValue.length > 0 &&
                  this.data[index].subContentsValue.indexOf(
                    String(this.data[index].value[subIndex].contentsType)
                  ) == -1))
            ) {
              this.data[index].value[subIndex].value = "";
              this.data[index].value[subIndex].isDisabled = "true";
            }
          }

          // 前回供給日、次回供給予定日、発送期間のセット
          for (var i = 0; i < this.data[index].regularDisposablesProduct[0].shoumouList.length; i++) {
            var target = this.data[index].regularDisposablesProduct[0].shoumouList[i];
            if (target.deleteFlg) {
              // 削除済みの行は対象外
              continue;
            }
            target.count = target.count ? target.count : 0
            var interval = this.data[index].CTERM;
            var year = parseInt(interval / 12);
            var month = parseInt(interval % 12);
            // 次回供給予定日
            var nextDate;
            // 対象月(前回供給日+期間)の月初日
            var targetFirstDay = new Date(
              Number(now.getFullYear() + year),
              Number(now.getMonth() + month),
              1
            );
            var targetLastDay = this.parseDate(
              this.getMonthLastDay(targetFirstDay)
            );

            if (targetLastDay.getDate() >= now.getDate()) {
              // 対象月(次回供給日+期間)の月末日が次回供給予定の日以上
              // そのまま設定
              nextDate = this.formatDate2(
                new Date(
                  Number(now.getFullYear()) + year,
                  Number(now.getMonth()) + month,
                  now.getDate()
                )
              );
            } else {
              // 対象月(次回供給日+期間)の月末日が次回供給予定の日より小さい
              // 対象月の月末日を設定
              nextDate = this.formatDate2(targetLastDay);
            }

            // 消耗品発送登録データチェック
            if (target.regularDeliveryFlag && target.interval <= 1) {
              // 発送フラグがTrueかつ、期間が「1」以下の場合
              isDisposableError = true;
              break multiple_loop;
            }
            if (target.deliveryKindFlag == 1) {
              target.preDate = this.formatDate2(now);
              target.nextDate = nextDate;
              target.interval = Number(interval);
            }
          }
        }
      } // multiple_loop END

      if (isDisposableError) {
        // エラーメッセージ表示
        this.showErrorMessage(
          "発送期間が1カ月の消耗品は発送できません。<br>" +
            "消耗品発送登録ボタンから消耗品発送登録画面に遷移して、<br>" +
            "発送のチェックを外して登録してください。"
        );
        return;
      }
      // if (isCheckAll) {
      //   // エラーメッセージ表示
      //   this.showErrorMessage(
      //     "未点検項目が存在します。<br>「レ点」にチェック もしくは「変更値」を入力してください。"
      //   );
      //   return;
      // }
      result = result && (await this.$validator.validateAll());
      if (isErrorRequired || isErrorValid || !result) {
        const errorTabIndexSet = new Set();
        for (const item of this.errors.items) {
          const fieldParts = item.field.split("_");
          if (!isNaN(Number(fieldParts[1]))) {
            errorTabIndexSet.add(Number(fieldParts[1]));
          }
        }

        for (const errorTabIndex of errorTabIndexSet.values()) {
          const contentsTypeTitle = this.getContentsTypeTitle(this.data[errorTabIndex], 1);
          errorTabs[errorTabIndex].contentsTypeTitles.unshift(contentsTypeTitle);
        }

        // エラーメッセージ表示
        scrollTo(0, 0);
        // エラーメッセージ表示
        let message = "「変更値」に値が入っていないか、入力に誤りがあります。<br>「変更値」を再確認してください。<br><br>";
        for (const errorTab of errorTabs) {
          if (errorTab.contentsTypeTitles.length) {
            message += "<li>" + errorTab.title + "<br>" + errorTab.contentsTypeTitles.join(", ") + "</li>"
          }
        }
        this.showErrorMessage(
          message
        );
        return;
      }
      // result.then(validatorResult => {
      if (result && this.totalResult) {
        this.messageFlg = false;
        this.checkMachineReplace = true;
        this.pause = false;
        this.regist().then(async result => {
          this.checkMachineReplace = false;
          if (this.compleateFlg) {
            // 点検中断API完了
            //GPSでの緯度経度取得
            // see@ https://www.tutorialsplane.com/vue-js-get-geolocation/
            if (navigator.geolocation && !this.$route.params.isDealer) {
              try {
                // Promiseで結果を待ち受ける
                await this.getEndPosition();
              } catch (err) {
                console.log(err);

                // 取得拒否：警告あり、点検不可
                if (err == this.PERMISSION_DENIED) {
                  this.showErrorMessage(
                    "位置情報の取得に失敗しました。<br>設定を確認して、再度実行してください。"
                  );
                  return;
                }
                // 以下、取得拒否以外のエラー処理
                // 情報必須：警告あり、点検継続
                if (this.$route.params.locationRequired) {
                  this.showErrorMessage(
                    "位置情報の取得に失敗しました。"
                  );
                }
              }
            }
            // 画面トップにスクロール
            scrollTo(0, 0);
            this.compleateFlg = false;

            // ディーラー点検の場合は、警告・署名スキップ
            if (this.$route.params.isDealer) {
              await this.inspectionComplete(null, null, null, true);
              return;
            }

            this.EvoWarningflag = true;
          }
        });
      }
      // });
    },
    doReturn: function(event) {
      // 予約一覧に戻る
      this.$router.push({
        name: this.$route.params.transitionSrc ? this.$route.params.transitionSrc : "AppAppointmentSearch",
        params: { searchConditions: this.searchConditions }
      });
    },
    regulardisposablesOrder(
      patientCode,
      patientName,
      disposablesByDevice,
      interval,
      index
    ) {
      // 定期消耗品発送登録
      this.isRegularDisposablesOrderModalActive = true;
      this.targetPatientCode = patientCode;
      this.targetPatientName = patientName;
      this.teikishoumouData = {
        disposablesByDevice: disposablesByDevice,
        interval: interval,
        index: index
      };
    },
    checkRegulardisposablesOrder() {
      var rtnFlg = true;
      grid_loop: for (var item in this.data) {
        if (Object.keys(this.data[item]).indexOf("otherWork") == -1) {
          if (this.data[item].CTERM <= 1) {
            // 点検期間が「1」以下の場合
            // TODO:
            for (var i = 0; i < 7; i++) {
              var targetName =
                "disposable" + String(i + 1) + "RegularDeliveryFlag";
              // デッドロジック（targetName に該当する設定がないため undefined となり条件不成立）
              if (this.data[item].regularDisposablesProduct[0][targetName]) {
                // 定期発送フラグがTrueの場合
                rtnFlg = false;
                break grid_loop;
              }
            }
          }
        }
      }
      return rtnFlg;
    },
    expendablesOrder: function(event) {
      // 子要素の点検入力データをdataに更新する（性能改善で子コンポーネント化したことによりバインディングが切れるため）
      const childitems = this.$refs.itemvaluecompo;
      for (let i = 0; i < childitems.length; i++) {
        let tmpitem = childitems[i];
        let fname = tmpitem.fieldName;
        let nval = tmpitem.value;
        let index1 = parseInt(fname.split("_")[1]);
        let index2 = parseInt(fname.split("_")[2]) - 1; // index2は1始まりのため-1する
        var value = tmpitem.dataValue;
        if (tmpitem.isDisabled == "true") {
          // 非活性項目の場合
          value = "";
        }
        if (
          tmpitem.machineType == 4 &&
          tmpitem.displayName.indexOf("治療前呼吸") != -1
        ) {
          // 半角変換
          value = value.replace(/[！-～]/g, function(input) {
            return String.fromCharCode(input.charCodeAt(0) - 65248);
          });
          // 大文字変換
          value = value.toUpperCase();
        }
        this.data[index1].value[index2].value = value;
      }

      // 定期消耗品発送登録データチェック
      if (this.checkRegulardisposablesOrder()) {
        //ヘッダー点検期間チェック
        for (let j = 0; j < this.data.length; j++) {
          if (Object.keys(this.data[j]).indexOf("otherWork") == -1) {
            var value = this.$refs.inspectionSpan[j].inspectionSpanValue;
            // 点検期間がnull or 桁数が3より大きい時 or 空の場合 or 期間が1より小さいとき or 期間が負の場合はエラーメッセージを表示
            if (
              value == null ||
              value.length > 3 ||
              value == "" ||
              Number(value) < 1 ||
              Math.sign(value) == -1
            ) {
              this.$refs.inspectionSpan[j].$validator.errors.add({
                field: "CTERM" + j,
                msg:
                  "点検期間は必須項目です。</br>1以上、3桁以内で入力してください。"
              });
              this.showErrorMessage(
                "点検期間は必須項目です。</br>1以上、3桁以内で入力してください。"
              );
              return;
            }
          }
        }

        // 点検中断
        this.pause = true;
        this.regist().then(result => {
          if (this.compleateFlg) {
            this.doReturn();
          }
        });
      } else {
        // 定期消耗品発送データチェック結果がFalseの場合、エラーメッセージ表示
        this.showErrorMessage(
          "発送期間が1カ月の消耗品は発送できません。<br>" +
            "消耗品発送登録ボタンから消耗品発送登録画面に遷移して、<br>" +
            "発送のチェックを外して登録してください。"
        );
      }
    },
    checkChangedMachine(targetCode, targetSerial) {
      var isOk = true;
      var data = JSON.parse(JSON.stringify(this.initData));
      for (var i = 0; i < data.length; i++) {
        if (
          targetCode == data[i].productCode &&
          targetSerial == data[i].serialNumber
        ) {
          isOk = false;
        }
      }
      return isOk;
    },
    serialReader: function(serial, product, index) {
      if (
        navigator.platform == "iPad" || // -iOS12
        (navigator.platform == "MacIntel" && // iPadOS
          navigator.userAgent.indexOf("Safari") != -1 &&
          navigator.userAgent.indexOf("Chrome") == -1 &&
          navigator.standalone !== undefined) ||
        navigator.userAgent == "AppGuardian"
      ) {
        // iPad
        // さらにWebKit判定を仕込む(UserAgentがAppGuardian)
        if (navigator.userAgent.endsWith("AppGuardian")) {
          // WkWebViewのためiPadアプリ
          // WkWebViewでのカメラアクセスを開始
          // コールバック関数を準備する
          // バーコード読み取り
          this.machinReplaceindex = index;
          this.oldSerialNumber = serial;
          this.productNumber = product;
          this.serialReaderByNative().then(
            function(returnValue) {
              var array = returnValue.split("/");
              // 本来はここでchildFunctionを呼び出すべきだが、Promiseのコールバックで
              // thisは使えないので直接ロジックを実行する
              const init = JSON.parse(JSON.stringify(this.initData));
              this.initData = JSON.parse(JSON.stringify(init));
              var oldSerial = this.oldSerialNumber;
              var oldProduct = this.productNumber;
              this.oldSerialNumber = "";
              this.productNumber = "";
              let newProductCode = array[0];
              let newSerial = array[1];
              let oldProductType = "";
              let newProductType = "";
              let hardwares = JSON.parse(sessionStorage.getItem("hardwareMaster"));
              if (
                this.data[this.machinReplaceindex].serialNumber == oldSerial &&
                this.data[this.machinReplaceindex].productCode == oldProduct
              ) {
                if (this.checkChangedMachine(newProductCode, newSerial)) {
                  // コード、シリアルのチェック処理
                  this.data[
                    this.machinReplaceindex
                  ].machineReplaceSerialNumber = newSerial;
                  this.data[this.machinReplaceindex].machineReplaceProductCode =
                    newProductCode;

                  oldProductType = hardwares.filter(hardware => hardware.itemCode == oldProduct)
                  newProductType = hardwares.filter(hardware => hardware.itemCode == newProductCode)

                  if(oldProductType[0].reportFormatType != newProductType[0].reportFormatType){
                    this.getMachineValue();
                  }
                } else {
                  this.showError();
                }
              }
              return;
            }.bind(this)
          );
          return;
        } else {
          // alert("使用可能な環境ではありません。PCブラウザまたはiPadアプリを使用してください。")
          // return;
        }
      } else {
        // MacOS
        // バーコード読み取り
        this.machinReplaceindex = index;
        this.oldSerialNumber = serial;
        this.productNumber = product;
        this.isSerialReaderModalActive = true;
      }
    },
    singleItemSerialReader: function(index, list, name, number) {
      //カメラ呼び出し関数
      // iPad
      // さらにWebKit判定を仕込む(UserAgentがAppGuardian)
      if (navigator.userAgent.endsWith("AppGuardian")) {
        // WkWebViewのためiPadアプリ
        // WkWebViewでのカメラアクセスを開始
        // コールバック関数を準備する
        // バーコード読み取り
        this.serialReaderByNative().then(
          function(returnValue) {
            var array = returnValue.split("/");
            // 本来はここでchildFunctionを呼び出すべきだが、Promiseのコールバックで
            // thisは使えないので直接ロジックを実行する
            //品目コードとシリアルのマージ
            var productSerial =
              "品目コード:" + array[0] + " " + "S/N:" + array[1];
            list[0].value = productSerial;
            // 単項目のシリアル読取りの場合
            this.serialChanged(
              index,
              list,
              name,
              number,
              this.data[index].machineType,
              array[0],
              array[1]
            );

            return;
          }.bind(this)
        );
        return;
      }
    },
    serialReaderByNative: function() {
      var promise = new Promise(function(resolve, reject) {
        // we generate a unique id to reference the promise later
        // from native function
        var promiseId = generateUUID();
        // save reference to promise in the global variable
        nativePromises[promiseId] = { resolve, reject };

        try {
          // call native function
          window.webkit.messageHandlers.callbackHandler.postMessage({
            promiseId: promiseId
          });
        } catch (exception) {
          alert("カメラアクセスでエラーが発生しました");
        }
      });
      return promise;
    },
    clearSerial: function(value, index) {
      // 機器交換キャンセル
      this.oldSerialNumber = "";
      this.productNumber = "";
      this.ReplaceCancelindex = index;

      if (this.data[this.ReplaceCancelindex].serialNumber === value) {
        this.data[this.ReplaceCancelindex].machineReplaceSerialNumber = "";
        this.data[this.ReplaceCancelindex].machineReplaceProductCode = "";
        if (
          this.initData[this.ReplaceCancelindex].machineReplaceSerialNumber ==
          ""
        ) {
          const item = this.initData[this.ReplaceCancelindex];
          this.data[this.ReplaceCancelindex] = item;

          if (this.data[this.ReplaceCancelindex].machineType == 6) {
            // 機器交換後の機種判定
            var hotLevel =
              Object.keys(this.portableTypeCode).indexOf(
                this.data[this.ReplaceCancelindex].productCode
              ) == -1
                ? 1
                : this.portableTypeCode[
                    this.data[this.ReplaceCancelindex].productCode
                  ];
            if (hotLevel > 1) {
              // 「シリアルNO」点検項目を抽出
              var serialInspection = this.data[
                this.ReplaceCancelindex
              ].value.filter(
                val =>
                  val.displayName == this.inspectionItemSerial[hotLevel - 1]
              );
              // 「シリアルNO」点検項目に機器交換後のシリアルNoを設定
              this.$set(
                serialInspection[0],
                "value",
                this.data[this.ReplaceCancelindex].serialNumber
              );
              // 「シリアルNO」点検項目に機器交換後のシリアルNoを表示(画面)
              var items = this.$refs.itemvaluecompo;
              for (let i = 0; i < items.length; i++) {
                var tmpitem = items[i];
                var fname = tmpitem.fieldName;
                var index1 = parseInt(fname.split("_")[1]);
                if (
                  this.ReplaceCancelindex == index1 &&
                  tmpitem.displayName == serialInspection[0].displayName
                ) {
                  tmpitem.dataValue = this.data[
                    this.ReplaceCancelindex
                  ].serialNumber;
                  break;
                }
              }
            }
          }

          //未入力チェックボックスのリストを空にし、チェックボックスを選択していない状態に戻す
          this.checkList = [];
          var childCheckItem = this.$refs.itemvaluecompo;
          for (let i = 0; i < childCheckItem.length; i++) {
            let tmpitem = childCheckItem[i];
            let fname = tmpitem.fieldName;
            let dname = tmpitem.displayName;
            if (
              fname.indexOf("radio") == -1 &&
              dname.indexOf("特記事項") == -1 &&
              dname.indexOf("点検値変更理由") == -1
            ) {
              //画面上でチェックボックスにチェックがない状態にする
              document.getElementById(
                fname + "_check2"
              ).control.checked = false;
              //チェックボックスが持つ値と同期させる
              childCheckItem[i].checker = false;
            }
          }

          this.ReplaceCancelindex = null;
          this.machinReplaceindex = null;
          // バリデーションエラーリセット
          const childitems = this.$refs.itemvaluecompo;
          for (let i = 0; i < childitems.length; i++) {
            let tmpitem = childitems[i];
            let fname = tmpitem.fieldName;
            tmpitem.letsValidate().then(validatorResult => {
              tmpitem.errors.remove(fname);
            });
          }
        } else {
          // 機器交換前の情報が無ければ、取得処理
          this.cancelMachineReplace = true;
          this.getMachineValue();
        }
      }
    },
    childFunction: function(oldSerial, oldProduct, newValue, newProductCode) {
      // 機器交換
      const init = JSON.parse(JSON.stringify(this.initData));
      this.initData = JSON.parse(JSON.stringify(init));
      this.oldSerialNumber = "";
      this.productNumber = "";
      let oldProductType = "";
      let newProductType = "";
      let hardwares = JSON.parse(sessionStorage.getItem("hardwareMaster"));

      if (
        this.data[this.machinReplaceindex].serialNumber == oldSerial &&
        this.data[this.machinReplaceindex].productCode == oldProduct
      ) {
        this.data[
          this.machinReplaceindex
        ].machineReplaceSerialNumber = newValue;
        this.data[
          this.machinReplaceindex
        ].machineReplaceProductCode = newProductCode;

        oldProductType = hardwares.filter(hardware => hardware.itemCode == oldProduct)
        newProductType = hardwares.filter(hardware => hardware.itemCode == newProductCode)

        if(oldProductType[0].reportFormatType != newProductType[0].reportFormatType){
          this.getMachineValue();
        }
      }
    },
    showError: function() {
      this.showErrorMessage(
        "点検機器と同じ「品目コード」+「シリアル番号」は入力できません。"
      );
    },
    getMachineValue: function() {
      var excuteApi = this.getMachineValuePOST;
      var successCallBack = this.getMachineValuePOSTSuccess;
      var errorCallBack = this.getMachineValuePOSTError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getMachineValuePOST: function(client) {
      if (this.machinReplaceindex != null) {
        // 機器交換
        return client.apis.apiInspection.getMachineValuePOST({
          body: {
            code: this.appointmentCode,
            productCode: this.data[this.machinReplaceindex].productCode,
            patientCode: this.data[this.machinReplaceindex].patientCode,
            serial: this.data[this.machinReplaceindex].serialNumber,
            type: 1,
            machineReplaceFlag: true,
            newProductCode: this.data[this.machinReplaceindex]
              .machineReplaceProductCode,
            machineType: this.data[this.machinReplaceindex].machineType
          }
        });
      } else {
        // 機器交換キャンセル
        return client.apis.apiInspection.getMachineValuePOST({
          body: {
            code: this.appointmentCode,
            productCode: this.data[this.ReplaceCancelindex].productCode,
            patientCode: this.data[this.ReplaceCancelindex].patientCode,
            serial: this.data[this.ReplaceCancelindex].serialNumber,
            type: 1,
            machineReplaceFlag: true,
            newProductCode: "",
            machineType: ""
          }
        });
      }
    },
    getMachineValuePOSTSuccess: function(result) {
      //未入力チェックボックスのリストを空にし、チェックボックスを選択していない状態に戻す
      this.checkList = [];
      var childCheckItem = this.$refs.itemvaluecompo;

      if (!this.cancelMachineReplace) {
        this.cancelMachineReplace = false;

        const checkClearIndex = this.machinReplaceindex ? this.machinReplaceindex : this.ReplaceCancelindex ? this.ReplaceCancelindex : null;
        if (checkClearIndex != null) {
          for (let item of this.data[this.machinReplaceindex].value)
          {
            if(item.requiredcheck == true){
              if(item.type == 'sel'){
                let checkItem = 'sel_' + this.machinReplaceindex + '_' + Number(i+1)
                this.checkList.push(checkItem);
              }
              else if(item.type == 'char'){
                let checkItem = 'input_' + this.machinReplaceindex + '_' + Number(i+1)
                this.checkList.push(checkItem);
              }
            }
            else if(item.requiredcheck == null){
              item.requiredcheck = false
            }
          }

          // バリデーションエラーリセット
          const childitems = this.$refs.itemvaluecompo;
          for (let i = 0; i < childitems.length; i++) {
            let tmpitem = childitems[i];
            let fname = tmpitem.fieldName;
            tmpitem.letsValidate().then(validatorResult => {
              tmpitem.errors.remove(fname);
            });
          }
        }
      }

      //異機種の器械交換時は値を空に変更
      let j;
      for(j = 0; j < childCheckItem.length; j++){
        //※器械交換する機種のみ判別
        let model_judge = childCheckItem[j].fieldName;
        model_judge = model_judge.split('_');
        model_judge = Number(model_judge[1]);
        if(model_judge == this.machinReplaceindex)
        {
        childCheckItem[j].dataValue = ''
      }
      }

      for (let i = 0; i < childCheckItem.length; i++) {
        let tmpitem = childCheckItem[i];
        let fname = tmpitem.fieldName;
        let dname = tmpitem.displayName;
        if (
          fname.indexOf("radio") == -1 &&
          dname.indexOf("特記事項") == -1 &&
          dname.indexOf("点検値変更理由") == -1
        ) {
          //画面上でチェックボックスにチェックがない状態にする
          document.getElementById(fname + "_check2").control.checked = false;
          //チェックボックスが持つ値と同期させる
          childCheckItem[i].checker = false;
        }
      }

      // WebAPI応答内容を画面に設定
      if (this.machinReplaceindex != null) {
        // 療法の取得
        this.data[this.machinReplaceindex].therapy =
          result.obj[result.obj.length - 1].therapy;
        this.$delete(result.obj, result.obj.length - 1);

        // 機器タイプの取得
        this.data[this.machinReplaceindex].machineType =
          result.obj[result.obj.length - 1].reportFormatType;
        this.$delete(result.obj, result.obj.length - 1);

        this.data[this.machinReplaceindex].subContentsValue = [];
        // 点検項目の入れ替え
        this.data[this.machinReplaceindex].value = result.obj;
        // 副項目設定
        switch (this.data[this.machinReplaceindex].machineType) {
          case 4:
            // カフアシストの場合
            if (
              this.data[this.machinReplaceindex].machineType !=
              this.initData[this.machinReplaceindex].machineType
            ) {
              // 機械交換前後で機械種別が異なる場合
              this.$set(
                this.data[this.machinReplaceindex].subContentsValue,
                0,
                "2"
              );
              this.$set(
                this.data[this.machinReplaceindex].subContentsValue,
                1,
                "3"
              );
            }
            break;
          case 5:
            // トリロジーの場合
            if (
              this.data[this.machinReplaceindex].machineType !=
              this.initData[this.machinReplaceindex].machineType
            ) {
              // 機械交換前後で機械種別が異なる場合
              this.$set(
                this.data[this.machinReplaceindex].subContentsValue,
                0,
                "2"
              );
            }
            break;
          case 6:
            // 機器交換後の機種判定
            var hotLevel =
              Object.keys(this.portableTypeCode).indexOf(
                this.data[this.machinReplaceindex].machineReplaceProductCode
              ) == -1
                ? 1
                : this.portableTypeCode[
                    this.data[this.machinReplaceindex].machineReplaceProductCode
                  ];
            if (hotLevel > 1) {
              // 「シリアルNO」点検項目を抽出
              var serialInspection = this.data[
                this.machinReplaceindex
              ].value.filter(
                val =>
                  val.displayName == this.inspectionItemSerial[hotLevel - 1]
              );
              // 「シリアルNO」点検項目に機器交換後のシリアルNoを設定
              this.$set(
                serialInspection[0],
                "value",
                this.data[this.machinReplaceindex].machineReplaceSerialNumber
              );
              // 「シリアルNO」点検項目に機器交換後のシリアルNoを表示(画面)
              var items = this.$refs.itemvaluecompo;
              // 入れ替わっていない
              for (let i = 0; i < items.length; i++) {
                var tmpitem = items[i];
                var fname = tmpitem.fieldName;
                var index1 = parseInt(fname.split("_")[1]);
                if (
                  this.machinReplaceindex == index1 &&
                  tmpitem.displayName == serialInspection[0].displayName
                ) {
                  tmpitem.dataValue = this.data[
                    this.machinReplaceindex
                  ].machineReplaceSerialNumber;
                  break;
                }
              }
            } else {
              if (
                Object.keys(
                  this.data[this.machinReplaceindex].value[
                    this.data[this.machinReplaceindex].value.length - 1
                  ]
                ).indexOf("bombeSerialList") != -1
              ) {
                this.data[this.machinReplaceindex].bombeSerialList = this.data[
                  this.machinReplaceindex
                ].value[
                  this.data[this.machinReplaceindex].value.length - 1
                ].bombeSerialList;
                this.$delete(
                  this.data[this.machinReplaceindex].value,
                  this.data[this.machinReplaceindex].value.length - 1
                );
              } else {
                this.data[this.machinReplaceindex].bombeSerialList = [];
              }
            }
          default:
            // TODO:
            // 副項目設定消す
            this.data[this.machinReplaceindex].subContentsValue = [];
            break;
        }
      } else if (this.ReplaceCancelindex != null) {
        // 療法の取得
        this.data[this.ReplaceCancelindex].therapy =
          result.obj[result.obj.length - 1].therapy;
        this.$delete(result.obj, result.obj.length - 1);

        // 機器タイプの取得
        this.data[this.ReplaceCancelindex].machineType =
          result.obj[result.obj.length - 1].reportFormatType;
        this.$delete(result.obj, result.obj.length - 1);

        this.data[this.ReplaceCancelindex].subContentsValue = [];
        // 点検項目の入れ替え
        this.data[this.ReplaceCancelindex].value = result.obj;
        switch (this.data[this.ReplaceCancelindex].machineType) {
          case 4:
            this.$set(
              this.data[this.ReplaceCancelindex].subContentsValue,
              0,
              "2"
            );
            this.$set(
              this.data[this.ReplaceCancelindex].subContentsValue,
              1,
              "3"
            );
            break;
          case 5:
            this.$set(
              this.data[this.ReplaceCancelindex].subContentsValue,
              0,
              "2"
            );
            break;
          case 6:
            // 機器交換後の機種判定
            var hotLevel =
              Object.keys(this.portableTypeCode).indexOf(
                this.data[this.ReplaceCancelindex].productCode
              ) == -1
                ? 1
                : this.portableTypeCode[
                    this.data[this.ReplaceCancelindex].productCode
                  ];
            if (hotLevel > 1) {
              // 「シリアルNO」点検項目を抽出
              var serialInspection = this.data[
                this.ReplaceCancelindex
              ].value.filter(
                val =>
                  val.displayName == this.inspectionItemSerial[hotLevel - 1]
              );
              // 「シリアルNO」点検項目に機器交換後のシリアルNoを設定
              this.$set(
                serialInspection[0],
                "value",
                this.data[this.ReplaceCancelindex].serialNumber
              );
              // 「シリアルNO」点検項目に機器交換後のシリアルNoを表示(画面)
              var items = this.$refs.itemvaluecompo;
              for (let i = 0; i < items.length; i++) {
                var tmpitem = items[i];
                var fname = tmpitem.fieldName;
                var index1 = parseInt(fname.split("_")[1]);
                if (
                  this.ReplaceCancelindex == index1 &&
                  tmpitem.displayName == serialInspection[0].displayName
                ) {
                  tmpitem.dataValue = this.data[
                    this.ReplaceCancelindex
                  ].serialNumber;
                  break;
                }
              }
              break;
            } else {
              if (
                Object.keys(
                  this.data[this.ReplaceCancelindex].value[
                    this.data[this.ReplaceCancelindex].value.length - 1
                  ]
                ).indexOf("bombeSerialList") != -1
              ) {
                this.data[this.ReplaceCancelindex].bombeSerialList = this.data[
                  this.ReplaceCancelindex
                ].value[
                  this.data[this.ReplaceCancelindex].value.length - 1
                ].bombeSerialList;
                this.$delete(
                  this.data[this.ReplaceCancelindex].value,
                  this.data[this.ReplaceCancelindex].value.length - 1
                );
              } else {
                this.data[this.ReplaceCancelindex].bombeSerialList = [];
              }
            }
        }
      }
      // // バリデーションエラーリセット
      // const childitems = this.$refs.itemvaluecompo;
      // for (let i = 0; i < childitems.length; i++) {
      //   let tmpitem = childitems[i];
      //   let fname = tmpitem.fieldName;
      //   tmpitem.letsValidate().then(validatorResult => {
      //     tmpitem.errors.remove(fname);
      //   });
      // }
      // this.ReplaceCancelindex = null;
      // this.machinReplaceindex = null;
    },
    getMachineValuePOSTError: function(result) {
      if (this.machinReplaceindex != null) {
        this.data[this.machinReplaceindex].machineReplaceSerialNumber = "";
        this.data[this.machinReplaceindex].machineReplaceProductCode = "";
      }
      this.ReplaceCancelindex = null;
      this.machinReplaceindex = null;
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    startInspectionPOST: function(client) {
      return client.apis.apiInspection.startInspectionPOST({
        body: {
          code: this.appointmentCode,
          startLatitude: this.startLatitude,
          startLongitude: this.startLongitude,
          isDealer: this.$route.params.isDealer
        }
      });
    },
    startInspectionPOSTSuccess: function(result) {
      // WebAPI応答内容を画面に設定
      this.data = result.obj;
      var otherWorkFlg = false;
      var nextMonthRegularDisposableOrder = false;
      for (var item in this.data) {
        var hotLevel;
        if (
          !nextMonthRegularDisposableOrder &&
          this.data[item].nextMonthRegularDisposableOrder
        ) {
          // 次月分の定期消耗品が発送登録済みの場合
          nextMonthRegularDisposableOrder = true;
        }
        if (this.data[item].signature) {
          this.signatureFlag = true;
          this.signData = this.data[item].signature;
          this.alternative = this.data[item].alternativeWriting;
          this.alternativeReason = this.data[item].alternativeWritingReason;
        }

        if (Object.keys(this.data[item]).indexOf("otherWork") == -1) {
          if (
            Object.keys(
              this.data[item].value[this.data[item].value.length - 1]
            ).indexOf("therapy") != -1
          ) {
            this.$delete(
              this.data[item].value,
              this.data[item].value.length - 1
            );
          }

          if (
            Object.keys(
              this.data[item].value[this.data[item].value.length - 1]
            ).indexOf("reportFormatType") != -1
          ) {
            this.$delete(
              this.data[item].value,
              this.data[item].value.length - 1
            );
          }
          // 点検実施日は複数器機の場合も同一
          if (this.$route.params.isDealer) {
            this.inspectionDate = this.data[item].inspectionDate ? this.parseDate(this.data[item].inspectionDate) : null;
          } else {
            this.inspectionDate = new Date();
          }

          //必須解除チェックをchecklistに追加する処理
          let i = 0;
          for(i = 0 ; this.data[item].value.length > i ; i++)
          {
            if(this.data[item].value[i].requiredcheck == true){
              if(this.data[item].value[i].type == 'sel'){
                let checkItem = 'sel_' + item + '_' + Number(i+1)
                this.checkList.push(checkItem);
                //checkcheckListに入れる変数の形を整形
                this.checkList.push()
              }
              else if(this.data[item].value[i].type == 'char'){
                let checkItem = 'input_' + item + '_' + Number(i+1)
                this.checkList.push(checkItem);
              }
            }
            else if(this.data[item].value[i].requiredcheck == null){
              this.data[item].value[i].requiredcheck = false
            }
          }

          if (this.data[item].subContentsValue == null) {
            this.data[item].subContentsValue = [];
            switch (this.data[item].machineType) {
              case 4:
                // カフアシストの場合
                var syohochi2 = this.data[item].value.filter(
                  val => val.displayName == "プリセット使用(プリセット2)"
                );
                var syohochi3 = this.data[item].value.filter(
                  val => val.displayName == "プリセット使用(プリセット3)"
                );
                if (
                  syohochi2.length != 0 &&
                  syohochi2[0].prescription != "" &&
                  syohochi2[0].prescription != null &&
                  syohochi2[0].prescription + "" != "2"
                ) {
                  this.$set(this.data[item].subContentsValue, 0, "2");
                }
                if (
                  syohochi3.length != 0 &&
                  syohochi3[0].prescription != "" &&
                  syohochi3[0].prescription != null &&
                  syohochi3[0].prescription + "" != "2"
                ) {
                  if (this.data[item].subContentsValue.length == 0) {
                    this.$set(this.data[item].subContentsValue, 0, "3");
                  } else {
                    this.$set(this.data[item].subContentsValue, 1, "3");
                  }
                }
                break;
              case 5:
                // トリロジーの場合
                var syohochi = this.data[item].value.filter(
                  val => val.displayName == "換気モード(副)"
                );
                if (
                  syohochi.length != 0 &&
                  syohochi[0].prescription != "" &&
                  syohochi[0].prescription != null
                ) {
                  this.$set(this.data[item].subContentsValue, 0, "2");
                }
                break;
              case 7:
                this.setSubContentsValue(item, 5);
                break;
              case 8:
                this.setSubContentsValue(item, 3);
                break;
              case 11:
                this.setSubContentsValue(item, 3);
                break;
              case 12:
                this.setSubContentsValue(item, 5);
                break;
              case 17:
                for (let contentsType = 2; contentsType <=5; ++contentsType) {
                  let contentsValue = this.data[item].value.find(val => val.displayName == "プロファイル使用" && val.contentsType == contentsType);
                  if (contentsValue.prescription == "1") {
                    this.data[item].subContentsValue.push(contentsType + "");
                  }
                }
                break;
              default:
                break;
            }
          }
          if (this.data[item].machineType == 6) {
            // HOTの場合、同予約内の共通点検項目の優先度を判別
            // 1：設置型
            // 2：ｼﾝﾌﾟﾘｰｺﾞｰﾐﾆ
            // 3：ｼﾝﾌﾟﾘｰｺﾞｰ
            hotLevel =
              Object.keys(this.portableTypeCode).indexOf(
                this.data[item].productCode
              ) == -1
                ? 1
                : this.portableTypeCode[this.data[item].productCode];
            if (this.hotTypeRange.length != 0) {
              if (this.hotTypeRange.indexOf(hotLevel) == -1) {
                this.hotTypeRange.push(hotLevel);
              }
            } else {
              this.hotTypeRange.push(hotLevel);
            }
            // HOTの場合
            if (hotLevel > 1) {
              var serialInspection = this.data[item].value.filter(
                val =>
                  val.displayName == this.inspectionItemSerial[hotLevel - 1]
              );
              if (serialInspection.length > 0) {
                if (this.data[item].machineReplaceSerialNumber) {
                  serialInspection[0].value = this.data[
                    item
                  ].machineReplaceSerialNumber;
                } else {
                  serialInspection[0].value = this.data[item].serialNumber;
                }
              }
            } else if (this.data[item].version == 0) {
              var serialInspection = this.data[item].value.filter(
                val => val.displayName == this.inspectionItemSerial[1]
              );
              if (serialInspection.length > 0) {
                if (this.data[item].machineReplaceSerialNumber) {
                  serialInspection[0].value = this.data[
                    item
                  ].machineReplaceSerialNumber;
                } else {
                  serialInspection[0].value = this.data[item].serialNumber;
                }
              }
            } else {
              if (
                Object.keys(
                  this.data[item].value[this.data[item].value.length - 1]
                ).indexOf("bombeSerialList") != -1
              ) {
                this.data[item].bombeSerialList = this.data[item].value[
                  this.data[item].value.length - 1
                ].bombeSerialList;
                this.$delete(
                  this.data[item].value,
                  this.data[item].value.length - 1
                );
              } else if(!this.data[item].bombeSerialList){
                this.data[item].bombeSerialList = [];
              }
            }
          }
          if (Object.keys(this.data[item]).indexOf("deliveryHistory") != -1) {
            // deliveryHistory 追加
            for (var i = 0; i < this.data[item].deliveryHistory.length; i++) {
              if (typeof this.data[item].deliveryHistory[i].count == "string") {
                this.data[item].deliveryHistory[i].count = parseInt(
                  this.data[item].deliveryHistory[i].count
                );
              }
            }
          }
          this.sortedItemsByDisplayOrder(this.data[item].value);
          for (var i = 0; i < this.data[item].value.length; i++) {
            if (typeof this.data[item].value[i].prescription == "number") {
              this.data[item].value[i].prescription += "";
            }
            if (this.data[item].value[i].prescription == "null") {
              this.data[item].value[i].prescription = null;
            }
          }
          this.data[item].updateNextInspectionDate = "true";
        } else {
          otherWorkFlg = true;
        }

        if (!otherWorkFlg) {
          for (const shoumou of this.data[item].regularDisposablesProduct[0].shoumouList) {
            if (shoumou.deliveryKindFlag == 1) {
              const nextMonthOld = dayjs(shoumou.nextDate).add(Number(this.data[item].CTERM), "month").format("YYYYMM");
              const nextMonthNew = dayjs().add(Number(this.data[item].CTERM), "month").format("YYYYMM");
              if (nextMonthOld != nextMonthNew) {
              // 点検サイクル外の履歴作成
                shoumou.oldDeliveryMonth = shoumou.nextDate;
              }
            }
          }
        }
      } // LoopEnd

      if (!otherWorkFlg) {
        this.data.push({ otherWork: "" });
      } else {
        this.otherWork = this.data[item].otherWork;
      }
      // HOT機器種別リストのソート
      this.hotTypeRange.sort(function(a, b) {
        return a - b;
      });
      // 機器交換キャンセル用初期データ
      const init = JSON.parse(JSON.stringify(this.data));
      this.initData = JSON.parse(JSON.stringify(init));

      if (nextMonthRegularDisposableOrder) {
        // 次月分の定期消耗品が発送登録済みの場合、キャンセルを促すメッセージを表示
        var msg = "";
        var now = new Date();
        var today = now.getDate();
        const lastCancelDay = this.getShoumouCancelRangeEndDay();
        if (today > lastCancelDay) {
          // キャンセル可能期間後
          msg =
            "次月分の消耗品が発送登録済みです。<br>キャンセル可能期間を過ぎている為、スケジュール管理システムではキャンセルできません。<br>キャンセルが必要な場合はWEBシステムから直接キャンセルをお願いします。";
        } else {
          // キャンセル可能期間
          msg =
            "次月分の消耗品が発送登録済みです。<br>キャンセルが必要な場合は事前に消耗品発送登録からキャンセルをお願いします。";
        }
        this.$dialog.confirm({
          title: "　",
          message: msg,
          canCancel: false,
          onConfirm: () => {
            return;
          }
        });
      }

      for (var i=0; i < this.data.length; i++) {
        if (Object.keys(this.data[i]).indexOf("otherWork") != -1) {
          continue
        }
        // 処方値変更履歴取得
        let _this = this;
        let _data = this.data[i]
        let _index = i
        // let _patientCode =  this.data[i].patientCode
        // let _serialNumber = this.data[i].serialNumber
        // Web Api Call
        this.apiCall(
          function(client){
            return client.apis.apiInspection.getPrescriptionHistoryListPOST({
              body:{
                productCode: _data.productCode,
                patientCode: _data.patientCode,
                serial: _data.serialNumber,
              }
            });
          },
          function(result) {
            // 検索結果取得
            _this.preEditHistoryList[_index] = result.obj
            if(_this.preEditHistoryList[_index].length > 0){
              _this.lastPreEditHistory[_index] = _this.preEditHistoryList[_index][_this.preEditHistoryList[_index].length - 1]
            }
          },
          function(result) {
            // エラーメッセージ表示
            _this.showErrorMessage(result);
          },
        );
      }
    },
    setSubContentsValue: function(item, contentsTypeMax) {
      for (let contentsType = 2; contentsType <= contentsTypeMax; ++contentsType) {
        let contentsValues = this.data[item].value.filter(val => val.contentsType == contentsType);
        for (let contentsValue of contentsValues) {
          if (contentsValue.prescription != null && contentsValue.prescription != "") {
            if (contentsValue.displayName.indexOf("I:E") != -1 && contentsValue.prescription == "：") {
              continue; 
            }
            this.data[item].subContentsValue.push(contentsType + "");
            break;
          }
        }
      }
    },
    startInspectionPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.doReturn();
    },
    saveTempInspectionPOST: function(client) {
      var obj = { inspectionList: [] };
      var now = new Date();
      obj["code"] = this.appointmentCode;
      obj["userId"] = this.userInfo.id;
      obj["staffCode"] = this.$route.params.isDealer ? null : this.userInfo.staffCode;
      var name = this.$route.params.isDealer ? "" : this.userInfo.fullName;
      obj["lastName"] = name.split(" ")[0];
      obj["firstName"] = name.split(" ")[1];
      obj["inspectionDate"] = this.inspectionDate;
      obj["pause"] = this.pause;
      obj.isDealer = this.$route.params.isDealer;

      for (var item in this.data) {
        if (Object.keys(this.data[item]).indexOf("otherWork") == -1) {
          this.data[item].subContentsValue = this.data[
            item
          ].subContentsValue.filter(v => v);
          let maxNum = this.data[item].value.length - 1;

          if (
            Object.keys(this.data[item].value[maxNum]).indexOf("therapy") != -1
          ) {
            this.$delete(this.data[item].value, maxNum);
            maxNum = this.data[item].value.length - 1;
          }

          if (
            Object.keys(this.data[item].value[maxNum]).indexOf(
              "reportFormatType"
            ) != -1
          ) {
            this.$delete(this.data[item].value, maxNum);
            maxNum = this.data[item].value.length - 1;
          }
          if (this.data[item].machineType == 6) {
            var product;
            if (this.data[item].machineReplaceProductCode) {
              product = this.data[item].machineReplaceProductCode;
            } else {
              product = this.data[item].productCode;
            }
            var hotLevel =
              Object.keys(this.portableTypeCode).indexOf(product) == -1
                ? 1
                : this.portableTypeCode[product];
            if (
              hotLevel < 2 &&
              this.data[item].version >= 1 &&
              this.data[item].bombeSerialList &&
              this.data[item].bombeSerialList.length > 0
            ) {
              this.data[item].value.push({
                bombeSerialList: this.data[item].bombeSerialList
              });
            }
          }

          var target = this.data[item];
          delete target.signature;

          let requireChecklist = [];
          //必須チェックの値挿入の為の正規化
          let i=0;
          for(i=0;  this.checkList.length > i ; i++)
          {
            let num = this.checkList[i];
            
              let char_list = num.split('_');
              if(char_list[1] == item){
                let char_num = Number(char_list[2]);
                requireChecklist.push(char_num);
              }
          }

          //値挿入
          for(i = 0; target.value.length > i; i++){
            //チェックリストには画面の項目順番が1から始まり、
            //配列には0から始まる為合わせる
            let num_exist = requireChecklist.includes(i+1);
            if(num_exist){
              target.value[i].requiredcheck = true
            }
            else{
              target.value[i].requiredcheck = false
            }
          }

          obj.inspectionList.push(target);

          // 次回作業指示
          const nextDirection = this.$refs.nextDirection[item];
          this.data[item].nextDirection = nextDirection.nextDirectionValue;
          obj["nextDirection"] = this.data[item].nextDirection;

          // 点検期間
          const inspectionSpan = this.$refs.inspectionSpan[item];
          this.data[item].CTERM = inspectionSpan.inspectionSpanValue;
          obj["CTERM"] = this.data[item].CTERM;

          // 診療科
          const department = this.$refs.department[item];
          this.data[item].department = department.itemNameValue;
          obj["department"] = this.data[item].department;

          // 担当医
          const doctorName = this.$refs.doctorName[item];
          this.data[item].doctorName = doctorName.itemNameValue;
          obj["doctorName"] = this.data[item].doctorName;

          // 前回供給日、次回供給予定日、発送期間のセット
          for (
            var i = 0;
            i < this.data[item].regularDisposablesProduct[0].shoumouList.length;
            i++
          ) {
            var target = this.data[item].regularDisposablesProduct[0]
              .shoumouList[i];
            var interval = target.deliveryKindFlag == 1 ? this.data[item].CTERM : Number(target.interval);
            var year = parseInt(interval / 12);
            var month = parseInt(interval % 12);

            // 次回供給予定日
            var nextDate;
            // 対象月(前回供給日+期間)の月初日
            var targetFirstDay = new Date(
              Number(now.getFullYear() + year),
              Number(now.getMonth() + month),
              1
            );
            var targetLastDay = this.parseDate(
              this.getMonthLastDay(targetFirstDay)
            );
            if (targetLastDay.getDate() >= now.getDate()) {
              // 対象月(次回供給日+期間)の月末日が次回供給予定の日以上
              // そのまま設定
              nextDate = this.formatDate2(
                new Date(
                  Number(now.getFullYear()) + year,
                  Number(now.getMonth()) + month,
                  now.getDate()
                )
              );
            } else {
              // 対象月(次回供給日+期間)の月末日が次回供給予定の日より小さい
              // 対象月の月末日を設定
              nextDate = this.formatDate2(targetLastDay);
            }
            if (target.deliveryKindFlag == 1) {
              target.preDate = this.formatDate2(now);
              target.nextDate = nextDate;
              target.interval = Number(interval);
            }
          }

          if (this.$route.params.isDealer) {
            // 委託担当者
            const trustStaff = this.$refs.trustStaff[item];
            this.data[item].trustStaff = trustStaff.itemNameValue;
            obj["trustStaff"] = this.data[item].trustStaff;
          }
        } else {
          // 点検外作業
          const otherWork = this.$refs.otherWork[0];
          this.data[item].otherWork = otherWork.otherWorkValue;
          obj["otherWork"] = this.data[item].otherWork;
        }
      }

      for (var j in obj.inspectionList) {
        if (obj.inspectionList[j].inspectionOrder == 99) {
          obj.inspectionList[j].inspectionOrder = null;
        }
        if (
          Object.keys(obj.inspectionList[j]).indexOf(
            "machineReplaceProductCode"
          ) != -1 &&
          obj.inspectionList[j].machineReplaceProductCode == null
        ) {
          obj.inspectionList[j].machineReplaceProductCode = "";
        }
        if (
          Object.keys(obj.inspectionList[j]).indexOf("appointmentMemo") != -1 &&
          obj.inspectionList[j].appointmentMemo == null
        ) {
          obj.inspectionList[j].appointmentMemo = "";
        }
        if (
          Object.keys(obj.inspectionList[j]).indexOf("appointmentMemo") != -1 &&
          obj.inspectionList[j].nextDirection == null
        ) {
          obj.inspectionList[j].nextDirection = "";
        }
        if (obj.inspectionList[j].updateNextInspectionDate) {
          obj.inspectionList[j].updateNextInspectionDate = this.parseBoolean(
            obj.inspectionList[j].updateNextInspectionDate
          );
        }
        for (var k in obj.inspectionList[j].value) {
          if (
            Object.keys(obj.inspectionList[j].value[k]).indexOf(
              "bombeSerialList"
            ) != -1
          ) {
            continue;
          }
          obj.inspectionList[j].value[k].value += "";
          if (typeof obj.inspectionList[j].value[k].prescription == "number") {
            obj.inspectionList[j].value[k].prescription += "";
          }
          if (obj.inspectionList[j].value[k].prescription == "null") {
            obj.inspectionList[j].value[k].prescription = null;
          }
        }
      }

      // 緯度・経度設定
      if (this.startLatitude && this.startLongitude) {
        obj["startLatitude"] = this.startLatitude; // 点検開始緯度
        obj["startLongitude"] = this.startLongitude; // 点検開始経度
      }

      // 器械交換チェック
      obj.checkMachineReplace = this.checkMachineReplace;

      var body = JSON.parse(JSON.stringify(obj));
      return client.apis.apiInspection.saveTempInspectionPOST({
        body: body
      });
    },
    saveTempInspectionPOSTSuccess: function(result) {
      if (this.messageFlg) {
        // 成功メッセージ表示
        this.showSuccess(result);
      }
      this.messageFlg = true;
      this.compleateFlg = true;
    },
    saveTempInspectionPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getInputFieldName: function(subscript, index) {
      return "input_" + subscript + "_" + index;
    },
    getSelectFieldName: function(subscript, index) {
      return "sel_" + subscript + "_" + index;
    },
    getRadioFieldName: function(subscript, index) {
      return "radio_" + subscript + "_" + index;
    },
    getnextUpDateFieldName: function(subscript, index) {
      return "nextUpDate" + subscript + index;
    },
    getProductName: function(value, productMaster) {
      if (!value) {
        return "";
      }

      var productElement = productMaster.find(v => v.productCode === value);
      if (productElement) {
        return productElement.productName;
      }
      return "";
    },

    inspectionComplete: async function(signData, signFlg, reason, signed) {
      // 登録処理
      this.signatureFlag = signed;
      this.signature = signData; //署名データ
      this.alternativeWriting = signFlg; //代筆フラグ
      this.alternativeWritingReason = reason; //代筆理由

      // ディーラー点検
      if(this.$route.params.isDealer){
        this.signatureFlag = false;
        this.alternativeWriting = true; //代筆フラグ
        this.alternativeWritingReason = "点検報告書(別紙)にサイン受領済みのため、サイン省略"; //代筆理由
      }

      if (!signed) {
        // 署名未登録もしくは再入力の場合、署名関連データ、緯度・経度のみ登録
        await this.setInspectionSignature();
      }

      this.setInspection().then(result => {
        if (this.compleateFlg) {
          this.doReturn();
        }
      });
    },
    getEndPosition() {
      return new Promise((resolve, reject) => {
        // 現在地を取得
        navigator.geolocation.getCurrentPosition(
          // 取得成功した場合
          position => {
            this.endLatitude = position.coords.latitude;
            this.endLongitude = position.coords.longitude;
            // debug:console.log(this.endLatitude + "," + this.endLongitude);
            resolve(true);
          },
          // 取得失敗した場合
          error => {
            reject(error.code);
          },
          // オプション
          {
            timeout: this.timeOut
          }
        );
      });
    },
    getStartPosition() {
      return new Promise((resolve, reject) => {
        // 現在地を取得
        navigator.geolocation.getCurrentPosition(
          // 取得成功した場合
          position => {
            this.startLatitude = position.coords.latitude;
            this.startLongitude = position.coords.longitude;
            resolve(true);
          },
          // 取得失敗した場合
          error => {
            reject(error.code);
          },
          // オプション
          {
            timeout: this.timeOut
          }
        );
      });
    },
    setInspectionSignature: function(client) {
      var excuteApi = this.setInspectionSignaturePOST;
      var successCallBack = this.setInspectionSignaturePOSTSuccess;
      var errorCallBack = this.setInspectionSignaturePOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setInspectionSignaturePOST: function(client) {
      return client.apis.apiInspection.setInspectionSignaturePOST({
        body: {
          reservationId: this.appointmentCode,
          signature: this.signature,
          alternativeWriting: this.alternativeWriting,
          alternativeWritingReason: this.alternativeWritingReason,
          endLatitude: this.endLatitude,
          endLongitude: this.endLongitude
        }
      });
    },
    setInspectionSignaturePOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.compleateFlg = true;
    },
    setInspectionSignaturePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    setInspection: async function(client) {
      var excuteApi = this.setInspectionPOST;
      var successCallBack = this.setInspectionPOSTSuccess;
      var errorCallBack = this.setInspectionPOSTError;
      // WebAPI Call
      return await this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setInspectionPOST: function(client) {
      var obj = { inspectionList: [] };
      obj["code"] = this.appointmentCode;
      obj["userId"] = this.userInfo.id;
      obj["staffCode"] = this.$route.params.isDealer ? null : this.userInfo.staffCode;
      var name = this.$route.params.isDealer ? "" : this.userInfo.fullName;
      obj["lastName"] = name.split(" ")[0];
      obj["firstName"] = name.split(" ")[1];
      obj["inspectionDate"] = this.inspectionDate;
      for (var item in this.data) {
        var hotLevel;
        this.data[item].signatureFlag = this.signatureFlag;
        if (this.data[item].inspectionOrder == 99) {
          this.data[item].inspectionOrder = null;
        }
        if (Object.keys(this.data[item]).indexOf("otherWork") == -1) {
          this.$set(
            this.data[item],
            "nextInspectionMonth",
            this.getNextInspection(this.data[item], false)
          );
          this.data[item].subContentsValue = this.data[
            item
          ].subContentsValue.filter(v => v);
          let maxNum = this.data[item].value.length - 1;

          if (
            Object.keys(this.data[item].value[maxNum]).indexOf("therapy") != -1
          ) {
            this.$delete(this.data[item].value, maxNum);
            maxNum = this.data[item].value.length - 1;
          }

          if (
            Object.keys(this.data[item].value[maxNum]).indexOf(
              "reportFormatType"
            ) != -1
          ) {
            this.$delete(this.data[item].value, maxNum);
            maxNum = this.data[item].value.length - 1;
          }

          if (this.data[item].machineType == 6) {
            // HOTの場合、同予約内の共通点検項目の優先度を判別
            // 1：設置型
            // 2：ｼﾝﾌﾟﾘｰｺﾞｰﾐﾆ
            // 3：ｼﾝﾌﾟﾘｰｺﾞｰ
            hotLevel =
              Object.keys(this.portableTypeCode).indexOf(
                this.data[item].productCode
              ) == -1
                ? 1
                : this.portableTypeCode[this.data[item].productCode];
            if (hotLevel > 1) {
              // 設置型でない場合、「点検項目：シリアルNo」にシリアルをセット
              var serialInspection = this.data[item].value.filter(
                val =>
                  val.displayName == this.inspectionItemSerial[hotLevel - 1]
              );
              if (serialInspection.length > 0) {
                if (this.data[item].machineReplaceSerialNumber) {
                  serialInspection[0].value = this.data[
                    item
                  ].machineReplaceSerialNumber;
                } else {
                  serialInspection[0].value = this.data[item].serialNumber;
                }
              }
            }
          }
          this.data[item].alternativeWriting = this.alternativeWriting
          this.data[item].alternativeWritingReason = this.alternativeWritingReason
          obj.inspectionList.push(this.data[item]);

          if (this.$route.params.isDealer) {
            // 委託担当者
            const trustStaff = this.$refs.trustStaff[item];
            this.data[item].trustStaff = trustStaff.itemNameValue;
            obj["trustStaff"] = this.data[item].trustStaff;
          }
        } else {
          // 点検外作業
          obj["otherWork"] = this.data[item].otherWork;
        }
      }
      if (this.startLatitude && this.startLongitude) {
        obj["startLatitude"] = this.startLatitude; // 点検開始緯度
        obj["startLongitude"] = this.startLongitude; // 点検開始経度
      }

      if (this.endLatitude && this.endLongitude) {
        obj["endLatitude"] = this.endLatitude; // 点検完了緯度
        obj["endLongitude"] = this.endLongitude; // 点検完了経度
      }
      obj["signature"] = this.signature; //署名データ
      obj["alternativeWriting"] = this.alternativeWriting; //代筆フラグ
      obj["alternativeWritingReason"] = this.alternativeWritingReason;

      for (var j in obj.inspectionList) {
        if (obj.inspectionList[j].machineReplaceProductCode == null) {
          obj.inspectionList[j].machineReplaceProductCode = "";
        }
        if (obj.inspectionList[j].appointmentMemo == null) {
          obj.inspectionList[j].appointmentMemo = "";
        }
        if (obj.inspectionList[j].nextDirection == null) {
          obj.inspectionList[j].nextDirection = "";
        }
        if (obj.inspectionList[j].updateNextInspectionDate) {
          obj.inspectionList[j].updateNextInspectionDate = this.parseBoolean(
            obj.inspectionList[j].updateNextInspectionDate
          );
        }
        for (var k in obj.inspectionList[j].value) {
          if (
            Object.keys(obj.inspectionList[j].value[k]).indexOf(
              "bombeSerialList"
            ) != -1
          ) {
            continue;
          }
          obj.inspectionList[j].value[k].value += "";
          if (typeof obj.inspectionList[j].value[k].prescription == "number") {
            obj.inspectionList[j].value[k].prescription += "";
          }
          if (obj.inspectionList[j].value[k].prescription == "null") {
            obj.inspectionList[j].value[k].prescription = null;
          }
        }
      }
      var body = JSON.parse(JSON.stringify(obj));
      return client.apis.apiInspection.setInspectionPOST({
        body: body
      });
    },
    setInspectionPOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.showSuccess(result);
      this.compleateFlg = true;
    },
    setInspectionPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getPrescriptionValue(value) {
      if (value == "-" || value == "null") {
        return "";
      } else {
        return value;
      }
    },
    serialChanged: function(
      index,
      list,
      name,
      number,
      machineType,
      productCode,
      serialCode
    ) {
      var serialValue;
      if (list[0]) {
        serialValue = list[0].value;
      } else {
        serialValue = "";
      }

      if (name == "携帯用酸素ボンベ（本数）") {
        this.data[index].bombeSerialList = list;
      } else {
        if (machineType && machineType == inspectionUtil.MACHINE_TYPE.TRILOGY_EVO.code) {
          let serialChangeList = inspectionUtil.SERIAL_CHANGED_INDEX[machineType];
          let productInfo = this.getProductInfo(productCode);
          let newDataList = {
            productCode: productCode,
            serialCode: serialCode,
            productName: productInfo.productName,
          };
          let items = this.$refs.itemvaluecompo;
          let breakCount = 0;
          for (let i = 0; i < items.length; i++) {
            let tmpitem = items[i];
            let index1 = parseInt(tmpitem.fieldName.split("_")[1]);
            for (const element of serialChangeList) {
              if (index == index1 && tmpitem.displayOrder == number + element.displayOrder) {
                tmpitem.dataValue = newDataList[element.key];
                breakCount++;
                break;
              }
            }
            if (breakCount == serialChangeList.length) {
              break;
            }
          }
        } else if (machineType && (machineType == 8 || machineType == this.MACHINE_TYPE_ASV)) {
          // シリアル
          let serialInspection = this.data[index].value.filter(
            val => val.displayOrder == number
          );
          // 品目コード
          let productCodeInspection = this.data[index].value.filter(
            val => val.displayOrder == number + 1
          );
          this.$set(serialInspection[0], "value", serialCode);
          this.$set(productCodeInspection[0], "value", productCode);
          // 子コンポーネントへのセット
          var items = this.$refs.itemvaluecompo;
          var targetFname;
          for (let i = 0; i < items.length; i++) {
            var tmpitem = items[i];
            var fname = tmpitem.fieldName;
            var index1 = parseInt(fname.split("_")[1]);
            if (index == index1 && tmpitem.displayOrder == number) {
              tmpitem.dataValue = serialCode;
            } else if (index == index1 && tmpitem.displayOrder == number + 1) {
              tmpitem.dataValue = productCode;
              targetFname = fname;
              break;
            }
          }
          document.getElementById(targetFname).focus();
        } else if(machineType && machineType == 12 && name == "加湿器（品目コード＋品目テキスト)"){
          //加湿器品目コード
          let humidifierItemCode = this.data[index].value.filter(
            val => val.displayOrder == number
            );

          //加湿器シリアル 
          let humidifierSerial = this.data[index].value.filter(
            val => val.displayOrder == number + 1
          );
          this.$set(humidifierItemCode[0], "value", productCode);
          this.$set(humidifierSerial[0], "value", serialCode);
          // 子コンポーネントへのセット
          let items = this.$refs.itemvaluecompo;
          let targetFname;
          for (let i = 0; i < items.length; i++) {
            let tmpitem = items[i];
            let fname = tmpitem.fieldName;
            let index1 = parseInt(fname.split("_")[1]);
            if (index == index1 && tmpitem.displayOrder == number) {
              tmpitem.dataValue = productCode;
            } else if (index == index1 && tmpitem.displayOrder == number + 1) {
              tmpitem.dataValue = serialCode;
              targetFname = fname;
              break;
            }
          }
          document.getElementById(targetFname).focus();
        }else {
          let serialInspection = this.data[index].value.filter(
            val => val.displayOrder == number
          );
          // 「シリアルNO」点検項目にシリアルNoを設定
          this.$set(serialInspection[0], "value", serialValue);
          // 「シリアルNO」点検項目に機器交換後のシリアルNoを表示(画面)
          var items = this.$refs.itemvaluecompo;
          for (let i = 0; i < items.length; i++) {
            var tmpitem = items[i];
            var fname = tmpitem.fieldName;
            var index1 = parseInt(fname.split("_")[1]);
            if (index == index1 && tmpitem.displayOrder == number) {
              tmpitem.dataValue = serialValue;
              break;
            }
          }
        }
      }
      this.serialInputModalActive.flg = false;
      this.serialInputModalActive.index = 0;
      this.serialInputModalActive.list = {};
      this.serialInputModalActive.serialType = 0;
      this.serialInputModalActive.dName = "";
      this.serialInputModalActive.dNumber = "";
      this.serialInputModalActive.machineType = "";
    },
    prescriptionCopyAll() {
      this.$dialog.confirm({
        title: "処方値一括コピー",
        message:
          "点検値に既に値が入力されている場合、上書きされますがよろしいでしょうか？<br/>※複数器機の場合、全ての器機の処方値がコピーされます。",
        confirmText: "OK",
        cancelText: "キャンセル",
        // type: "is-info",
        // hasIcon: true,
        onConfirm: () => {
          // Loading:START
          this.appVue.loadingStart();
          this.copyAll();
          // Loading:END
          this.appVue.loadingEnd();
        }
      });
    },
    copyAll() {
      // Loading:START
      this.appVue.loadingStart();
      const childitems = this.$refs.itemvaluecompo;
      for (let i = 0; i < childitems.length; i++) {
        let tmpitem = childitems[i];
        let type = tmpitem.machineType;
        let fname = tmpitem.fieldName;
        let dname = tmpitem.displayName;
        if (type == 1 || type == 3 || type == 5 || type == 6 || type == 7) {
          if (
            // A40
            dname.indexOf("ブロワー時間") != -1 ||
            // LTV,ﾄﾘﾛｼﾞｰ
            dname.indexOf("アワーメータ") != -1 ||
            // HOT
            dname.indexOf("積算時間") != -1 ||
            // ﾄﾘﾛｼﾞｰEvo
            dname.indexOf("稼働時間　ブロア総稼働時間") != -1
          ) {
            // 処方値コピー対象外
            continue;
          }
        }

        if (type == 3 && dname.indexOf("予備回路破損・リーク セット") != -1) {
          // 処方値コピー対象外
            continue;
        }

        //A40Proコピー対象外
        if(type == 10) {
          if(
            dname.indexOf("ブロワー時間") != -1 ||
            dname.indexOf("予備回路") != -1 ||
            dname.indexOf("フィルタ") != -1 ||
            dname.indexOf("フィルタ残数") != -1
            ) {
              continue;
              }
        }

        //ASV
        if (type == this.MACHINE_TYPE_ASV) {
          //コピー対象外
          if (
            dname.indexOf("総運転時間") != -1 ||
            dname.indexOf("EPAP実測値") != -1 ||
            dname.indexOf("予備回路") != -1 ||
            dname.indexOf("フィルタ残数") != -1
          ) {
            continue;
          }
          // コードのみコピー
          if (
            dname == "加湿器品目コード" ||
            dname == "マスク品目コード" ||
            dname == "通信モジュール品目コード"
          ) {
            if (tmpitem.prescription) {
              let index = tmpitem.prescription.search(/\n/);
              if (index > -1) {
                tmpitem.dataValue = tmpitem.prescription.substring(0, index);
              } else {
                tmpitem.dataValue = tmpitem.prescription;
              }
            }
            continue;
          }
        }

        //LUISA
        if (type == 12) {
          if (
            dname.indexOf("運転時間") != -1 
          ) {
            continue;
          }
        }

        if (
          fname.indexOf("radio") == -1 &&
          dname.indexOf("特記事項") == -1 &&
          dname.indexOf("点検値変更理由") == -1 &&
          tmpitem.prescription != "-" &&
          tmpitem.prescription != "" &&
          tmpitem.prescription != null &&
          tmpitem.prescription != "null"
        ) {
          tmpitem.dataValue = tmpitem.prescription;
        }

        // let nval = tmpitem.value;
        // let index1 = parseInt(fname.split("_")[1]);
        // let index2 = parseInt(fname.split("_")[2]) - 1; // index2は1始まりのため-1する
        // this.data[index1].value[index2].value = tmpitem.dataValue;
      }
      //
      for (var index = 0; index < this.data.length; index++) {
        if (
          this.data[index].machineType == 7 ||
          this.data[index].machineType == 8 ||
          this.data[index].machineType == 11 ||
          this.data[index].machineType == 12 ||
          this.data[index].machineType == 17
        ) {
          // value for
          for (
            var subIndex = 0;
            subIndex < this.data[index].value.length;
            subIndex++
          ) {
            if (
              this.data[index].value[subIndex].type != "radio" &&
              this.data[index].subContentsValue.length > 0 &&
              this.data[index].subContentsValue.indexOf(
                String(this.data[index].value[subIndex].contentsType)
              ) != -1
            ) {
              if (
                this.data[index].value[subIndex].type == "char" &&
                this.data[index].value[subIndex].prescription != "-" &&
                this.data[index].value[subIndex].prescription != "" &&
                this.data[index].value[subIndex].prescription != null &&
                this.data[index].value[subIndex].prescription != "null"
              ) {
                this.data[index].value[subIndex].value = this.data[index].value[
                  subIndex
                ].prescription;
              } else if (
                this.data[index].value[subIndex].type == "sel" &&
                this.data[index].value[subIndex].prescription != null &&
                this.data[index].value[subIndex].prescription != "null"
              ) {
                this.data[index].value[subIndex].value = this.data[index].value[
                  subIndex
                ].prescription;
              }
            }
          }
        }
      }
      this.check();
      // Loading:END
      this.appVue.loadingEnd();
      // 成功メッセージ表示
      this.showErrorMessage("コピー完了しました。");
    },
    checkDisposablesOrder() {
      var rtnFlg = true;
      grid_loop: for (var item in this.data) {
        if (Object.keys(this.data[item]).indexOf("otherWork") == -1) {
          for (
            var i = 0;
            i < this.data[item].regularDisposablesProduct[0].shoumouList.length;
            i++
          ) {
            if (
              this.data[item].regularDisposablesProduct[0].shoumouList[i].regularDeliveryFlag == true &&
              this.data[item].regularDisposablesProduct[0].shoumouList[i].interval <= 1 &&
              !this.data[item].regularDisposablesProduct[0].shoumouList[i].deleteFlg
            ) {
              // 定期発送フラグがTrueの場合
              rtnFlg = false;
              break grid_loop;
            }
          }
        }
      }
      return rtnFlg;
    },
    machineReplaceDate(LTDAT, nextMaintenanceDate) {
      var leaseUp = this.parseDate2(LTDAT);
      var maintenance = this.parseDate2(nextMaintenanceDate);
      var rtnMsg = "";
      if (leaseUp && maintenance) {
        rtnMsg =
          "（リースアップ日：" +
          this.formatDate2(leaseUp) +
          "、メンテナンス日：" +
          this.formatDate2(maintenance) +
          "）";
      } else if (leaseUp) {
        rtnMsg = "（リースアップ日：" + this.formatDate2(leaseUp) + "）";
      } else if (maintenance) {
        rtnMsg = "（メンテナンス日：" + this.formatDate2(maintenance) + "）";
      }
      return rtnMsg;
    },
    openModal(index){
      this.targetHistoryList = this.preEditHistoryList[index]
      this.prescriptionHistoryModalActive = true
    },

    updateInspectionsStatus(inspection) {
      const patients = inspection.patients;
      let appointedNum = 0;
      let canceledNum = 0;
      let completedNum = 0;
      for (let patient of patients) {
        switch (patient.status) {
          case Inspection.INSPECTION_STATUS_MAP.appointment.code:
            // アポ実施済
            ++appointedNum;
            break;
          case Inspection.INSPECTION_STATUS_MAP.cancel.code:
            // 取り消し
            ++canceledNum;
            break;
          case Inspection.INSPECTION_STATUS_MAP.completed.code:
            // 点検完了
            ++completedNum;
            break;
        }
      }

      switch (patients.length) {
        case appointedNum:
          // アポ実施済
          inspection.status = Inspection.INSPECTION_STATUS_MAP.appointment.code;
          break;
        case canceledNum:
          // 取り消し
          inspection.status = Inspection.INSPECTION_STATUS_MAP.cancel.code;
          break;
        case completedNum:
        case completedNum + canceledNum:
          // 点検完了
          inspection.status = Inspection.INSPECTION_STATUS_MAP.completed.code;
          break;
        default:
          if (appointedNum) {
            // 点検中
            inspection.status = Inspection.INSPECTION_STATUS_MAP.underInspection.code;
          }
          break;
      }

      return;
    },

    returnToInspectionSearch: function() {
      // 点検一覧に戻る
      this.$router.push({
        name: "AppInspectionSearch",
        params: { searchConditions: this.$route.params.searchConditions }
      });
    },

    subSettingName: function(subscript, contentsType) {
      let name;
      let screenNo; // 画面順番
      let prescriptionNo; // 処方値設定名称

      switch (contentsType) {
        case 2:
          screenNo = 121;
          prescriptionNo = 122;
          break;

        case 3:
          screenNo = 186;
          prescriptionNo = 187;
          break;

        case 4:
          screenNo = 251;
          prescriptionNo = 252;
          break;

        case 5:
          screenNo = 316;
          prescriptionNo = 317;
          break;
      }

      // 画面順番
      let screenItem = this.data[subscript].value.find((item) =>
        item.displayOrder == screenNo && item.contentsType == contentsType);
      if (screenItem) {
        name = "画面順番";
        if (screenItem.value) {
          name += screenItem.value;
        } else if (screenItem.prescription) {
          name += screenItem.prescription;
        } else {
          name = "―"
        }
        name += "："
      } else {
        name = "―：";
      }

      // 処方値設定名称
      let prescriptionItem = this.data[subscript].value.find((item) =>
        item.displayOrder == prescriptionNo && item.contentsType == contentsType);
      if (prescriptionItem) {
        let prescriptionKey = prescriptionItem.value ? prescriptionItem.value : prescriptionItem.prescription;
        prescriptionItem = prescriptionItem.displayValue.find((item) => item.key == prescriptionKey);
        name += prescriptionItem ? prescriptionItem.value : "―";
      } else {
        name += "―";
      }

      return name;
    },

    header: function(inspectionItem, content){
      let header;
      if (content.contentsType == 1) {
        header = inspectionUtil.INSPECTION_HEADER[inspectionItem.machineType][content.contentsType][content.displayOrder];
      }

      return header;
    },

    getProductInfo: function(productCode) {
      let productInfo = this.productMaster.find(product => product.productCode == productCode);
      return productInfo ? productInfo : "";
    },

    getMainSettingTrilogyEvo: function (mainSetting, contentsType) {
      const mainSettingTrilogyEvo = inspectionUtil.getMainSettingTrilogyEvo(mainSetting, contentsType);
      return mainSettingTrilogyEvo;
    },
  },
  data() {
    // 緯度・経度の取得タイムアウト(60秒)
    var timeOut = 60000;
    var data = {};
    var items = [];
    var initData = [];
    var productMaster = [];
    var target;
    var mode = {};
    var hotTypeRange = [];
    var inspectionDate = new Date();
    this.getProductList(productMaster);
    var appointmentCode = this.$route.params["appointmentCode"];
    var staffCode = this.$route.params["staffCode"];
    var staffName = this.$route.params["staffName"];
    var patientName = this.$route.params["patientName"];
    var patientCode = this.$route.params["patientCode"];
    var officeName = this.$route.params["officeName"];
    var officeCode = this.$route.params["officeCode"];
    var searchConditions = this.$route.params["searchConditions"];
    var inspectionStatus = this.$route.params["status"];
    var compleateFlg = false;
    var messageFlg = true;
    var checkList = [];
    var otherWork;
    sessionStorage.getItem("officeMaster");
    // 点検指示内容
    var inspectionOrderList = [
      { key: 0, value: "設置" },
      { key: 1, value: "定期点検" },
      { key: 2, value: "メンテナンス" },
      { key: 4, value: "緊急対応" },
      { key: 3, value: "その他" },
      { key: 99, value: "" }
    ];
    // HOTの点検項目種別判別用(2：設置型、3：ゴーミニ、4：ゴー)
    var hotIndividual = [2, 3, 4];
    // HOTの機器種別判別用
    // R1133943：ｼﾝﾌﾟﾘｰｺﾞｰﾐﾆ標準ﾊﾞｯﾃﾘｾｯﾄﾚﾝﾀﾙ
    // R1134819 ：ｼﾝﾌﾟﾘｰｺﾞｰﾐﾆ用標準ﾊﾞｯﾃﾘﾚﾝﾀﾙobs
    // R1098833: シンプリーゴー_レンタル
    var portableTypeCode = { R1134819: 2, R1133943: 2, R1098833: 3 };
    // ｼﾝﾌﾟﾘｰｺﾞｰﾐﾆ、ｼﾝﾌﾟﾘｰｺﾞｰ共通項目
    var portableCommonOrder = [55, 56, 57, 58];
    // HOTの点検項目：シリアルNo
    var inspectionItemSerial = [
      "",
      "シンプリーゴーミニシリアルNO",
      "シンプリーゴーシリアルNO"
    ];
    var serialDisplayNameList = [
      "2ネット2ハブ（ｵｷｼｼﾞｪﾝｽﾃｰｼｮﾝ5L用）　S/N",
      "APM-100　S/N",
      "オプション拡張バッテリー　シリアルNO",
      "シンプリーゴー予備バッテリシリアルNO",
      "リモコン　S/N",
      "予備バッテリ　着脱式バッテリ(レンタルバッテリー)　S/N",
      "内部着脱式バッテリSN",
      "加湿器のSN",
      "同調装置機種　シリアルNO",
      "外部バッテリ　S/N",
      "外部バッテリー S/N",
      "標準バッテリ（ｼﾝﾌﾟﾘｰｺﾞｰﾐﾆ）　S/N",
      "着脱式バッテリ　 SN",
      "調整装置機種　シリアルNO",
      "購入バッテリ　着脱式バッテリ(購入バッテリー)　S/N",
      "リチウムイオンバッテリ　S/N",
      "ﾊﾞｯﾃﾘｰﾓｼﾞｭｰﾙ　 SN",
      "ボンベ切り替えｷｯﾄ　S/N",
      "加湿器シリアル1(Prog1)",
      "加湿器シリアル2(Prog1)",
      "加湿器（品目コード＋品目テキスト)",
      "外部バッテリー1",
      "外部バッテリー2",
      "加湿器シリアル",
      "外部バッテリー1シリアル",
      "外部バッテリー2シリアル",
      "酸素濃縮器 シリアル",
      "着脱式バッテリ　シリアル番号",
      "予備の着脱式バッテリ　シリアル番号",
      "通信機器シリアル番号",
    ];
    // カフアシスト：アドバンスド自動選択時のみ活性項目
    var cuffAssistAdvancedItems = {
      治療前呼吸: 11,
      治療前圧力: 12,
      治療前フロー: 13,
      治療前吸気時間: 14,
      治療前一時停止時間: 15,
      咳回数: 16,
      サイクル数: 17,
      治療後呼吸: 18
    };
    //カフアシスト2: パーカッサーモードのみ非活性項目
    var cuffAssist2Items = {
      呼気圧: 3,
      吸気流量: 4,
      吸気時間: 5,
      呼気時間: 6,
      一時停止時間: 7,
      "Cough-Sync": 8,
      "Cough-Syncレベル": 9,
      オシレーション: 10,
      オシレーション周波数: 11,
      オシレーション振幅圧力: 12,
    }
    //カフアシスト2: 自動、手動モードのみ非活性項目
    var cuffAssist2NotPercussorItems = {
      "パーカッサー振動数":13,
      "パーカッサー動作時間(分)": 14,
      "パーカッサー動作時間(秒)": 15,
      "I:E Ratio": 16
    }
    // プリズマ用品目コード⇒品目名設定項目定義
    var prismaAnotherInputItems = {
      "加湿器1（品目コード）(Prog1)": "加湿器1（品目テキスト）(Prog1)",
      "加湿器2（品目コード）(Prog1)": "加湿器2（品目テキスト）(Prog1)"
    };
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var appVue = this.$root.$children[0];
    const MACHINE_TYPE_ASV = 13;
    let humidifierItemName;
    const PERMISSION_DENIED = 1; // 位置情報取得拒否
    return {
      data,
      hotTypeRange,
      hotIndividual,
      inspectionItemSerial,
      portableTypeCode,
      portableCommonOrder,
      inspectionOrderList,
      totalResult: true,
      productMaster,
      productNumber: "",
      oldSerialNumber: "",
      inspectionDate,
      machinReplaceindex: null,
      ReplaceCancelindex: null,
      isComponentModalActive: false,
      isRegularDisposablesOrderModalActive: false,
      isSubContentsModalActive: false,
      isSerialReaderModalActive: false,
      appointmentCode,
      staffCode,
      staffName,
      patientCode,
      patientName,
      officeName,
      officeCode,
      items,
      signature: "",
      alternativeWriting: "",
      alternativeWritingReason: "",
      startLatitude: null,
      startLongitude: null,
      endLatitude: null,
      endLongitude: null,
      initData,
      compleateFlg,
      messageFlg,
      searchConditions,
      isSubContentsChangeModalActive: false,
      targetContents: [],
      target,
      mode,
      serialInputModalActive: {
        flg: false,
        index: 0,
        list: {},
        serialType: 0,
        dName: "",
        dNumber: "",
        machineType: ""
      },
      checkList,
      otherWork,
      isSerialPuroductReaderModalActive: false,
      serialPuroductList: [],
      serialPuroductListIndex: 0,
      targetContentsType: 0,
      serialDisplayNameList,
      timeOut,
      targetPatientCode: "",
      targetPatientName: "",
      teikishoumouData: {
        disposablesByDevice: "",
        interval: null,
        index: null
      },
      timeOut,
      signatureFlag: false,
      signData: "",
      alternative: false,
      alternativeReason: "",
      userInfo,
      appVue,
      cuffAssistAdvancedItems,
      cuffAssist2Items,
      cuffAssist2NotPercussorItems,
      prismaAnotherInputItems,
      prescriptionHistoryModalActive:false,
      preEditHistoryList: [],
      lastPreEditHistory: {},
      targetHistoryList: [],
      EvoWarningflag: false,
      monthNames: datetime.MONTHS,
      dayNames: datetime.DAYS,
      trustStaff: "",
      MACHINE_TYPE_ASV,
      humidifierItemName,
      pause: false,
      inspectionStatus,
      PERMISSION_DENIED,
      trilogyEvoMainSetting: inspectionUtil.TRILOGY_EVO_SETTING,
      trilogyEvoSetting: inspectionUtil.TRILOGY_EVO_SETTING.slice(1),
    };
  },
  components: {
    "sign-modal": SignTemplate,
    "regular-disposables-modal": RegularDisposablesTemplate,
    "sub-inspection-modal": InspectionExecuteSubTemplate,
    "reader-modal": serialScannerTemplate,
    "serialProductReader-modal": serialProductScannerTemplate,
    "heading-comp": HeadingCompTemplate,
    "char-comp": CharCompTemplate,
    "sel-comp": SelCompTemplate,
    "radio-comp": RadioCompTemplate,
    "subContentsChange-Modal": subContentsChangeModal,
    "serialInput-modal": serialInputModal,
    "nextDirection-comp": nextDirectionCompTemplate,
    "otherWork-comp": otherWorkCompTemplate,
    "text-items": TextItemsTemplate,
    "inspection-span-items": InspectionSpanItemsTemplate,
    "prescription-history-modal": prescriptionHistoryModal
  },
  async mounted() {
    // 点検開始時:GPSでの緯度経度取得
    // see@ https://www.tutorialsplane.com/vue-js-get-geolocation/
    if (navigator.geolocation && !this.$route.params.isDealer) {
      // Promiseで結果を待ち受ける
      try {
        // Promiseで結果を待ち受ける
        await this.getStartPosition();
      } catch (err) {
        console.log(err);

        // 取得拒否：警告あり、点検不可
        if (err == this.PERMISSION_DENIED) {
          this.showErrorMessage(
            "位置情報の取得に失敗しました。<br>設定を確認して、再度実行してください。"
          );
          // 予約一覧画面への遷移処理
          this.$router.push({
            name: "AppAppointmentSearch",
            params: { searchConditions: this.searchConditions }
          });
        }
        // 以下、取得拒否以外のエラー処理
        // 情報必須：警告あり、点検継続
        if (this.$route.params.locationRequired) {
          this.showErrorMessage(
            "位置情報の取得に失敗しました。"
          );
        }
      }
    } else {
    }
    var excuteApi = this.startInspectionPOST;
    var successCallBack = this.startInspectionPOSTSuccess;
    var errorCallBack = this.startInspectionPOSTError;
    // WebAPI Call
    this.apiCall(excuteApi, successCallBack, errorCallBack);
  },
  created: function() {
    this.$validator.extend("validationCheck", {
      getMessage: field => `入力内容に誤りがあります。再度入力してください。`,
      validate: (value, indexArray) => {
        var subscript = indexArray[0];
        var index = indexArray[1];
        var name = indexArray[2];
        var ret = false;
        var validationRule = this.data[subscript].value[index].validationRule;
        // 入力値チェック
        var regex = RegExp(validationRule);
        if (regex.test(value)) {
          ret = true;
        }
        return ret;
      }
    });
    this.$validator.extend("requiredCheck", {
      getMessage: field => `点検値は必須項目です`,
      validate: (value, valueList) => {
        var ret = true;
        // 入力値チェック
        if (valueList[0] != null) {
          valueList[0] = valueList[0] + "".replace(" ", "").replace("　", "");
        }
        if (valueList[0] == null || valueList[0] == "") {
          ret = false;
        }
        return ret;
      }
    });
    this.$validator.extend("minValue_1", {
      getMessage: field => `点検期間は1以上で入力してください`,
      validate: value => {
        var ret = true;
        // 入力値チェック
        if (Number(value) < 1 || Math.sign(value) == -1) {
          ret = false;
        }
        return ret;
      }
    });
    this.$validator.extend("checkProduct", {
      getMessage: field =>
        `入力された品目コードは品目マスタに存在しません。再度入力してください。`,
      validate: value => {
        var ret = true;
        // 入力値チェック
        var productElement = this.productMaster.find(
          v => v.productCode == value
        );
        if (!productElement) {
          ret = false;
        }
        return ret;
      }
    });
  },
  filters: {
    productFilter: function(value, productMaster) {
      if (!value) {
        return "";
      }

      var productElement = productMaster.find(v => v.productCode == value);
      if (productElement) {
        return productElement.productName;
      }
      return "";
    }
  }
};
</script>

<style lang="scss">
.header {
  border-bottom: double;
}
.row {
  border-bottom: 1px solid;
}
canvas.drawingBuffer {
  position: absolute;
  left: 0;
}
.column.is-checkBoxCol {
  width: 30px;
  -webkit-box-flex: 0;
  -ms-flex: none;
  flex: none;
}
.requiredCheckBox {
  width: 20px;
}
.requiredText {
  position: absolute;
  text-indent: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/AppInspectionExecute.vue